(function() {
  'use strict';

  angular
    .module('wargos', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ngFileUpload',
      'ngMaterial',
      'ngMdIcons',
      'md.data.table',
      'ng-webcam',
      'ja.qr'
    ])
    .filter('unsafe', function($sce) { return $sce.trustAsHtml; });
 ;
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AtteDetailSetStatesUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    LocalError,
    State
  ) {
    var area_id = $state.params.area_id;
    var state_id = $state.params.state_id;

    State.get({
      _id: state_id
    }, function(res) {
      $scope.item = res;
    });

    $scope.update_state = function(item) {
      item.$update({
          _id: item._id
      }, function(res) {
        $state.go('attendance.detail.settings.states.main');
        $scope.load_states();
      }, LocalError.request);
    }

    $scope.remove_state = function(item) {
      item.$remove({
        _id: item._id
      }, function(res) {
        $state.go('attendance.detail.settings.states.main');
        $scope.load_states();
      }, LocalError.request);
    }
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AtteDetailSetStatesMainController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    LocalError,
    State
  ) {
    var area_id = $state.params.area_id;
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AtteDetailSetStatesCreateController', controller);

    /** @ngInject */
    function controller(
      $scope,
      $state,
      LocalError,
      State
    ) {
      var area_id = $state.params.area_id;

      $scope.item = {
        order: 0
      };

      $scope.create_state = function(item) {
        item.area_id = area_id;
        State.save(item, function(response) {
          $scope.states.unshift(response);
          $state.go('attendance.detail.settings.states.main');
        }, LocalError.request);
      }

      $scope.load = function() {
        State.query({
          area_id: area_id
        }, function(res) {
          var max = 0;
          res.forEach(function(state) {
            if (state.order > max) {
              max = state.order;
            }
          });
          $scope.item.order = ++max;
        }, LocalError.request);
      };
      $scope.load();
    }
  })();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceReportsPiefulController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Reports
  ) {
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;
    var area_id = $state.params.area_id;

    Reports.att_groups_report({
      room_id: room_id,
      event_id: event_id
    }, function(res) {
      $scope.draw(res);
    });

    $scope.draw = function(data) {
      var categories = [];
      var ontime = [];
      var faltas = [];
      data.forEach(function(item) {
        var group = item.group;
        if (group) {
          categories.push(group.name);
        }
        var porcentage = 0;
        if (item.current.length != 0) {
            porcentage = (item.current.length * 100) / item.total;
        }
        ontime.push(porcentage);
        faltas.push(100 - porcentage);
      });
      categories.push("Sin grupo");
      $('#container').highcharts({
          chart: {
              type: 'bar'
          },
          title: {
              text: 'Asistencia por grupos'
          },
          xAxis: {
              categories: categories
          },
          yAxis: {
              min: 0,
              title: {
                  text: 'Porcentaje al 100%'
              }
          },
          legend: {
              reversed: true
          },
          plotOptions: {
              series: {
                  stacking: 'normal'
              }
          },
          series: [ {
              name: 'Faltantes',
              data: faltas,
              color: '#ececec'
          },
          {
              name: 'Presentes',
              data: ontime,
              color: '#47a447'
          }]
      });
    }
  };
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceReportsDonutController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Store,
    Event,
    Participant,
    State,
    Auth,
    AttendanceAtts,
    Toast,
    LocalError,
    Reports
  ) {
    console.log('init grupos report');
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;
    var area_id = $state.params.area_id;
    var groups = [];

    var getGroupId = function(groupId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].group._id == groupId) {
          return i + 1;
        }
      }
    }

    var getGroup = function(groupId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].group._id == groupId) {
          return groups[i];
        }
      }
    }

    var existId = function(list, id) {
      var result = false;
      list.forEach(function(item) {
        if (id == item) {
          result = true;
        }
      });
      return result;
    }

    var changeValues = function(group) {
      return [
        // {
        //     name: 'Faltantes',
        //     data: group.current.length,
        //     color: '#ececec'
        // },
        // {
        //     name: 'Presentes',
        //     data: group.total - group.current.length,
        //     color: '#47a447'
        // }
          ['Presente', group.current.length],
          ['Falta', group.total - group.current.length]
      ];
    }

    Reports.att_groups_report({
      room_id: room_id,
      event_id: event_id
    }, function(response) {
      groups = response;
      response.forEach(function(item) {
        $scope.draw(item);
      });
    });

    $scope.draw = function(item) {
      var data = {
        id: getGroupId(item.group._id),
        title: item.group.name,
        data: changeValues(item)
      };
      $scope.draw_donut(data);
    }

    $scope.draw_donut = function(data) {
      Highcharts.setOptions({ colors: ['#47a447', '#ececec'] });
      $('#' + data.id).highcharts({
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: 0,
              plotShadow: false
          },
          title: {
              text: '<b>' + data.title +'</b>',
              align: 'center',
              verticalAlign: 'middle',
              y: 60
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
              pie: {
                  dataLabels: {
                      enabled: true,
                      distance: -50,
                      style: {
                          fontWeight: 'bold',
                          color: 'white',
                          textShadow: '0px 1px 2px black'
                      }
                  },
                  startAngle: -90,
                  endAngle: 90,
                  center: ['50%', '75%'],
                  size: '110%'
              }
          },
          series: [{
              type: 'pie',
              name: 'Asistencia',
              innerSize: '50%',
              data: data.data
          }]
      });
    };

    $scope.update_donut = function(item) {
      var id = getGroupId(item.group._id);
      var chart = $('#' + id).highcharts();
      chart.series[0].setData(changeValues(item), false);
      chart.redraw();
    }

    // socket
    function loadjscssfile(filename, callback) {
      if (Global.socket) {
        return;
      }
      var fileref = document.createElement('script');
      fileref.setAttribute("type", "text/javascript");
      fileref.setAttribute("src", filename);
      fileref.onload = callback;

      if (typeof fileref != "undefined") {
        document.getElementsByTagName("head")[0].appendChild(fileref);
      }
    }

    var socket_module = {};
    var create = function(module) {
      var socket = io(Global.PATH);
      module.version = "v0.0.1";
      module.emit = function (msg) {
        console.info('sent:', msg);
        socket.emit('chat', msg);
      };
      module.on = function(callback) {
        socket.on('atts', function(msg) {
          callback(msg);
        });
      };
    };

    // /socket.io/socket.io.js
    // loadjscssfile(Global.PATH + '/socket.io/socket.io.js', function() {
    //   create(socket_module);
    //   socket_module.on(function(message) {
    //     $scope.$apply(function() {
    //       // here is my problem
    //       // the ng-if don't react when $scope.activated is changed
    //       if (event_id == message.event_id) {
    //         message.participant.groups.forEach(function(group_id) {
    //           var group = getGroup(group_id);
    //           if (!group) {
    //             return;
    //           }
    //           if (!existId(group.current, message.participant._id)) {
    //             group.current.push(message.participant._id);
    //             $scope.update_donut(group);
    //           } else {
    //             console.log('participant registered');
    //           }
    //         });
    //         var isAloneParticipant = true;
    //         message.participant.groups.forEach(function(group_id) {
    //           if (getGroup(group_id)) {
    //             isAloneParticipant = false;
    //           }
    //         });
    //         if (isAloneParticipant) {
    //           var group = getGroup(null);
    //           if (!existId(group.current, message.participant._id)) {
    //             group.current.push(message.participant._id);
    //             $scope.update_donut(group);
    //           } else {
    //             console.log('participant registered');
    //           }
    //         }
    //       } else {
    //         console.log('data from other event');
    //       }
    //     });
    //   });
    // });
  };
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceReportsArriveController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    LocalError,
    Reports
  ) {
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;
    var area_id = $state.params.area_id;

    // pagination
    $scope.query = {
      event_id: event_id,
      limit: 15,
      page: 1
    };

    function success(response) {
      $scope.atts = response;
      var participants = [];
      response.forEach(function(item) {
        participants.push(item.participant);
      });
      $scope.updateParticipants(participants);
      $scope.participants = participants;
    }

    $scope.getParticipants = function() {
      $scope.promise = Reports.arrive($scope.query, success).$promise;
    };
    // end pagination

    $scope.updateParticipants = function(participants) {
      for (var i = 0; i < participants.length; i++) {
        $scope.loadParticipantAttendance(participants[i]);
      };
    };

    $scope.loadParticipantAttendance = function(participant) {
      for (var i = 0; i < $scope.atts.length; i++) {
        if ($scope.atts[i].participant._id == participant._id) {
          participant.att = $scope.atts[i];
          participant.color = $scope.get_color($scope.atts[i]);
        };
      };
    };

    $scope.get_color = function(isPunctual) {
      var date = new Date(isPunctual.created);
      var eventDate = new Date($scope.event.start);
      eventDate.setMinutes(eventDate.getMinutes() + $scope.event.slackTime);
      if (eventDate > date) {
        return "#47a447";
      } else {
        return "#ed9c28";
      }
    }

    $scope.getParticipants();
  };
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomPeopleMainController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Config,
    HelperDetailRoute,
    HelperParticipant,
    Participant,
    Group,
    LocalError
  ) {
    HelperParticipant.init($scope);

    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.order = Config.loadOrder();
    $scope.search = {
      alive: false
    };

    // helper routes
    $scope.goToParticipant = HelperDetailRoute.goToParticipant;

    // participants
    $scope.loadParticipants = HelperParticipant.loadParticipants;

    $scope.createParticipant = function() {
      $state.go('attendance.detail.room.people.create', {
        area_id: area_id,
        room_id: room_id
      });
    };

    // groups
    $scope.select = {
      group: null
    };

    Group.query({
      area_id: area_id,
      room_id: room_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);

    $scope.discartGroup = function() {
      $scope.select.group = null;
      delete $scope.query.groups;
      $scope.getParticipants();
    }

    $scope.selectGroup = function() {
      var group_id = $scope.select.group;
      $scope.query.groups = group_id;
      $scope.getParticipants();
    };

    // options
    $scope.goToOptions = function() {
      $state.go('attendance.detail.room.options', {
        area_id: area_id,
        room_id: room_id
      });
    };

    // pagination
    $scope.query = {
      area_id: area_id,
      rooms: room_id,
      limit: 21,
      page: 1
    };

    function success(participants) {
      $scope.participants = participants;
    };

    $scope.getParticipants = function() {
      $scope.query.order = Config.loadOrder();
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };

    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    }

    $scope.change_order = function(order) {
      $scope.order = order;
      Config.saveOrder(order);
      $scope.getParticipants();
    }

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    }

    $scope.getParticipants();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomPeopleCreateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $window,
    Participant,
    LocalError,
    UploadImages,
    UUID
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;

    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;
    // $scope.config = {
    //   viewerWidth: 400,
    //   viewerHeight: 400,
    //   countdown: 3
    // };
    // $scope.camError = function(err) {
    //   console.log(err);
    // }
    // $scope.camOnLoad = function(err) {
    //   console.log(err);
    // }
    // $scope.camOnLive = function(err) {
    //   console.log(err);
    // }
    // $scope.camOnCaptureProgress = function(err) {
    //   console.log(err);
    // }
    // $scope.camOnCaptureComplete = function(err) {
    //   console.log(err);
    // }

    //$scope.$broadcast('ngWebcam_capture');
    //$scope.$broadcast('ngWebcam_on');

    $scope.item = {
      area_id: area_id,
      uid: UUID.next(),
      first_name: '',
      last_name: '',
      cel: '',
      email: '',
      image: null,
      ci: null,
      address: null,
      rooms: [room_id]
    };

    $scope.create_participant = function(item) {
      Participant.save(item, function(response) {
        $state.go('attendance.detail.room.people.main', {
          area_id: area_id,
          room_id: room_id
        });
      }, LocalError.request);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailRoomAttUniqueController', controller);

  /** @ngInject */
  function controller(
    $scope,
    Global,
    $state,
    Event,
    Participant,
    AttendanceAtts,
    Auth,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;
    $scope.current_participant = null;
    $scope.check_participants = [];
    $scope.failed_codes = [];

    Event.get({
      _id: event_id
    }, function(res) {
      $scope.event = res;
    }, LocalError.request);
    $scope.changeUserAttendanceReportsState = function(item) {
      if (!item.code) {
        LocalError.display("codigo en blanco");
        return;
      }
      var participant = $scope.searchParticipant(item);
      if (participant) {
         if (!event_id) {
           Toast.show('Seleccione un evento');
           return;
         };
         if (!participant._id) {
           throw new Error('participant in undefined');
         };
         AttendanceAtts.save({
           area_id: area_id,
           room_id: room_id,
           event_id: event_id
         }, {
           participant_id: participant._id
         }, function(res) {
           participant.att = res;
           participant.color = $scope.getColor(res);
           $scope.check_participants.unshift(participant);
           $scope.current_participant = participant;
           $scope.removeLastItem();
         }, LocalError.request);
      } else {
         item.index = $scope.count;
         $scope.failed_codes.unshift(item.code);
      }
      $scope.clean();
    }

    $scope.clean = function() {
      $scope.item.code = '';
    }

    Participant.query({
      area_id: area_id,
      rooms: room_id
    }, function(response) {
      $scope.participants = response;
      // $scope.load_attendance_Reportsendance();
    });

    $scope.load_attendance_Reportsendance = function() {
      AttendanceAtts.query({room_id: $state.params.room_id}, function(response) {
        for (var i = 0; i < response.length; i++) {
          $scope.load_participant_attendance_reportsendance(response[i]);
        };
      });
    };

    $scope.load_participant_attendance_reportsendance = function(att) {
      for (var i = 0; i < $scope.participants.length; i++) {
        if ($scope.participants[i].id == att.participantId) {
          $scope.participants[i].att = att;
        };
      };
    };

    $scope.changeStatus = function(participant, state, callback) {
      if (!participant.id) {
        throw new Error('participant in undefined');
      };
      if (!state.id) {
        throw new Error('state in undefined');
      };
      if (participant.att) {
        participant.att.stateId = state.id;
        participant.att.$update({id: participant.att.id}, function(response) {
          callback(response, false);
        });
        return;
      }
      var itemParams = {
        eventId: Global.event.id,
        participantId: participant.id,
        stateId: state.id,
        room_id: $state.params.room_id
      };
      AttendanceAtts.save(itemParams, function(response) {
        $scope.load_participant_attendance_reportsendance(response);
        callback(response, true);
      });
    }

    // local functions
    $scope.searchParticipant = function(generator) {
      var result = null;
      $scope.participants.forEach(function(item) {
        var code = String(generator.code);
        if (item.uid == generator.code) {
          //TODO: break the loop
          result = item;
        }
      });
      return result;
    }

    $scope.removeLastItem = function() {
      if ($scope.check_participants.length > 15) {
        $scope.check_participants.pop();
      }
    }

    $scope.updateCheckParticipantList = function(participant) {
      if (!participant) {
        throw new Error('participant is not defined');
      }
      for (var index in $scope.check_participants) {
        if ($scope.check_participants[index].id == participant.id) {
            $scope.check_participants.splice(index, 1);
            break;
        }
      }
      $scope.check_participants.unshift(participant);
    }

    $scope.getColor = function(isPunctual) {
      var date = new Date(isPunctual.created);
      var eventDate = new Date($scope.event.start);
      eventDate.setMinutes(eventDate.getMinutes() + $scope.event.slackTime);
      if (eventDate > date) {
        return "#47a447";
      } else {
        return "#ed9c28";
      }
    }
  };

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailRoomAttOnlyoneController', controller);

  /** @ngInject */
  function controller($scope,
    $state,
    HelperEvent,
    $mdDialog,
    Config,
    Event,
    Participant,
    State,
    AttendanceAtts,
    Note,
    Alibi,
    Toast,
    Group,
    LocalError
  ) {
    HelperEvent.init($scope);
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.order = Config.loadOrder();

    $scope.event = null;
    $scope.events = [];
    $scope.states = [];
    $scope.participants = [];

    $scope.atts = [];
    $scope.notes = [];
    $scope.alibis = [];

    // pagination
    $scope.query = {
      area_id: area_id,
      rooms: room_id,
      limit: 20,
      page: 1
    };

    $scope.setEvent = function(current_event) {
      $scope.event = current_event;
    };

    $scope.loadMoreEvents = function() {
      HelperEvent.loadMoreEvents(room_id);
    };

    $scope.createEvent = function() {
      HelperEvent.createEvent(room_id);
    };

    HelperEvent.loadEvents(room_id);

    $scope.selectEvent = function(event) {
      if ($scope.event) {
        $scope.event.selected = false;
      }
      event.selected = true;
      $scope.event = event;
      $scope.loadAttendance();
      $scope.loadNotes();
      $scope.loadAlibis();
    }

    $scope.go_to_accessibility = function() {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      $state.go('accessibility', {
        area_id: area_id,
        room_id: room_id,
        event_id: $scope.event._id
      });
    }

    $scope.go_to_unique = function() {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      $state.go('attendance.detail.room.unique', {
        area_id: area_id,
        room_id: room_id,
        event_id: $scope.event._id
      });
    }
    $scope.go_to_report = function() {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      $state.go('attendance.detail.room.reports.arrive', {
        area_id: area_id,
        room_id: room_id,
        event_id: $scope.event._id
      });
    }

    $scope.goToEvent = function(event) {
      $mdDialog.show({
        controller: DialogEventUpdateController,
        templateUrl: 'app/attendance/detail/room/att/onlyone/event-update.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
           event: event
        }
      })
      .then(function(answer) {
        HelperEvent.loadEvents(room_id);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    }

    $scope.goToTakeAttendance = function(route) {
      if ($scope.event) {
        $state.go(route, {
          event_id: $scope.event._id
        });
      } else {
        alert('seleccione un evento');
      }
    }

    $scope.openEventMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    $scope.generate_qr = function(event, index, ev) {
      $scope.show_event_dialog(ev, event, function(item) {
      });
    }

    $scope.show_event_dialog = function(ev, item, cb) {
      $mdDialog.show({
        controller: DialogEventController,
        templateUrl: 'app/attendance/detail/room/att/onlyone/qr-generator.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        escapeToClose: false,
        locals: {
           item: item
        }
      })
      .then(function(answer) {
        cb(answer);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    };

    // states
    State.query_order_by({
      area_id: area_id
    }, function(response) {
      $scope.states = response;
    });

    $scope.changeStatus = function(participant, index) {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      if (!participant._id) {
        throw new Error('participant in undefined');
      };
      participant.isloading = true;
      AttendanceAtts.save({
        area_id: area_id,
        room_id: room_id,
        event_id: $scope.event._id
      }, {
        participant_id: participant._id
      }, function(response) {
        participant.isloading = false;
        participant.att = response;
        participant.color = $scope.get_color(response);
        $scope.atts.push(response);
      }, LocalError.request);
    }

    $scope.add_message = function(participant, index, ev) {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      if (!participant._id) {
        throw new Error('participant in undefined');
      };
      Note.find_note({
        event_id: $scope.event._id,
        area_id: area_id,
        room_id: room_id,
        participant_id: participant._id
      }, function(response) {
          if (response.length > 0) {
            var note = response[0];
            $scope.show_note_dialog(ev, note, function(item) {
              item.$update(function() {
                Toast.show('El mensage se guardo correctamente');
              });
            });
          } else {
            $scope.show_note_dialog(ev, {}, function(item) {
              Note.save({
                event_id: $scope.event._id,
                area_id: area_id,
                room_id: room_id
              }, {
                text: item.text,
                participant_id: participant._id
              }, function(response) {
                $scope.notes.push(response);
                participant.note = response;
                Toast.show('El mensage se guardo correctamente');
              }, LocalError.request);
            });
          }
      }, LocalError.request);
    }

    $scope.take_alibi = function(participant, state, index) {
      if (!$scope.event) {
        Toast.show('Seleccione un evento');
        return;
      };
      if (!participant._id) {
        throw new Error('participant in undefined');
      };
      Alibi.find_alibi({
        event_id: $scope.event._id,
        area_id: area_id,
        room_id: room_id,
        participant_id: participant._id
      }, function(response) {
          if (response.length > 0) {
            var alibi = response[0];
            alibi.state_id = state._id;
            alibi.$update(function() {
              participant.alibi = null;
              participant.alibi = $scope.getState(state._id);
              Toast.show('El incidente se guardo correctamente');
            });
          } else {
            Alibi.save({
              event_id: $scope.event._id,
              area_id: area_id,
              room_id: room_id
            }, {
              state_id: state._id,
              participant_id: participant._id
            }, function(response) {
              $scope.alibis.push(response);
              $scope.loadParticipantAlibis(participant);
              Toast.show('El incidente se guardo correctamente');
            }, LocalError.request);
          }
      }, LocalError.request);
    }

    $scope.getState = function(stateId) {
      var userState = null;
      $scope.states.forEach(function(state) {
        if (state._id == stateId) {
          userState = state;
        }
      });
      if (!userState) {
        throw new Error('theis no state to this participants');
      }
      return userState;
    }

    $scope.get_color = function(isPunctual) {
      var date = new Date(isPunctual.created);
      var eventDate = new Date($scope.event.start);
      eventDate.setMinutes(eventDate.getMinutes() + $scope.event.slackTime);
      if (eventDate > date) {
        return "#47a447";
      } else {
        return "#ed9c28";
      }
    }

    $scope.loadAttendance = function() {
      AttendanceAtts.query({
          event_id: $scope.event._id
        }, function(response) {
          $scope.atts = response;
          $scope.updateParticipants($scope.participants);
      });
    };

    $scope.loadNotes = function() {
      Note.query({
          event_id: $scope.event._id
        }, function(response) {
          $scope.notes = response;
          $scope.updateNotes($scope.participants);
      });
    };

    $scope.loadAlibis = function() {
      Alibi.query({
          event_id: $scope.event._id
        }, function(response) {
          $scope.alibis = response;
          $scope.updateAlibis($scope.participants);
      });
    };

    $scope.updateParticipants = function(participants) {
      for (var i = 0; i < participants.length; i++) {
        participants[i].att = null;
        participants[i].color = null;
        $scope.loadParticipantAttendance(participants[i]);
      };
    };

    $scope.loadParticipantAttendance = function(participant) {
      for (var i = 0; i < $scope.atts.length; i++) {
        if ($scope.atts[i].participant_id == participant._id) {
          participant.att = $scope.atts[i];
          participant.color = $scope.get_color($scope.atts[i]);
        };
      };
    };

    $scope.updateNotes = function(participants) {
      for (var i = 0; i < participants.length; i++) {
        participants[i].note = null;
        $scope.loadParticipantNotes(participants[i]);
      };
    };

    $scope.loadParticipantNotes = function(participant) {
      for (var i = 0; i < $scope.notes.length; i++) {
        if ($scope.notes[i].participant_id == participant._id) {
          participant.note = $scope.notes[i];
        };
      };
    };

    $scope.updateAlibis = function(participants) {
      for (var i = 0; i < participants.length; i++) {
        participants[i].alibi = null;
        $scope.loadParticipantAlibis(participants[i]);
      };
    };

    $scope.loadParticipantAlibis = function(participant) {
      for (var i = 0; i < $scope.alibis.length; i++) {
        if ($scope.alibis[i].participant_id == participant._id) {
          participant.alibi = $scope.getState($scope.alibis[i].state_id);
        };
      };
    };

    $scope.remove_attendance_events = function(participant) {
      participant.att.$remove(function(response) {
          participant.att = null;
          participant.color = null;
      });
    };

    function success(participants) {
      $scope.updateParticipants(participants);
      $scope.updateNotes(participants);
      $scope.updateAlibis(participants);
      $scope.participants = participants;
    }

    $scope.getParticipants = function() {
      $scope.query.order = Config.loadOrder();
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };
    // end pagination

    $scope.getParticipants();

    $scope.show_note_dialog = function(ev, item, cb) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: 'app/attendance/messages/index.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false, // Only for -xs, -sm breakpoints.
        locals: {
           item: item
        }
      })
      .then(function(answer) {
        cb(answer);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    };

    $scope.go_to_participant = function(participant) {
      $state.go('attendance.detail.participant', {
        participant_id: participant._id
      });
    };

    // Toolbar search helper
    $scope.search = {
      alive: false
    };

    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    }

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };

    // groups
    $scope.select = {
      group: null
    };

    Group.query({
      area_id: area_id,
      room_id: room_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);

    $scope.discartGroup = function() {
      $scope.select.group = null;
      delete $scope.query.groups;
      $scope.getParticipants();
    }

    $scope.selectGroup = function() {
      var group_id = $scope.select.group;
      $scope.query.groups = group_id;
      $scope.getParticipants();
    };

    $scope.openMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };
  };

  function DialogController($scope, $mdDialog, item) {
    $scope.item = item;

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }
})();

function DialogEventController($scope, $mdDialog, LocalError, UUID, item) {
  $scope.title = item.name;
  $scope.qr = item.temp || null;
  $scope.isRunning = false;
  $scope.duration = 30;
  $scope.counter = $scope.duration;
  var interval = null;
  var interval_counter = null;

  $scope.update = function() {
    item.temp = UUID.next();
    item.$update(function(res) {
      $scope.qr = res.temp;
    }, LocalError.request);
  }

  if (item.temp) {
    console.log('event has an temp qr assigned');
  } else {
    $scope.update();
  }

  $scope.start = function() {
    $scope.isRunning = true;
    interval = setInterval(function() {
      $scope.counter = $scope.duration;
      $scope.update();
    }, $scope.duration * 1000);
    interval_counter = setInterval(function() {
      $scope.$apply(function () {
        $scope.counter = $scope.counter - 1;
      });
    }, 1000);
  };

  $scope.stop = function() {
    $scope.isRunning = false;
    $scope.counter = $scope.duration;
    clearInterval(interval);
    clearInterval(interval_counter);
  };

  $scope.hide = function() {
    clearInterval(interval);
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    clearInterval(interval);
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

function DialogEventUpdateController($scope, $mdDialog, LocalError, UUID, Event, event) {
  $scope.item = null;

  Event.get({
    _id: event._id
  }, function(res) {
    res.start = new Date(res.start);
    res.end = new Date(res.end);
    res.start.setSeconds(0);
    res.start.setMilliseconds(0);
    res.end.setSeconds(0);
    res.end.setMilliseconds(0);
    $scope.item = res;
  });

  $scope.remove = function(item) {
    item.$remove({
      _id: event._id
    }, function(response) {
      $scope.answer(response);
    }, LocalError.request);
  }

  $scope.update = function(item) {
    item.$update(function(response) {
      response.start = new Date(response.start);
      response.end = new Date(response.end);
      $scope.item = response;
      $scope.answer(item);
    }, LocalError.request);
  }

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailPeopleGateUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Gate,
    LocalError,
    HelperEvent,
    Toast
  ) {
    var area_id = $state.params.area_id;
    var gate_id = $state.params.gate_id;

    $scope.item = {
      type: 'pair',
      pair: null,
      state: null,
      area_id: area_id
    }
    $scope.pair = {
      in: 'Entrada',
      out: 'Salida'
    }
    $scope.states = [
      {
        key: 'default',
        value: 'Por defecto'
      }
    ];

    if (gate_id) {
      var itemParams = {
        _id: gate_id
      };
      Gate.get(itemParams, function(res) {
        $scope.item = res;
        $scope[res.type] = res[res.type];
      });
    } else {
      throw new Error('There is no element to load on this screen');
    }

    $scope.update = function(item) {
      item = angular.copy(item);
      item[item.type] = $scope[item.type];
      item.$update(function(res) {
        $state.go('attendance.detail.people.main');
      }, LocalError.request);
    }

    $scope.new_state = function(item) {
      if (!item.key) {
        Toast.show('tiene que proporcionar un valor para el estado');
        return;
      }
      if (!item.value) {
        Toast.show('tiene que proporcionar un estado');
        return;
      }
      $scope.states.push(angular.copy(item));
    };

    $scope.delete_state = function(index) {
      $scope.states.splice(index, 1);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailPeopleGateCreateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Gate,
    LocalError,
    HelperEvent,
    Toast
  ) {
    var area_id = $state.params.area_id;

    $scope.item = {
      type: 'pair',
      pair: null,
      state: null,
      area_id: area_id
    }
    $scope.pair = {
      in: 'Entrada',
      out: 'Salida'
    }
    $scope.states = [
      {
        key: 'default',
        value: 'Por defecto'
      }
    ]

    $scope.create = function(item) {
      item = angular.copy(item);
      item[item.type] = $scope[item.type];
      Gate.save(item, function(res) {
        $scope.gates.unshift(res);
        $state.go('attendance.detail.people.main');
      }, LocalError.request);
    }

    $scope.new_state = function(item) {
      if (!item.key) {
        Toast.show('tiene que proporcionar un valor para el estado');
        return;
      }
      if (!item.value) {
        Toast.show('tiene que proporcionar un estado');
        return;
      }
      $scope.states.push(angular.copy(item));
    };

    $scope.delete_state = function(index) {
      $scope.states.splice(index, 1);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansStoresUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $window,
    AttStore,
    LocalError,
    UploadImages,
    UUID
  ) {
    var area_id = $state.params.area_id;
    var store_id = $state.params.store_id;
    $scope.item = {
      _id: ''
    };

    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;

    $scope.update_store = function(item) {
      item.$update(function(res) {
        $state.go('attendance.detail.loans.stores');
      }, LocalError.request);
    }

    if (store_id) {
      AttStore.get({
        _id: store_id
      }, function(res) {
        $scope.item = res;
        console.log(res);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansStoresCreateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $window,
    AttStore,
    LocalError,
    UploadImages
  ) {
    var area_id = $state.params.area_id;

    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;

    $scope.item = {
      area_id: area_id
    };

    $scope.create_store = function(item) {
      AttStore.save(item, function(res) {
        $state.go('attendance.detail.loans.stores');
      }, LocalError.request);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansAssetsUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $window,
    $filter,
    Loan,
    Asset,
    Toast,
    AttStore,
    LocalError,
    Participant,
    UploadImages,
    UUID
  ) {
    var area_id = $state.params.area_id;
    var asset_id = $state.params.asset_id;

    // botton
    $scope.isId = false;
    $scope.idLabel = 'md-primary';
    $scope.codeLabel = null;

    // query
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    var end = new Date();
    end.setHours(23, 59, 0, 0);
    $scope.timer = {
      start: start,
      end: end
    };

    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;

    $scope.update_store = function(item) {
      item.$update(function(res) {
        $state.go('attendance.detail.loans.objects');
      }, LocalError.request);
    }

    $scope.load_asset_infomation = function(item) {
      if (item.type === 'store') {
        AttStore.get({
          _id: item._id
        }, function(res) {
          item.data = res;
          item.title = '[A] ' + res.name;
        }, LocalError.request);
      }
      if (item.type === 'participant') {
        Participant.get({
          _id: item._id
        }, function(res) {
          item.data = res;
          item.title = '[P] ' + res.last_name + ' ' + res.first_name;
        }, LocalError.request);
      }
    }

    if (asset_id) {
      Asset.get({
        _id: asset_id
      }, function(res) {
        $scope.changeIdentificar(res);
        $scope.item = res;
      });
      // Loan.query({
      //   asset_id: asset_id
      // }, function(loans) {
      //   loans.forEach(function(loan) {
      //     $scope.load_asset_infomation(loan.from);
      //     $scope.load_asset_infomation(loan.to);
      //   });
      //   $scope.loans = loans;
      // });
    }

    $scope.select_group = function() {
      $scope.item.type = 'store';
    }

    $scope.changeIdentificar = function(item) {
      $scope.isId = !$scope.isId;
      if ($scope.isId) {
        $scope.idLabel = 'md-primary';
        $scope.codeLabel = null;
        item.qr = item._id;
      } else {
        $scope.idLabel = null;
        $scope.codeLabel = 'md-primary';
        item.qr = item.uid;
      }
    }

    $scope.find_markers = function(timer) {
      $scope.markers = [];
      var data = {
        start: JSON.stringify(timer.start),
        end: JSON.stringify(timer.end)
      };
      data.start = data.start.slice(1, -1);
      data.end = data.end.slice(1, -1);
      Loan.search({
        area_id: area_id,
        asset_id: asset_id
      }, data, function(loans) {
        loans.forEach(function(loan) {
          $scope.load_asset_infomation(loan.from);
          $scope.load_asset_infomation(loan.to);
        });
        $scope.loans = loans;
      });
    }

    $scope.save_report = function() {
      if (!$scope.loans) {
        Toast.show('No hay informacion cargada, debe hacer una busqueda primero.');
        return;
      }
      var rows = [['Fecha', 'Desde', 'Donde']];
      $scope.loans.forEach(function(loan) {
        rows.push([$filter('date')(loan.created, 'MM/dd/yyyy HH:mm:ss'), loan.from.title, loan.to.title]);
      });

      var csvContent = "data:text/csv;charset=utf-8,";
      rows.forEach(function(rowArray) {
         var row = rowArray.join(";");
         csvContent += row + "\r\n";
      });
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "my_data.csv");
      document.body.appendChild(link);
      link.click();
    }

    AttStore.query({
      area_id: area_id
    }, function(res) {
      $scope.stores = res;
    }, LocalError.request);
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('ProviderStudioUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Studio
  ) {
    $scope.template = {
      item: 'app/attendance/provider/studio/item.html',
      remove: 'app/attendance/provider/studio/delete/index.html'
    };

    if ($state.params.studio_id) {
      Studio.get({
        _id: $state.params.studio_id
      }, function(response) {
        $scope.item = response;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('ProviderStudioListController', controller);

  /** @ngInject */
  function controller(
    $scope,
    Toast,
    $state,
    Studio,
    Global
  ) {
    Toast.show('Cargando...');
    Studio.query({
      attendance: Global.counter._id
    }, function(response) {
      $scope.providers = response;
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('ProviderStudioCreateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Studio,
    Global
  ) {
    $scope.item = {};

    $scope.template = {
      item: 'app/attendance/provider/studio/item.html'
    };

    $scope.create = function(item) {
      item.attendance = Global.counter._id;
      Toast.show('Cargando...');
      Studio.save(item, function(response) {
        Toast.show('Se creo un nuevo provedor');
        $state.go('attendance.provider.studio.list');
      });
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AreaDetailTemplateUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $mdDialog,
    Toast,
    Global,
    Template,
    UploadImages,
    Store,
    LocalError,
    HelperTemplateType
  ) {
    var area_id = $state.params.area_id;
    var template_id = $state.params.template_id;
    $scope.container = null;
    $scope.item = {};
    $scope.layer = null;
    $scope.background = null;
    $scope.fonts = HelperTemplateType.fonts;

    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;

    Template.get({
      _id: template_id
    }, function(res) {
      $scope.container = res.config.container;
      $scope.items = res.config.config;
      $scope.item = res;
      HelperTemplateType.load_image(res.image, function(imageObject) {
        $scope.background = imageObject;
        $scope.populate_default_canvas();
      });
    });

    UploadImages.callback(function(data) {
      HelperTemplateType.load_image(data.file_name, function(imageObject) {
        $scope.background = imageObject;
        $scope.populate_default_canvas();
      });
    });

    $scope.populate_default_canvas = function() {
      $scope.layer = HelperTemplateType.get_layer($scope.container);
      HelperTemplateType.draw_background($scope.layer, $scope.container, $scope.background);
      $scope.items.forEach(function(item) {
          $scope.draw_property(item);
      });
    }

    $scope.re_draw = function() {
      $scope.items = HelperTemplateType.get_canvas_config($scope.layer);
      $scope.populate_default_canvas();
    }

    $scope.select_property = function(property) {
      if (!$scope.layer) {
        Toast.show('No existe aun un template');
      }
      var item = {
        key: property.key,
        x: $scope.container.width / 2,
        y: $scope.container.height / 2
      };
      switch (property.type) {
        case 'image':
          item.width = 100;
          item.height = 100;
          break;
        case 'qr':
          item.size = 100;
          break;
        case 'text':
            item.font = 'Monospace';
            item.size = 20;
          break;
        default:
            throw new Error('Type is not implemented');
      }
      $scope.draw_property(item);
    };

    $scope.on_update_options = function(shape) {
      $scope.items = HelperTemplateType.get_canvas_config($scope.layer);
      $scope.$apply(function() {
        $scope.info = HelperTemplateType.select_value(shape.att_key, $scope.properties);
        $scope.property = HelperTemplateType.select_value(shape.att_key, $scope.items);
      });
    }

    $scope.draw_property = function(item) {
      if (!$scope.layer) {
        Toast.show('No existe aun un template');
      }
      switch (item.key) {
        case 'image':
            item.data = "data:image/jpeg;base64,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";
            HelperTemplateType.draw_default_image($scope.layer, item, $scope.on_update_options);
          break;
        case '_id':
            console.log(item);
            item.data = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAUMSURBVHhe7V07UiMxEJU5CyagOIH3BHa0p8AhJJsRcgAT4mxTIpLFJ8AnoAgwd/HOLItLo9H0tFqfaXseVa6CcqvVek/dLfVoxMQYs68+2X72e576yWTSsIFqZ8u6ctR3dgduf10AUPpzgHaWQyl0yhEAIXLssrSs48QhpnDDS58lkrBROjS4Y7D7TxES+zDqCp/wkBDkCsiCkAIgh3QBQkLQKiBL5pAUS8MUuSHV0jZFjuTmF4o7ajzwkAKzPqQLEBKCVgHZQUMWN4RQu3huWO3DUmKLNBwjZPWxoeh7hCxFZNSmgBBlhKjNIVRu4MZ7F2tJvglZcnP1I4co8wLKHIQsZWQVr/Z27XS57l7jJ314xcWeuxuXhk4qlMJDuCwVkgMhhYDmdpMlZHE7P2a5OqzlCFkNQkIBSmVQaL8a5ENyXoi9CFkhaBWQBSEFQA7pYlKFHd7BqRCtkBUjAA8RQ5enIQjJg6tYKwgRQ5enYVS1d8zpJ2bZS+EGD8kz0cVaQYgYujwNyWUv94xuHtN0a/WVTqQP1ex28BBlvIMQZYSQxcWuI/rfYxjzKqvGQPrWlzsHbBzhIco8RB0hm+Xk38w7fJabNmSbZVPGlnd///FgPpWBTpmjjpCWsW8fLUA/P974EG9vzfQ/ST5u+YrKSJ7V8avrY89Un0wZE9P1sl5UnpeQFReThmc7nkrhbI9Qv4ew+Lg2L56J9XLtabxeJCWFZV6A0IkQ4h/x/LH2/hfT4qUiJaGjBMDdL3pmuxkl7rpjv2otEnPzuFuZmWPO+j59sueGfwrLk/aQAwfnN+bOdZPtk/mjcPk1DkIqZuY/W4yYJ4WMjIaQipFWLtm+77TE1YMdJCF2TFRn+cAGUUtcX9WXwtLWNR4PMVNz6WZ2z6ZzYJ7xBtXQBLj9NzzkeJe2HFh35n3ryF1dmHNO0w4Zd5lri1FYUsvjEYWsNqqzy2kEHXmajoeQzbNZtxwkxj9ASBQCm2eXjplR6CD8pO6rbEYhVLLx54O5d/m4vjM3EQ5S45Ej544gZG3Mcnprmvl8Zla/5iWnBLuvkybk6+njopU7ZqvfUd7BRlcg2HhA5banKsG6DjiszcLzGHfhhqlqgLPVzrzGxCoCZGm1d6Q79SpM7fbZyBA4g7eJ/pDl2bydX1yxx197xNfMfVUbphobSvsNKulRSDY6JyaY6lxWg5DqD9ErbbpySHmmcba3POaD9Kg/hwwCy3Cdst+gGnuI8lFE5RDpd/CQ4ZzhSJe9ygDLbQ48JDfCgfrFOSTlbTiBNqsVT/EKIDxEGb0gRBkh4pClbBzFzYm5OIAyFh5SnEq6QxCijBDcl5WQEGm1HBcHJCQhtSqErNSIRuoDIZEApm6Oa2KFiMY8oCIrwdInhtxxcO9pp/SFlP5T7w+ofy1BfeeOh7qmBFdrcGfTAHJZrhqnimxdMzjEk/ouxfnGMcSzbOylRUJuOypkIakP4AUonSgDHYQcESHsam/IKoibQ7grjxwH0kJWQan5xDWxqRHNqA9JPSO4EtVqQpbE+LqNNJxxN3wh+rljoDav8BAuioXkQEghoLndgBAuUoXkjiKHSAuGIeUYG29pO6kOFBcLzXZJNwhZEtQytile7c1dVeUeNAh5XaArFHH7cvlDtTfjjE6tGiErNaKR+kBIJICpm0cdcuAYwy1RULqky16OfT4Z7pPGkLIK92kiPETKWqZ2ICQTsFK1fwF9TMW0Q9X8xQAAAABJRU5ErkJggg==";
            HelperTemplateType.draw_default_qr($scope.layer, item, $scope.on_update_options);
          break;
        case 'uid':
            item.data = "data:image/png;base64,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";
            HelperTemplateType.draw_default_qr($scope.layer, item, $scope.on_update_options);
          break;
        default:
            HelperTemplateType.draw_text($scope.layer, item, $scope.properties, $scope.on_update_options);
      }
    };

    $scope.update_template = function(item) {
      if (!$scope.layer) {
        Toast.show('No existe aun un template');
      }
      var config = HelperTemplateType.get_canvas_config($scope.layer);
      $scope.item.config = {
        container: $scope.container,
        config: config
      };
      $scope.item.$update(function(response) {
        $scope.load_templates();
        $state.go('attendance.detail.template.main');
      }, LocalError.request);
    };

    $scope.clear = function() {
      if (!$scope.layer) {
        Toast.show('No existe aun un template');
        return;
      }
      $scope.layer.clear();
      $scope.layer = HelperTemplateType.get_layer($scope.container);
      HelperTemplateType.draw_background($scope.layer, $scope.container, $scope.background);
    };

    $scope.remove_template = function(item) {
      item.$remove({
        _id: item._id
      }, function(res) {
        $state.go('attendance.detail.template.main');
        $scope.load_templates();
      }, LocalError.request);
    }

    $scope.openEventMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    $scope.show_confirm_template = function(ev) {
      var confirm = $mdDialog.confirm()
      .title('¿Esta seguro que desea eliminar esta plantilla?')
      .textContent('Todos los elementos asociados seran eliminas')
      .ariaLabel('confirmation-modal')
      .targetEvent(ev)
      .ok('Aceptar')
      .cancel('Cancelar');

      $mdDialog.show(confirm)
      .then(function() {
          $scope.remove_template($scope.item);
      }, function() {
          console.log('cancel');
      });
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AreaDetailTemplateMainController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    LocalError
  ) {
    var area_id = $state.params.area_id;
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .controller('AreaDetailTemplateCreateController', controller);

    /** @ngInject */
    function controller(
      $scope,
      $state,
      Toast,
      Global,
      Template,
      UploadImages,
      Store,
      LocalError,
      HelperTemplate,
      HelperTemplateType
    ) {
      var area_id = $state.params.area_id;
      $scope.container = {
        width: 400,
        height: 600
      };
      $scope.item = {};
      $scope.layer = null;
      $scope.background = null;
      $scope.fonts = HelperTemplateType.fonts;

      UploadImages.init($scope);
      $scope.upload = UploadImages.upload;

      UploadImages.callback(function(data) {
        HelperTemplateType.load_image(data.file_name, function(imageObject) {
          $scope.background = imageObject;
          $scope.create_default_canvas();
        });
      });

      $scope.create_default_canvas = function() {
        $scope.layer = HelperTemplateType.get_layer($scope.container);
        HelperTemplateType.draw_background($scope.layer, $scope.container, $scope.background);
      };

      $scope.select_property = function(property) {
        if (!$scope.layer) {
          Toast.show('No existe aun un template');
        }
        var item = {
          key: property.key,
          x: $scope.container.width / 2,
          y: $scope.container.height / 2
        };
        switch (property.type) {
          case 'image':
            item.width = 100;
            item.height = 100;
            break;
          case 'qr':
            item.size = 100;
            break;
          case 'text':
              item.font = 'Monospace';
              item.size = 20;
            break;
          default:
              throw new Error('Type is not implemented');
        }
        $scope.draw_property(item);
      };

      $scope.on_update_options = function(shape) {
        $scope.items = HelperTemplateType.get_canvas_config($scope.layer);
        $scope.$apply(function() {
          $scope.info = HelperTemplateType.select_value(shape.att_key, $scope.properties);
          $scope.property = HelperTemplateType.select_value(shape.att_key, $scope.items);
        });
      }

      $scope.draw_property = function(item) {
        if (!$scope.layer) {
          Toast.show('No existe aun un template');
        }
        switch (item.key) {
          case 'image':
              item.data = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4QBuRXhpZgAASUkqAAgAAAABAGmHBAABAAAAGgAAAAAAAAABAIaSAgA6AAAALAAAAAAAAABDUkVBVE9SOiBnZC1qcGVnIHYxLjAgKHVzaW5nIElKRyBKUEVHIHY4MCksIHF1YWxpdHkgPSA5MAoA/9sAQwADAgIDAgIDAwMDBAMDBAUIBQUEBAUKBwcGCAwKDAwLCgsLDQ4SEA0OEQ4LCxAWEBETFBUVFQwPFxgWFBgSFBUU/9sAQwEDBAQFBAUJBQUJFA0LDRQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU/8AAEQgAyADIAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A/VOiiigAooooAKKKKACiiigAorhvi/8AG3wT8B/CkviLxz4gtdB01ciPzmzLO4GdkUYy0jeyg++BX5bftEf8Fk/FfiSa50v4SaNH4W03LINb1VFuL2VeRuSLmOL153n6UAfrtq2s6foFjJe6nfW2nWcYy9xdzLFGo92YgCvGPFH7cnwD8HzNFqXxW8N+apwUs7r7WQfpCHr+fn4g/Fvxr8V9TfUPGPirVvEl053btRu3lVf91Sdqj2AArkqdgP6AG/4Kdfs2rc+T/wALFQ848waZd7Pz8quu8Nft3fs/+LJli0/4reHlkY4C3twbTJ/7bBa/nRoosB/UtofiHSvE9gl9o+p2erWT/dubG4SaNvoykg1oV/L94H+Jfiz4Z6pHqPhPxLqvhy9Rtwm0y7eAk++0gEexr7r/AGe/+CxfjzwXLb6b8UdLi8caQMIdTs1S21CIepAAjl+hCn/aosB+y1FecfBD9obwD+0T4YXXPAniC31e3UAXFtnZc2rH+GWI/Mh9yMHsTXo9IAooooAKKKKACiiigAooooAKKKKACiiigAooooAK+af20v23fC/7I/hIBxHrXjjUIidL0JXxnt505HKRA/ixGB3I6/8Aaz/aY0P9lb4Q6h4u1TZdak+bXSNML4a9uyCVT1CjBZj2UHuRn+en4m/E3xJ8YfHOreLvFmpSarrmpymWeeToB/CiDoqKMAKOABTA0/jP8cfGn7QHjS48UeN9am1fUpMrGh+WG2jzkRwxjhEHoOvUknmuDooqgCiiigAooooAKKKKAOu+FnxZ8WfBXxlZeKfBmtXOh61an5ZoG+WRe6SKeHQ91YEGv3E/YY/b38P/ALWGg/2PqawaF8R7CHfeaUGxHdoMAz22eSv95OSue4wa/A2trwX4z1v4eeKtL8SeHNRn0nW9MnW4tby3bDxuP5g9CDwQSDwaTQH9RlFfPf7E37WGl/tY/CK31tfKs/FOnbbXXdNQ/wCpnxxIg/55yAFl9PmXqpr6EqQCiiigAooooAKKKKACiiigAooooAKQkKCScAdzS188ft+fGd/gb+yv401y1lMOrX0A0jT2U4ZZ7jKbh7qm9/8AgNAH5E/8FGf2nZ/2jf2gNSisbrzfB/hl5NL0iNGyku1sTXHuZHHB/uqlfK1FFUAUUUUwCiiigAooooAKKKKACiiigD6D/Ya/aVu/2Yvj5o2vPOy+GtRddO1y3z8rWrsB5mP70Zw4+hHc1/Q9bXMV5bxTwSLNBKoeORDlWUjIIPcEV/K9X76f8ExPjQ/xh/ZQ8PR3kxm1fwy7aDdMzZZliCmFj9YmjH1U1LA+sqKKKQBRRRQAlFLRQAUUUUAFFFFABX5ef8FvPHUtvoHwy8HRS4iuri71WeMHqY1SOMn/AL+yV+odfjP/AMFrNSa4/aB8GWRPyW3hsOB7vcy5P/jo/KmB+eNFFFUAUUUUAFFFFABRRRQAUUUUAFFFFABX6df8ERfHM0HjD4k+DnmH2a5sbfVooiejxyGJyPqJUz9BX5i19xf8EeNRez/a8NurYS78P3sTD1w0Tj/0GkwP3EoooqQCiiigAooooAKKKKACiiigAr8cP+C2OjSW3xy8CaoR+5u/D7QqcfxR3Dkj8pF/Ov2Pr82f+C2Pw7k1X4X+AvGkEJf+x9Tl0+4cfwx3CBlJ9t0IH/AqAPx/oooqwCiiigAooooAKKKKACiiigAooooAK+6/+CN+iS6j+1je3yrmLT/Dt3I5x03SQoP/AEKvhSv1W/4Ii/DuRI/iV46mjYRObbRbZyOGIzNKB9Mw0mB+qFFFFSAUUUUAFFFFABRRRQAUUUUAFeS/tXfBqP4/fs+eNPBO0G8v7FnsWI+7dRkSQn/vtFB9ia9aooA/lfvLOfTrye0uoXt7mCRopYpBhkdThlI7EEEVDX3t/wAFY/2VZvhR8Wj8S9DtCPCni+YvdeWvy2mo4zIp9BKAZB7+YOwr4JqgCiiimAUUUUAFFFFABRRRQAUUUUAKql2CqCzE4AA5Jr+iX9hL4IN8Av2YfB/hy6iMOsXMH9qamrD5luZ8OyH3Rdif8Ar8pP8AgmH+ytN8ffjfb+JtXtN/grwhNHe3bSL8l1dA7oLcdjyN7D+6oB+8K/dupYBRRRSAKKKKACiiigAoopDzQAtFFFABRRRQBx3xd+FHh343fDrW/BfimzF5o2qwGKQcb4m6pIh/hdWAYH1Ffz3ftTfsv+Kv2VviXdeGPEETXGnylpdK1hEIhv4M8MvowyAydVPqCCf398bftEfDX4c+MtG8J+JfGmkaR4j1eVYrTTri4AlZm+7uA/1YY8AvgEkAc0nx4+AXg79o7wBd+EvGenC8sZP3kFxHhbizmxhZYn/hYZ+hHBBBxTA/mfor6Z/a5/YM8f8A7Kur3F5cW0niHwM8pW08R2URKKp+6lwo/wBU/bn5SehPQfM1MAooopgFFFFABRRRQAV6d+zv+z14s/aX+JVh4P8ACdqXmlIkvL+RT5FhBnDTSkdAOw6scAcmuy/ZW/Yo+If7VuuxroNi2l+FopAt74kvkK20IB+ZY/8AnrJ/sL+JUc1+537N/wCzP4L/AGXfAEXhjwhZkFyJL/U7jDXV/NjHmSMP0UYCjoOpKuBqfAH4G+HP2dPhbo/gfwxDtsrFN01y6gS3c7cyTSY6sx/IAAcAV6JXnWg/tEfDXxP8SNU8A6X400i78YaadtzpKXAEobuq54dl/iCkle+K9FqQCiiigAooooAKKKKACiiigAoorkvip8VfC/wW8D6l4u8YarDo+h2CbpJ5TlnY/djRerux4Cjk0AbviDxBpnhTRb3WNZ1C20rSrKIzXN5eSiOKFB1ZmPAFflH+2J/wVx1DWJr7wn8EWbTdOBMU3i6aPFxN2P2VG/1a/wDTRhuPYL1r5o/bR/bx8XftY69LYRtNoHw+tZt1joMb4M2D8s1yQcPJ3A+6vbnJPy5TsBa1TVb3XNRuNQ1K8uNQv7hzJNdXUrSSyserMzEkn3Nfor+w/wD8FU7/AOHUGmeBfi/Ncav4ZiUW9l4kAMt3YoOFWcdZYx03D51H94dPzgop2A/qF0DxD4Y+KnhGLUdJvdN8UeG9Th+WaBkuba4jI5U9QeuCp+hFfFH7RP8AwSH+G/xNmu9X+H97J8O9clJc2kUfn6bI3/XLIaLP+wcD+7X5SfAr9p34k/s4aw194E8S3GlxSMGuNOk/e2dzj/npC3yk/wC0MMOxFfpX8DP+Cz/hLXIbWw+KXhm68NX5G2TVtGBubNj/AHjET5iD2G+kB8V/Fb/gmV8fvhdcTFPCB8XacmSt94blF0GA7+VxKP8Avivm/X/BXiHwrO8OtaDqejyocNHf2ckLA+4YCv6Qfhv+0t8K/i7Gp8IePtC1uUjP2aG8VLgfWJsOPxFeiXdlbajAYrmCK6hbqkqB1P4Gi4H8sGRWronhTXPEsyxaRo2oarKxwsdlayTMT7BQa/pyPw/8LmTzD4b0gyf3zYRZ/PbWtZadaaZD5VnbQ2kXXZBGEX8hRcD8APhZ/wAE2/j98VJoWi8Ez+GtPkwTfeI3Fkiqe/ltmQ/ghr78/Z6/4I7+A/AU1rq3xL1aTx7qsZD/ANmwKbfTUI7MM75R9SoPda+yviL+0J8NPhLCZPGHjnQtAI/5Y3d6gmb6Rglz+Ar4r+N//BZnwD4WjurH4a6Be+MtSUFY9R1BTZ2IbPXB/euPbCZ9aAPviefw18MPCLSSvpnhbw1pUPJPl2traxD8lUV+W37bn/BV+TXIdQ8EfBO5kt7Fw0F74vKlJZV6MtopwUB/56nn+6Bw1fEfx/8A2t/ih+0vqAl8b+JJbnTo33waNZjyLGA9isQ4J/2m3N7145RYCxBqF1a36X0FzNDepJ5qXMchWRXzncGHIOec1+iv7Hv/AAVq17wLJYeFfjG0/iTw6MRReJI13X9oO3nAf69B6/fH+10r84qKdgP6jfCHjHQ/H/huw1/w5qtrrei30Yltr6ylEkUin0I79iDyDwea2a/ni/ZB/bX8afsl+KkfTpX1jwddyg6n4cnkPlSjjMkR/wCWcoHRhwejAjp+8PwU+N3hH9oHwDYeL/BmppqOl3Iw6Hia2lwC0MqdVdc8j8QSCDUgd5RRRQAUUUUAFFFFAGF458caH8NvCOq+J/Emow6VomlwNcXV3OcKiD+ZJwABySQBya/Ab9tj9szxB+1v8QDcOZdN8FaZI66Lou7hF6efLj70rDr2UfKO5Psf/BUX9tJ/jd47l+G/hS9J8C+HbkrdTwv8mp3q5DPx1jjOVXsTub+7j4MpoAoooqgCiiigAooooAVGMbBlJVgchgcEGu18N/G/4ieDht0Lx34k0hMY2Weqzxr+QbFcTRSA9kX9sv46raG2Hxb8X+Sf4f7Wmz+e7Nct4j+PPxK8Xp5et/EDxNqsf/PO71eeRfyL4rhKKAHSyPNI0kjtJIxyWc5JPuabRRTAKKKKACiiigAr3X9kX9rTxR+yZ8R49c0hnv8AQLwrFrGiO+I7yEHqP7si5JVvwOQSK8KopAf09fCv4peG/jP4C0jxj4T1BNS0PU4RLDKvDIf4o3X+F1OQynoRXWV+Ef8AwTc/bOm/Zr+JSeGvEV2f+Fd+I50ju/MPy6dcnCpdL6L0V/VcH+EV+7UciTRrJGyvG4DKynIIPQg1IDqKKKACvjP/AIKfftVN+z78E28PaFem38a+LVeztHibElpagATz+oOCEU+r5H3a+yLi4itLeWeeRYoYlLvI5wqqBkknsAK/nR/bU/aDuP2lP2hPEnioSs2iwyHT9HizwlnExCHHq5LSH3c0AeGdaSiirAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK/bD/gk5+1W/xe+Fc3w58Q3pn8V+EYlFtJM2XutOztjOe5iOIz7GP1NfifXqn7MHxyv/2dPjj4X8dWRd4bC4CX1up/4+LR/lmj/FSSP9oKe1Jgf0pUVS0XWLPxFo9jqunTpdaffQJc288ZyskbqGVh7EEGipA+XP8Agpt8bW+DP7KfiGOzuPI1rxMw0KzIbDBZQfPYfSJXGfVhX4E1+jP/AAWm+KR134w+EPAkEzG30DTGvriMHjz7luMj1EcaH/gdfnNVIAooopgFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAH7mf8ElfjW3xP/Zki8N31x5ureDLo6YQx+Y2rDfbn6AF0HtHRXxD/wAEd/iifBv7Td54Wnm2WfivSpbdULYBuIf30Z+uwTD/AIFRUAeF/t3eNm8f/tefFHVDN50UWsSafCwOR5duBAuPb93n8a8FrsvjH4N8Q/D/AOKvivw/4sjePxFY6lPHes//AC1kLk+YD3V8hge4YGuNqgCiiimAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeofsveNZPh1+0Z8NvEUbbBZa9aGQk4HlNKEkH/fDMKK4vwL4b1fxh400LQ9At5brWtQvYbezihUlmlZwFxj0POe2KKlgf0P/Hv9jj4T/tKSw3XjfwxHd6tCgjj1azla2u1QdFMiEblGeAwIHbFeIf8ADoD9nz/n08Sf+Dc//EUUUgD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAD/h0B+z5/wA+niT/AMG5/wDiKP8Ah0B+z5/z6eJP/Buf/iKKKAD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAD/h0B+z5/wA+niT/AMG5/wDiKP8Ah0B+z5/z6eJP/Buf/iKKKAD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAD/h0B+z5/wA+niT/AMG5/wDiKP8Ah0B+z5/z6eJP/Buf/iKKKAD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAD/h0B+z5/wA+niT/AMG5/wDiKP8Ah0B+z5/z6eJP/Buf/iKKKAD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAD/h0B+z5/wA+niT/AMG5/wDiKP8Ah0B+z5/z6eJP/Buf/iKKKAD/AIdAfs+f8+niT/wbn/4ij/h0B+z5/wA+niT/AMG5/wDiKKKAPYvgL+xB8H/2cNTbVvB3hcLrpUoNX1Gdrq5RSMEIzcJkcHaBnvRRRQB//9k=";
              HelperTemplateType.draw_default_image($scope.layer, item, $scope.on_update_options);
            break;
          case '_id':
              item.data = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAUMSURBVHhe7V07UiMxEJU5CyagOIH3BHa0p8AhJJsRcgAT4mxTIpLFJ8AnoAgwd/HOLItLo9H0tFqfaXseVa6CcqvVek/dLfVoxMQYs68+2X72e576yWTSsIFqZ8u6ctR3dgduf10AUPpzgHaWQyl0yhEAIXLssrSs48QhpnDDS58lkrBROjS4Y7D7TxES+zDqCp/wkBDkCsiCkAIgh3QBQkLQKiBL5pAUS8MUuSHV0jZFjuTmF4o7ajzwkAKzPqQLEBKCVgHZQUMWN4RQu3huWO3DUmKLNBwjZPWxoeh7hCxFZNSmgBBlhKjNIVRu4MZ7F2tJvglZcnP1I4co8wLKHIQsZWQVr/Z27XS57l7jJ314xcWeuxuXhk4qlMJDuCwVkgMhhYDmdpMlZHE7P2a5OqzlCFkNQkIBSmVQaL8a5ENyXoi9CFkhaBWQBSEFQA7pYlKFHd7BqRCtkBUjAA8RQ5enIQjJg6tYKwgRQ5enYVS1d8zpJ2bZS+EGD8kz0cVaQYgYujwNyWUv94xuHtN0a/WVTqQP1ex28BBlvIMQZYSQxcWuI/rfYxjzKqvGQPrWlzsHbBzhIco8RB0hm+Xk38w7fJabNmSbZVPGlnd///FgPpWBTpmjjpCWsW8fLUA/P974EG9vzfQ/ST5u+YrKSJ7V8avrY89Un0wZE9P1sl5UnpeQFReThmc7nkrhbI9Qv4ew+Lg2L56J9XLtabxeJCWFZV6A0IkQ4h/x/LH2/hfT4qUiJaGjBMDdL3pmuxkl7rpjv2otEnPzuFuZmWPO+j59sueGfwrLk/aQAwfnN+bOdZPtk/mjcPk1DkIqZuY/W4yYJ4WMjIaQipFWLtm+77TE1YMdJCF2TFRn+cAGUUtcX9WXwtLWNR4PMVNz6WZ2z6ZzYJ7xBtXQBLj9NzzkeJe2HFh35n3ryF1dmHNO0w4Zd5lri1FYUsvjEYWsNqqzy2kEHXmajoeQzbNZtxwkxj9ASBQCm2eXjplR6CD8pO6rbEYhVLLx54O5d/m4vjM3EQ5S45Ej544gZG3Mcnprmvl8Zla/5iWnBLuvkybk6+njopU7ZqvfUd7BRlcg2HhA5banKsG6DjiszcLzGHfhhqlqgLPVzrzGxCoCZGm1d6Q79SpM7fbZyBA4g7eJ/pDl2bydX1yxx197xNfMfVUbphobSvsNKulRSDY6JyaY6lxWg5DqD9ErbbpySHmmcba3POaD9Kg/hwwCy3Cdst+gGnuI8lFE5RDpd/CQ4ZzhSJe9ygDLbQ48JDfCgfrFOSTlbTiBNqsVT/EKIDxEGb0gRBkh4pClbBzFzYm5OIAyFh5SnEq6QxCijBDcl5WQEGm1HBcHJCQhtSqErNSIRuoDIZEApm6Oa2KFiMY8oCIrwdInhtxxcO9pp/SFlP5T7w+ofy1BfeeOh7qmBFdrcGfTAHJZrhqnimxdMzjEk/ouxfnGMcSzbOylRUJuOypkIakP4AUonSgDHYQcESHsam/IKoibQ7grjxwH0kJWQan5xDWxqRHNqA9JPSO4EtVqQpbE+LqNNJxxN3wh+rljoDav8BAuioXkQEghoLndgBAuUoXkjiKHSAuGIeUYG29pO6kOFBcLzXZJNwhZEtQytile7c1dVeUeNAh5XaArFHH7cvlDtTfjjE6tGiErNaKR+kBIJICpm0cdcuAYwy1RULqky16OfT4Z7pPGkLIK92kiPETKWqZ2ICQTsFK1fwF9TMW0Q9X8xQAAAABJRU5ErkJggg==";
              HelperTemplateType.draw_default_qr($scope.layer, item, $scope.on_update_options);
            break;
          case 'uid':
              item.data = "data:image/png;base64,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";
              HelperTemplateType.draw_default_qr($scope.layer, item, $scope.on_update_options);
            break;
          default:
              HelperTemplateType.draw_text($scope.layer, item, $scope.properties, $scope.on_update_options);
        }
      };

      $scope.create_template = function(item) {
        if (!$scope.layer) {
          Toast.show('No existe aun un template');
        }
        var config = HelperTemplateType.get_canvas_config($scope.layer);
        var data = {
          area_id: area_id,
          name: $scope.item.name,
          image: $scope.item.image,
          config: {
            container: $scope.container,
            config: config
          }
        }
        Template.save(data, function(res) {
          $scope.load_templates();
          $state.go('attendance.detail.template.main');
        }, LocalError.request);
      };

      $scope.populate_default_canvas = function() {
        $scope.layer = HelperTemplateType.get_layer($scope.container);
        HelperTemplateType.draw_background($scope.layer, $scope.container, $scope.background);
        $scope.items.forEach(function(item) {
            $scope.draw_property(item);
        });
      }

      $scope.re_draw = function() {
          $scope.items = HelperTemplateType.get_canvas_config($scope.layer);
          $scope.populate_default_canvas();
      }

      $scope.clear = function() {
        if (!$scope.layer) {
          Toast.show('No existe aun un template');
          return;
        }
        $scope.layer.clear();
        $scope.layer = HelperTemplateType.get_layer($scope.container);
        HelperTemplateType.draw_background($scope.layer, $scope.container, $scope.background);
      };
    }
  })();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('DetailStudioUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Studio
  ) {
    $scope.template = {
      item: 'app/attendance/detail/studio/item.html',
      remove: 'app/attendance/detail/studio/delete/index.html'
    };

    if ($state.params.studio_id) {
      Studio.get({
        _id: $state.params.studio_id
      }, function(response) {
        $scope.item = response;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('DetailStudioListController', controller);

  /** @ngInject */
  function controller(
    $scope,
    Toast,
    $state,
    Studio,
    Global
  ) {
    Toast.show('Cargando...');
    Studio.query({
      attendance: Global.counter._id
    }, function(response) {
      $scope.details = response;
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('DetailStudioCreateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Studio,
    Global
  ) {
    $scope.item = {};

    $scope.template = {
      item: 'app/attendance/detail/studio/item.html'
    };

    $scope.create = function(item) {
      item.attendance = Global.counter._id;
      Toast.show('Cargando...');
      Studio.save(item, function(response) {
        Toast.show('Se creo un nuevo provedor');
        $state.go('attendance.detail.studio.list');
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailSetUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    Area,
    Users,
    UploadImages,
    LocalError
  ) {
    UploadImages.init($scope);
    var area_id = $state.params.area_id;
    if (!area_id) {
      throw new Error('params is empty');
    }

    $scope.load = function() {
      Area.get({
        _id: area_id
      }, function(response) {
        $scope.item = response;
        UploadImages.add_current_image(response.image);
      });
    };

    $scope.load();
    $scope.upload = UploadImages.upload;

    $scope.updateArea = function(item) {
      item.$update(function(response) {
        Toast.show('Se actualizo correctamente');
        $scope.set_area(response);
        $scope.loadToolbarAreas();
        $scope.select_main_room();
      }, LocalError.request);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailSetUdfController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    Area
  ) {
    var area_id = $state.params.area_id;
    if (!area_id) {
      throw new Error('params is empty');
    }

    $scope.load = function() {
      Area.get({
        _id: area_id
      }, function(response) {
        $scope.item = response;
        $scope.loadListOfAdministrators();
      });
    };

    $scope.load();

  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
      var base_url = 'app/attendance/detail/settings/states';

      $stateProvider.state('attendance.detail.settings.states.update', {
        url: '/update/:state_id',
        templateUrl: base_url + '/update/index.html',
        controller: 'AtteDetailSetStatesUpdateController'
      });
      $stateProvider.state('attendance.detail.settings.states.create', {
        url: '/create',
        templateUrl: base_url + '/create/index.html',
        controller: 'AtteDetailSetStatesCreateController'
      });
      $stateProvider.state('attendance.detail.settings.states.main', {
        url: '/main',
        templateUrl: base_url + '/main/index.html',
        controller: 'AtteDetailSetStatesMainController'
      });
    }

  })();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AtteDetailSetStatesController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    State,
    LocalError
  ) {
    var area_id = $state.params.area_id;

    $scope.states = [];

    $scope.load_states = function() {
      State.query_order_by({
        area_id: area_id
      }, function(res) {
        $scope.states = res;
      }, LocalError.request);
    };
    $scope.load_states();
  };

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailSetMainController', controller);

  /** @ngInject */
  function controller() {
  };

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailSetAdministratorsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    Area,
    Users,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    if (!area_id) {
      throw new Error('params is empty');
    }

    $scope.load = function() {
      Area.get({
        _id: area_id
      }, function(response) {
        $scope.item = response;
        $scope.loadListOfAdministrators();
      });
    };

    $scope.load();

    // administrators
    $scope.addAdministrator = function(email) {
      if (!email) {
        return;
      }
      Users.findByEmail({
        email: email
      }, function(users) {
        if (users.length < 1) {
          Toast.show('No existe un usuario registrado con este email');
          return;
        }
        var user = users[0];
        var isRegistry = addAdministratorToCurrentArea(user);
        if (!isRegistry) {
          $scope.item.$update(function(response) {
            $scope.administrators.push(user);
          }, LocalError.request);
        }
      }, LocalError.request);
    }

    $scope.removeAdministrator = function(user, index) {
      var user_ids = [];
      $scope.item.users.forEach(function(user_id) {
        if (user._id != user_id) {
          user_ids.push(user_id);
        }
      });
      $scope.item.users = user_ids;
      $scope.item.$update(function(response) {
        $scope.administrators.splice(index, 1);
      }, LocalError.request);
    }

    $scope.loadListOfAdministrators = function() {
      $scope.administrators = [];
      $scope.item.users.forEach(function(user_id) {
        if ($scope.item.user_id == user_id) {
          return;
        }
        Users.get({
            _id: user_id
          }, function(response) {
          $scope.administrators.push(response);
        });
      });
    }

    var addAdministratorToCurrentArea = function(user) {
        var isRegistry = false;
        $scope.item.users.forEach(function(user_id) {
          if (user._id == user_id) {
            isRegistry = true;
          }
        });
        if (!isRegistry) {
            $scope.item.users.push(user._id);
        } else {
          Toast.show('El usuario ya fue registrado');
        }
        return isRegistry;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomUpdateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Room,
    Toast,
    LocalError,
    Participant
  ) {
    $scope.item = {};
    var room_id = $state.params.room_id;
    var area_id = $state.params.area_id;
    $scope.new_participants = [];

    if (room_id) {
      var itemParams = {
        _id: room_id
      };
      Room.get(itemParams, function(response) {
        $scope.item = response;
      });
    }

    $scope.update = function(item) {
      if (!item.parent) {
          Toast.show('No se puede editar una sala principal');
          return;
      }
      item.$update(function(response) {
        $scope.set_room(response);
        $scope.selectRoom(response);
      }, LocalError.request);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomSettingsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Room,
    Toast,
    LocalError,
    Participant
  ) {
    $scope.item = {};
    var room_id = $state.params.room_id;
    var area_id = $state.params.area_id;
    $scope.new_participants = [];

    if (room_id) {
      var itemParams = {
        _id: room_id
      };
      Room.get(itemParams, function(response) {
        $scope.item = response;
      });
    }

    $scope.validate_if_user_is_added = function(participant) {
      var is_new = false;
      participant.rooms.forEach(function(item) {
        if (room_id == item) {
          is_new = true;
        }
      });
      return is_new;
    }

    $scope.remove_participant_to_room = function(participant) {
      var rooms = [];
      participant.rooms.forEach(function(item) {
        if (room_id != item) {
          rooms.push(item);
        }
      });
      participant.rooms = rooms;
      participant.$update(function(response) {
        Toast.show('El participante fue actualizado');
      });
    };

    $scope.validate_if_user_is_not_added = function(participant) {
        var is_new = true;
        participant.rooms.forEach(function(item) {
          if (room_id == item) {
            is_new = false;
          }
        });
        return is_new;
    }

    $scope.add_participant_to_room = function(participant, $index) {
      var is_new = true;
      participant.rooms.forEach(function(item) {
        if (room_id == item) {
          is_new = false;
        }
      });
      if (is_new) {
        participant.rooms.push(room_id);
        participant.$update(function(response) {
          Toast.show('El participante fue actualizado');
        });
      } else {
        $scope.remove_participant_to_room(participant, $index);
      }
    };

    // pagination
    $scope.search = {
      alive: false
    };
    $scope.query = {
      area_id: area_id,
      limit: 25,
      page: 1
    };

    function success(participants) {
      $scope.participants = participants;
    };

    $scope.getParticipants = function() {
      Participant.search($scope.query, success);
    };

    $scope.getParticipants();

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    var path = 'app/attendance/detail/room/reports';

    $stateProvider.state('attendance.detail.room.reports', {
      url: '/reports/events/:event_id',
      templateUrl: path + '/index.html',
      controller: 'AttendanceReportsController'
    });
    $stateProvider.state('attendance.detail.room.reports.pieful', {
      url: '/pieful',
      templateUrl: path + '/pieful/index.html',
      controller: 'AttendanceReportsPiefulController'
    });
    $stateProvider.state('attendance.detail.room.reports.arrive', {
      url: '/arrive',
      templateUrl: path + '/arrive/index.html',
      controller: 'AttendanceReportsArriveController'
    });
    $stateProvider.state('attendance.detail.room.reports.donut', {
      url: '/donut',
      templateUrl: path + '/donut/index.html',
      controller: 'AttendanceReportsDonutController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceReportsController', controller);

  /** @ngInject */
  function controller($scope,
    $state,
    Global,
    Store,
    HelperEvent,
    $mdDialog,
    Event,
    LocalError
  ) {
    HelperEvent.init($scope);

    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;
    $scope.event = null;
    $scope.bookmark = {
      limit: 20,
      page: 1
    };

    $scope.go_to_take_attendance = function(route) {
      $state.go(route);
    }

    Event.get({
      _id: event_id
    }, function(res) {
      $scope.event = res;
    }, LocalError.request);
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailQrController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Participant,
    Config,
    Store,
    Group,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.isId = true;
    $scope.idLabel = 'md-primary';
    $scope.codeLabel = null;
    $scope.participants = [];
    $scope.search = {
      alive: false
    };

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    $scope.size = parseInt(Store.load('print_size', true)) || 100;
    Store.save('print_limit', $scope.limit, true);
    Store.save('print_size', $scope.size, true);
    $scope.query = {
      area_id: area_id,
      rooms: room_id,
      page: 1,
      order: Config.loadOrder()
    };

    function success(participants) {
      $scope.updateParticipantList(participants);
    }

    $scope.getParticipants = function() {
      $scope.query.limit = $scope.limit;
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };

    $scope.updateParticipantList = function(participants) {
      participants.forEach(function(participant) {
        participant.qr = $scope.buildQrText(participant);
      });
      $scope.participants = participants;
    };

    $scope.changeIdentificar = function() {
      $scope.isId = !$scope.isId;
      if ($scope.isId) {
        $scope.idLabel = 'md-primary';
        $scope.codeLabel = null;
      } else {
        $scope.idLabel = null;
        $scope.codeLabel = 'md-primary';
      }
      $scope.updateParticipantList($scope.participants);
    };

    $scope.getParticipants();
    // end pagination

    $scope.next = function() {
      $scope.query.page += 1;
      $scope.getParticipants();
    };

    $scope.reset = function() {
      $scope.query.page = 1;
      $scope.getParticipants();
    };

    $scope.previous = function() {
      $scope.query.page -= 1;
      $scope.getParticipants();
    };

    $scope.updateDefaultData = function() {
      Store.save('print_limit', $scope.limit, true);
      Store.save('print_size', $scope.size, true);
    }

    $scope.print = function() {
      var url = null;
      if ($scope.query.groups) {
        url = "/#/print/qr/areas/{area_id}/rooms/{room_id}/groups/{group_id}/page/{page}?type={type}"
        .replace('{area_id}', area_id)
        .replace('{room_id}', room_id)
        .replace('{group_id}', $scope.query.groups)
        .replace('{type}', $scope.isId ? 'id' : 'code')
        .replace('{page}', $scope.query.page);
      } else {
        url = "/#/print/qr/areas/{area_id}/rooms/{room_id}/page/{page}?type={type}"
        .replace('{area_id}', area_id)
        .replace('{room_id}', room_id)
        .replace('{type}', $scope.isId ? 'id' : 'code')
        .replace('{page}', $scope.query.page);
      }
      $scope.print_url = url;
    }

    $scope.buildQrText = function(participant) {
      if (!participant) {
        throw new Error('participant is not defined');
      }
      if (!participant.uid) {
        throw new Error('participant UID is not defined');
      }
      if ($scope.isId) {
          return participant._id;
      }
      return participant.uid;
    }

    // filter
    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    }

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };

    $scope.discartGroup = function() {
      $scope.select.group_id = null;
      delete $scope.query.groups;
      $scope.getParticipants();
    }

    $scope.selectGroup = function() {
      var group_id = $scope.select.group_id;
      $scope.query.groups = group_id;
      $scope.getParticipants();
    };

    // groups
    $scope.select = {
      group_id: null
    };

    Group.query({
      area_id: area_id,
      room_id: room_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/room/people';
    
    $stateProvider.state('attendance.detail.room.people.main', {
      url: '/main',
      templateUrl: base_url + '/main/index.html',
      controller: 'AreaDetailRoomPeopleMainController'
    });
    $stateProvider.state('attendance.detail.room.people.create', {
      url: '/create',
      templateUrl: base_url + '/create/index.html',
      controller: 'AreaDetailRoomPeopleCreateController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomPeopleController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    HelperDetailRoute,
    HelperParticipant,
    Participant,
    Group,
    LocalError
  ) {
    // HelperParticipant.init($scope);
    //
    // var area_id = $state.params.area_id;
    // var room_id = $state.params.room_id;
    //
    // $scope.search = {
    //   alive: false
    // };
    //
    // // helper routes
    // $scope.goToParticipant = HelperDetailRoute.goToParticipant;
    //
    // // participants
    // $scope.createParticipant = HelperParticipant.createParticipant;
    // $scope.loadParticipants = HelperParticipant.loadParticipants;
    //
    //
    // $scope.loadParticipantById = function(participant) {
    //   console.log(participant);
    // }
    //
    // // groups
    // $scope.select = {
    //   group: null
    // };
    //
    // Group.query({
    //   area_id: area_id,
    //   room_id: room_id
    // }, function(response) {
    //   $scope.groups = response;
    // }, LocalError.request);
    //
    // $scope.discartGroup = function() {
    //   $scope.select.group = null;
    //   delete $scope.query.groups;
    //   $scope.getParticipants();
    // }
    //
    // $scope.selectGroup = function() {
    //   var group_id = $scope.select.group;
    //   $scope.query.groups = group_id;
    //   $scope.getParticipants();
    // };
    //
    // // options
    // $scope.goToOptions = function() {
    //   $state.go('attendance.detail.room.options', {
    //     area_id: area_id,
    //     room_id: room_id
    //   });
    // };
    //
    // // pagination
    // $scope.query = {
    //   area_id: area_id,
    //   rooms: room_id,
    //   limit: 21,
    //   page: 1
    // };
    //
    // function success(participants) {
    //   $scope.participants = participants;
    // };
    //
    // $scope.getParticipants = function() {
    //   $scope.promise = Participant.search($scope.query, success).$promise;
    // };
    //
    // $scope.cancel_search = function() {
    //   delete $scope.query.last_name;
    //   delete $scope.query.first_name;
    //   $scope.search.alive = false;
    //   $scope.getParticipants();
    // }
    //
    // $scope.search_participant = function(last_name, first_name) {
    //   $scope.query.last_name = last_name  == '' ? null : last_name;
    //   $scope.query.first_name = first_name  == '' ? null : first_name;
    //   $scope.getParticipants();
    // };
    //
    // $scope.init = function() {
    //   console.log('init');
    //   $scope.getParticipants();
    // }
    // $scope.init();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailImportController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Participant,
    Upload,
    LocalError,
    Toast,
    Files,
    Group,
    UploadFiles
  ) {
    $scope.item = {
      // file: '65317b9b6b6ba7233e43237c18e67e5a.xlsx'
    };
    UploadFiles.init($scope);
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.url = Global.PATH_ATT + '/assets/participants.xlsx';
    $scope.participants = [];
    $scope.selected = [];
    $scope.upload = UploadFiles.upload;

    $scope.buildParticipantObjects = function(participants) {
      var result = [];
      participants.forEach(function(item) {
        result.push({
          // counter_id: Global.counter._id,
          area_id: $state.params.area_id,
          rooms: [$state.params.room_id],
          uid: item[0].toString(),
          // last_name: item[1].toUpperCase(),
          last_name: item[1],
          first_name: item[2],
          email: item[3] || 'none',
          cel: item[4] || 'none',
          ci: item[5] || 'none',
          address: item[6] || 'none',
          image: null,
          group_helper: {
            area_id: $state.params.area_id,
            room_id: $state.params.room_id,
            name: item[7] ? item[7].trim() : ''
          },
          status:  {
            key: 'in-progress',
            message: 'En proceso!'
          }
        });
      });
      return result;
    }

    $scope.importfromExcel = function() {
      if (!$scope.item.file) {
        throw new Error('Seleccione un archivo para importar los participantes');
      }
      var params = {
        'file_name': $scope.item.file
      };

      Files.read(params, function(request) {
        $scope.participants = $scope.buildParticipantObjects(request);
      });
    }
    UploadFiles.setImportCallback($scope.importfromExcel);

    $scope.createAlistOfParticipants = function() {
      // $scope.selected.forEach(function(item) {
      //   var items = $scope.selected;
      // });
      $scope.create_recursive($scope.selected, 0);
    };

    $scope.create_recursive = function(items, index) {
      if (index >= items.length) {
        return;
      }
      Participant.save_import(items[index], function(response) {
        items[index].status = {
          key: 'done',
          message: 'Guardado!'
        };
        $scope.create_recursive(items, ++index);
      }, function(err) {
        items[index].status = {
          key: 'fail',
          message: err.data.message
        };
        $scope.create_recursive(items, ++index);
        LocalError.request(err);
      });
    };

    $scope.create = function(item) {
      Participant.save_import(item, function(response) {
        item.status = {
          key: 'done',
          message: 'Guardado!'
        };
      }, function(err) {
        item.status = {
          key: 'fail',
          message: err.data.message
        };
        LocalError.request(err);
      });
    };

    $scope.remove_participants = function(state) {
      $scope.remove_participants_unselected(state);
      var selected = $scope.selected;
      var result = [];
      for (var i = 0; i < selected.length; i++) {
        if (state != selected[i].status.key) {
          result.push(selected[i]);
        }
      }
      $scope.selected = result;
      selected = null;
    }

    $scope.remove_participants_unselected = function(state) {
      var selected = $scope.participants;
      var result = [];
      for (var i = 0; i < selected.length; i++) {
        if (state != selected[i].status.key) {
          result.push(selected[i]);
        }
      }
      $scope.participants = result;
      selected = null;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailGroupsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Toast,
    Config,
    LocalError,
    Group,
    Store,
    Event,
    Room,
    Participant,
    State
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.groups = [];
    $scope.selected = [];
    $scope.participants = [];
    $scope.select = {
      group: null
    };
    $scope.search = {
      alive: false
    };
    $scope.chips = {
      removable: false
    };

    $scope.discartGroup = function() {
      $scope.select.group = null;
    }

    $scope.createGroup = function(title) {
      if (!title) {
        Toast.show('El grupo no tiene un nombre');
        return;
      }
      $scope.isCreating = false;
      var item = {
        name: title,
        room_id: room_id
      };
      $scope.title = null;
      Group.save({
        area_id: area_id
      }, item, function(response) {
        Toast.show('Se creo correctamente un nuevo grupo');
        $scope.groups.push(response);
      }, LocalError.request);
      return null;
    }

    $scope.removableChange = function() {
      $scope.chips.removable = !$scope.chips.removable ? true : false;
    }

    $scope.removeGroup = function(item, index) {
      if (!item) {
          throw new Error('item is undefined');
      }
      item.$remove(function(response) {
        $scope.groups.splice(index, 1);
      }, LocalError.request);
    }

    // participant groups
    $scope.existId = function(list, id) {
      if (!list instanceof Array) {
          throw new Error('list is not array');
      }
      var result = false;
      list.forEach(function(item) {
        if (item == id) {
          result = true;
        }
      });
      return result;
    }

    $scope.isMember = function(groups, id) {
      if (!groups) {
        throw new Error('should provide a list of groups');
      }
      var is_new = false;
      groups.forEach(function(item) {
        if (id == item) {
          is_new = true;
        }
      });
      return is_new;
    }

    $scope.addParticipantToGroup = function(participant, $index) {
        var group_id = $scope.select.group;
        if (group_id) {
          if ($scope.isMember(participant.groups, group_id)) {
            $scope.remove_participant_from_group(participant, group_id);
          } else {
            $scope.add_participant_to_group(participant, group_id);
          }
        } else {
          Toast.show('Tiene que seleccionar un grupo');
        }
    };

    $scope.remove_participant_from_group = function(participant, group_id) {
      var groups = [];
      participant.groups.forEach(function(item) {
        if (group_id != item) {
          groups.push(item);
        }
      });
      participant.groups = groups;
      participant.$update(function(response) {
        Toast.show('El participante ya no es parte de este grupo');
      });
    };

    $scope.add_participant_to_group = function(participant, group_id) {
      participant.groups.push(group_id);
      participant.$update(function(response) {
        Toast.show('El participante fue agregado al grupo');
      });
    };

    Group.query({
      area_id: area_id,
      room_id: room_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);

    $scope.select_group = function(group) {
      $scope.select.group = group._id;
    };

    // pagination
    $scope.query = {
      area_id: area_id,
      rooms: room_id,
      limit: 30,
      page: 1,
      order: Config.loadOrder()
    };

    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    }

    function success(participants) {
      $scope.participants = participants;
    }

    $scope.getParticipants = function() {
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };

    $scope.getParticipants();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailExportController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Participant,
    Upload,
    LocalError,
    Toast,
    Files,
    Reports,
    Group,
    UploadFiles
  ) {
    var room_id = $state.params.room_id;
    var area_id = $state.params.area_id;
    $scope.reports = [];

    $scope.generateReport = function() {
      if ($scope.select.group) {
        Reports.att_report_by_group({
          room_id: room_id,
          group_id: $scope.select.group
        }, function(response) {
          response.url = Global.PATH_ATT + '/assets/files/' + response.name;
          $scope.reports.push(response);
        }, LocalError.request);
      } else {
        Reports.att_report({
          room_id: room_id
        }, function(response) {
          response.url = Global.PATH_ATT + '/assets/files/' + response.name;
          $scope.reports.push(response);
        }, LocalError.request);
      }
    }

    // groups
    $scope.select = {
      group: null
    };

    $scope.discartGroup = function() {
      $scope.select.group = null;
    }

    $scope.selectGroup = function() {
    };

    Group.query({
      area_id: area_id,
      room_id: room_id,
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailCredentialsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Participant,
    Config,
    Store,
    Group,
    Global,
    Template,
    LocalError,
    AttQr,
    HelperTemplate,
    HelperTemplateType
  ) {
    var template = null;
    var background = null;
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.area_id = $state.params.area_id;
    $scope.templates = [];
    $scope.participants = [];
    $scope.search = {
      alive: false
    };

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    Store.save('print_limit', $scope.limit, true);

    $scope.query = {
      area_id: area_id,
      rooms: room_id,
      page: 1,
      order: Config.loadOrder()
    };

    function success(participants) {
      HelperTemplate.cleanup_containers();
      $scope.participants = participants;
      HelperTemplate.generate_containers($scope.participants);
      $scope.participants.forEach(function(participant) {
        var layer = HelperTemplate.get_layer(participant._id, template.config.container);
        HelperTemplateType.draw_background(layer, template.config.container, background);
        HelperTemplate.draw_template(template, layer, participant, $scope.properties);
      });
    }

    $scope.getParticipants = function() {
      $scope.query.limit = $scope.limit;
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };
    // end pagination

    $scope.next = function() {
      $scope.query.page += 1;
      $scope.getParticipants();
    };

    $scope.reset = function() {
      $scope.query.page = 1;
      $scope.getParticipants();
    };

    $scope.previous = function() {
      $scope.query.page -= 1;
      $scope.getParticipants();
    };

    $scope.updateDefaultData = function() {
      Store.save('print_limit', $scope.limit, true);
    }

    $scope.print = function() {
      var url = null;
      if ($scope.query.groups) {
        url = "/#/print/credential/{template_id}/areas/{area_id}/rooms/{room_id}/groups/{group_id}/page/{page}"
        .replace('{area_id}', area_id)
        .replace('{template_id}', template._id)
        .replace('{room_id}', room_id)
        .replace('{group_id}', $scope.query.groups)
        .replace('{page}', $scope.query.page);
      } else {
        url = "/#/print/credential/{template_id}/areas/{area_id}/rooms/{room_id}/page/{page}"
        .replace('{area_id}', area_id)
        .replace('{template_id}', template._id)
        .replace('{room_id}', room_id)
        .replace('{page}', $scope.query.page);
      }
      $scope.print_url = url;
    }

    // filter
    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    }

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    }

    $scope.discartGroup = function() {
      $scope.select.group = null;
      delete $scope.query.groups;
      $scope.getParticipants();
    }

    $scope.selectGroup = function() {
      var group_id = $scope.select.group_id;
      $scope.query.groups = group_id;
      $scope.getParticipants();
    }

    // groups
    $scope.select = {
      group: null
    };

    Group.query({
      area_id: area_id,
      room_id: room_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);

    Template.properties(function(res) {
      $scope.properties = res;
    }, LocalError.request);


    $scope.change_template = function(temp) {
      template = temp;
      $scope.build_credentials();
    }

    $scope.load_templates = function() {
      Template.query({
        area_id: area_id
      }, function(res) {
        if (res.length <= 0) {
          return;
        }
        $scope.templates = res;
        res.forEach(function(item) {
          if (item.isDefault) {
            template = item;
          }
        });
        if (!template) {
          template = res[0];
        }
        $scope.build_credentials();
      }, LocalError.request);
    };

    $scope.build_credentials = function() {
      HelperTemplateType.load_image(template.image, function(imageObject) {
        background = imageObject;
        $scope.getParticipants();
      });
    }

    $scope.load_templates();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    var path = 'app/attendance/detail/room/att';

    $stateProvider.state('attendance.detail.room.att', {
      url: '/att',
      templateUrl: path + '/onlyone/index.html',
      controller: 'AttendanceDetailRoomAttOnlyoneController'
    });
    $stateProvider.state('attendance.detail.room.unique', {
      url: '/events/:event_id/unique',
      templateUrl: path + '/unique/index.html',
      controller: 'AttendanceDetailRoomAttUniqueController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailPeopleListController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Config,
    Store,
    Participant,
    Group,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.participants = [];

    // groups
    $scope.select = {
    };
    $scope.groups = [];

    $scope.search = {
      alive: false
    };

    $scope.query = {
      area_id: area_id,
      limit: 30,
      page: 1,
      order: Config.loadOrder()
    };

    function success(participants) {
      $scope.participants = participants;
    }

    $scope.getParticipants = function() {
      $scope.promise = Participant.search_order_by($scope.query, success).$promise;
    };

    $scope.getParticipants();

    Group.query({
      area_id: area_id
    }, function(response) {
      $scope.groups = response;
    }, LocalError.request);

    $scope.discartGroup = function() {
      $scope.select.group = null;
      delete $scope.query.groups;
      $scope.getParticipants();
    }

    $scope.selectGroup = function() {
      var group_id = $scope.select.group;
      $scope.query.groups = group_id;
      $scope.getParticipants();
    };

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };

    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.search.alive = false;
      $scope.getParticipants();
    };

    $scope.openMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    $scope.go_to_participant = function(participant) {
      $state.go('attendance.detail.participant', {
        participant_id: participant._id
      });
    };
  };

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansStoresController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    AssetConfig,
    AttStore,
    Group,
    LocalError
  ) {

    var area_id = $state.params.area_id;

    $scope.createParticipant = function() {
      $state.go('attendance.detail.room.people.create', {
        area_id: area_id,
        room_id: room_id
      });
    };

    $scope.go_to_store = function(store) {
      $state.go('attendance.detail.loans.stores_update', {
        store_id: store._id
      });
    };

    // pagination
    $scope.query = {
      area_id: area_id,
      limit: 21,
      page: 1
    };

    function success(stores) {
      $scope.stores = stores;
    };

    $scope.get_stores = function() {
      $scope.promise = AttStore.pagination($scope.query, success).$promise;
    };

    $scope.get_stores();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansQrController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Asset,
    AssetConfig,
    Store,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.area_id = $state.params.area_id;
    $scope.isId = true;
    $scope.idLabel = 'md-primary';
    $scope.codeLabel = null;
    $scope.participants = [];
    $scope.search = {
      alive: false
    };

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    $scope.size = parseInt(Store.load('print_size', true)) || 100;
    Store.save('print_limit', $scope.limit, true);
    Store.save('print_size', $scope.size, true);
    $scope.query = {
      area_id: area_id,
      page: 1,
      order: AssetConfig.loadOrder()
    };

    function success(assets) {
      $scope.updateAssetList(assets);
    }

    $scope.getAssets = function() {
      $scope.query.limit = $scope.limit;
      $scope.promise = Asset.search_order_by($scope.query, success).$promise;
    };

    $scope.updateAssetList = function(assets) {
      assets.forEach(function(asset) {
        asset.qr = $scope.buildQrText(asset);
      });
      $scope.assets = assets;
    };

    $scope.changeIdentificar = function() {
      $scope.isId = !$scope.isId;
      if ($scope.isId) {
        $scope.idLabel = 'md-primary';
        $scope.codeLabel = null;
      } else {
        $scope.idLabel = null;
        $scope.codeLabel = 'md-primary';
      }
      $scope.updateAssetList($scope.assets);
    };

    $scope.getAssets();
    // end pagination

    $scope.next = function() {
      $scope.query.page += 1;
      $scope.getAssets();
    };

    $scope.reset = function() {
      $scope.query.page = 1;
      $scope.getAssets();
    };

    $scope.previous = function() {
      $scope.query.page -= 1;
      $scope.getAssets();
    };

    $scope.updateDefaultData = function() {
      Store.save('print_limit', $scope.limit, true);
      Store.save('print_size', $scope.size, true);
    }

    $scope.print = function() {
      var url = "/#/print/assets/areas/{area_id}/page/{page}?type={type}"
      .replace('{area_id}', area_id)
      .replace('{page}', $scope.query.page)
      .replace('{type}', $scope.isId ? 'id' : 'code');
      $scope.print_url = url;
    }

    $scope.buildQrText = function(asset) {
      if (!asset) {
        throw new Error('asset is not defined');
      }
      if (!asset.uid) {
        throw new Error('asset UID is not defined');
      }
      if ($scope.isId) {
          return asset._id;
      }
      return asset.uid;
    }

    // filter
    $scope.cancel_search = function() {
      delete $scope.query.name;
      $scope.search.alive = false;
      $scope.getAssets();
    }

    $scope.search_assets = function(name) {
      $scope.query.name = name  == '' ? null : name;
      $scope.getAssets();
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansAssetsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    AssetConfig,
    Asset,
    LocalError
  ) {

    var area_id = $state.params.area_id;
    $scope.order = AssetConfig.loadOrder();
    $scope.search = {
      alive: false
    };

    $scope.createParticipant = function() {
      $state.go('attendance.detail.room.people.create', {
        area_id: area_id,
        room_id: room_id
      });
    };

    $scope.go_to_asset = function(asset) {
      $state.go('attendance.detail.loans.assets_update', {
        asset_id: asset._id
      });
    };

    // pagination
    $scope.query = {
      area_id: area_id,
      limit: 21,
      page: 1
    };

    function success(assets) {
      $scope.assets = assets;
    };

    $scope.get_assets = function() {
      $scope.query.order = AssetConfig.loadOrder();
      $scope.promise = Asset.search_order_by($scope.query, success).$promise;
    };

    $scope.cancel_search = function() {
      delete $scope.query.name;
      $scope.search.alive = false;
      $scope.get_assets();
    }

    $scope.change_order = function(order) {
      $scope.order = order;
      AssetConfig.saveOrder(order);
      $scope.get_assets();
    }

    $scope.search_asset = function(name) {
      $scope.query.name = name  == '' ? null : name;
      $scope.get_assets();
    }

    $scope.get_assets();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansMainController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $mdDialog,
    Global,
    Store,
    AttStore,
    Participant,
    Group,
    Toast,
    Asset,
    AssetConfig,
    Loan,
    UUID,
    Incident,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    var store_key = 'store-config-' + area_id;
    $scope.query = {
      area_id: area_id,
      order: AssetConfig.loadOrder(),
      page: 1,
      limit: 30
    };

    $scope.search_assets = function(store, search) {
      $scope.query.name = search ? search : null;
      $scope.query.type = store.type;
      $scope.query.data_id = store._id;
      Asset.search_order_by($scope.query, function(res) {
        store.assets = res;
      }, LocalError.request);
    };

    $scope.refresh_assets = function(store) {
      Asset.pagination({
        type: store.type,
        data_id: store._id,
        page: 1,
        limit: 30
      }, function(res) {
        store.assets = res;
      }, LocalError.request);
    }

    $scope.load_store = function(store) {
      store.isCreating = false;
      if (store.type === 'store') {
        AttStore.get({
          _id: store._id
        }, function(res) {
          store.data = res;
        }, LocalError.request);
      }
      if (store.type === 'participant') {
        Participant.get({
          _id: store._id
        }, function(res) {
          store.data = res;
        }, LocalError.request);
      }
      $scope.refresh_assets(store);
    }

    $scope.stores = Store.load(store_key) || [];
    $scope.stores.forEach(function(store, index) {
      store.index = index;
      $scope.load_store(store);
    });

    $scope.remove_store = function(store, index) {
      $scope.stores.splice(index, 1);
      var store_config = Store.load(store_key) || [];
      store_config.splice(index, 1);
      Store.save(store_key, store_config);
    }

    $scope.save_asset = function(asset, store) {
      asset.area_id = area_id;
      asset.data_id = store._id;
      asset.type = store.type;
      Asset.save(asset, function(res) {
        store.isCreating = false;
        store.assets.unshift(res);
      }, LocalError.request);
    }

    $scope.open_create_asset = function(store) {
       store.isCreating = !store.isCreating;
       store.asset = {
         uid: UUID.next()
       }
    }

    $scope.move_asset = function(asset, store, index) {
      store.assets.splice(index, 1);
      var current = $scope.stores[store.index];
      var next_store = $scope.stores[store.index + 1];
      if (next_store) {
        $scope.update_asset(current, next_store, asset);
      } else {
        console.error('Store does not exist');
      }
    }

    $scope.update_asset = function(current, next, asset) {
      next.assets.unshift(asset);
      asset.data_id = next._id;
      asset.type = next.type;
      asset.$update(function(res) {
      }, LocalError.request);
      Loan.save({
        area_id: area_id,
        asset_id: asset._id,
        from: {
          _id: current._id,
          type: current.type
        },
        to: {
          _id: next._id,
          type: next.type
        }
      }, function(res) {
      }, LocalError.request);
    }

    $scope.select_store = function() {
      $mdDialog.show({
        controller: DialogSelectStoreController,
        templateUrl: 'app/attendance/detail/loans/main/select-store.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: false,
        locals: {
           area_id: area_id
        }
      })
      .then(function(answer) {
        var store_config = Store.load(store_key) || [];
        var data = {
          _id: answer._id,
          type: 'store'
        };
        store_config.push(data);
        Store.save(store_key, store_config);
        data.index = $scope.stores.length;
        $scope.stores.push(data);
        $scope.load_store(data);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    }

    $scope.select_participant = function() {
      $mdDialog.show({
        controller: DialogSelectParticipantController,
        templateUrl: 'app/attendance/detail/loans/main/select-participant.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: false,
        locals: {
           area_id: area_id
        }
      })
      .then(function(answer) {
        var store_config = Store.load(store_key) || [];
        var data = {
          _id: answer._id,
          type: 'participant'
        };
        store_config.push(data);
        Store.save(store_key, store_config);
        data.index = $scope.stores.length;
        $scope.stores.push(data);
        $scope.load_store(data);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    }

    Asset.query({
      area_id: area_id
    }, function(res) {
      $scope.assets = res;
      console.log(res);
    }, LocalError.request);
  };

})();

function DialogSelectStoreController($scope, $mdDialog, LocalError, UUID, Event, AttStore, area_id) {
  $scope.stores = [];

  AttStore.query({
    area_id: area_id
  }, function(res) {
    $scope.stores = res;
  });

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.select_item = function(store) {
    $scope.answer(store);
  }

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.create_store = function(item) {
    item.area_id = area_id;
    AttStore.save(item, function(res) {
      $scope.stores.unshift(res);
    });
  };

  $scope.store_print = function(store) {
  };

  $scope.store_remove = function(item, index) {
    item.$remove({
      _id: item._id
    }, function(res) {
      $scope.stores.splice(index, 1);
    }, LocalError.request);
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

function DialogSelectParticipantController($scope, $mdDialog, LocalError, UUID, Participant, AttStore, UploadImages, area_id) {
  $scope.participants = [];
  $scope.query = {
    area_id: area_id,
    limit: 15,
    page: 1
  };
  $scope.loadImage = UploadImages.loadImage;

  function success(participants) {
    $scope.participants = participants;
  }

  $scope.getParticipants = function() {
    $scope.promise = Participant.search($scope.query, success).$promise;
  };

  $scope.select_participant = function(participant) {
    $scope.answer(participant);
  };

  $scope.search_participant = function(last_name, first_name) {
    $scope.query.last_name = last_name  == '' ? null : last_name;
    $scope.query.first_name = first_name  == '' ? null : first_name;
    $scope.getParticipants();
  };

  $scope.cancel_search = function() {
    delete $scope.query.last_name;
    delete $scope.query.first_name;
    $scope.participant = null;
    $scope.getParticipants();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };

  $scope.getParticipants();
}

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailIncidentListController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Global,
    Store,
    Participant,
    Group,
    Toast,
    Incident,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.selected = [];
    $scope.incidents = [];
    $scope.participant = null;
    $scope.participants = [];
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    var end = new Date();
    end.setHours(23, 59, 0, 0);
    $scope.timer = {
      start: start,
      end: end
    };
    $scope.query = {
      area_id: area_id,
      limit: 15,
      page: 1
    };

    function success(participants) {
      $scope.participants = participants;
    }

    $scope.getParticipants = function() {
      $scope.promise = Participant.search($scope.query, success).$promise;
    };
    $scope.select_participant = function(participant) {
      $scope.participant = participant;
    };

    $scope.getParticipants();

    $scope.search_participant = function(last_name, first_name) {
      $scope.query.last_name = last_name  == '' ? null : last_name;
      $scope.query.first_name = first_name  == '' ? null : first_name;
      $scope.getParticipants();
    };

    $scope.cancel_search = function() {
      delete $scope.query.last_name;
      delete $scope.query.first_name;
      $scope.participant = null;
      $scope.getParticipants();
    };

    $scope.unselect_participant = function() {
      $scope.participant = null;
    };

    $scope.find_markers = function(timer) {
      if (!$scope.gate) {
        Toast.show('No esta seleccionado un incidente');
        return;
      }
      if ($scope.gate.type === 'pair' && !$scope.participant) {
        Toast.show('Tiene que seleccionar un particiapnte');
        return;
      }
      $scope.markers = [];
      var data = {
        start: JSON.stringify(timer.start),
        end: JSON.stringify(timer.end)
      };
      data.start = data.start.slice(1, -1);
      data.end = data.end.slice(1, -1);

      if ($scope.participant) {
        data.participant_id = $scope.participant._id;
      }

      Incident.search({
        area_id: area_id,
        gate_id: $scope.gate._id
      }, data, function(res) {
        if ($scope.gate.type === 'pair') {
          try {
            $scope.incidents = $scope.merge_pair(res);
          } catch (e) {
            console.log(e);
          }
          return;
        }
        $scope.incidents = res;
      });
    };

    $scope.merge_pair = function(incidents) {
      var result = [];
      var tmp = null;
      for (var i = 0; i < incidents.length; i++) {
        var incident = incidents[i];
        if (!tmp) {
          tmp = {
            in: null,
            out: null
          };
        }
        tmp[incident.state] = incident;
        var next = incidents[i + 1];
        if (!next) {
          result.push(tmp);
          break;
        }
        if (next.state === 'in' || incident.state === 'out') {
          result.push(tmp);
          tmp = null;
        }
      }
      return result;
    };
  };

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/provider/studio';

    $stateProvider.state('attendance.provider.studio.create', {
      url: '/create',
      templateUrl: base_url + '/create/index.html',
      controller: 'ProviderStudioCreateController'
    });
    $stateProvider.state('attendance.provider.studio.list', {
      url: '/list',
      templateUrl: base_url + '/list/index.html',
      controller: 'ProviderStudioListController'
    });
    $stateProvider.state('attendance.provider.studio.update', {
      url: '/update/:studio_id',
      templateUrl: base_url + '/update/index.html',
      controller: 'ProviderStudioUpdateController'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('ProviderStudioController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    LocalError
  ) {
    $scope.create_screen = function() {
      $state.go('attendance.provider.studio.create');
    };

    $scope.selectItem = function(item) {
      $state.go('attendance.provider.studio.update', {
        studio_id: item._id
      });
    };

    $scope.deleteItem = function(item) {
      Toast.show('Cargando...');
      item.$delete(function(response) {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.provider.studio.list');
      }, LocalError.request);
    };

    $scope.updateItem = function(item) {
      Toast.show('Cargando...');
      item.$update(function(response) {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.provider.studio.list');
      }, LocalError.request);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('PrintQrController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $location,
    Participant,
    Config,
    Store,
    LocalError
  ) {
    var room_id = $state.params.room_id;
    var area_id = $state.params.area_id;
    var group_id = $state.params.group_id || null;
    var page = $state.params.page;
    var type = $location.search().type;

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    $scope.size = parseInt(Store.load('print_size', true)) || 100;
    Store.save('print_limit', $scope.limit, true);
    Store.save('print_size', $scope.size, true);

    var query = {
      area_id: area_id,
      rooms: room_id,
      groups: group_id,
      limit: $scope.limit,
      page: page,
      order: Config.loadOrder()
    };

    Participant.search_order_by(query, function(response) {
      $scope.updateParticipantList(response);
    }, LocalError.request);

    $scope.updateParticipantList = function(participants) {
      participants.forEach(function(participant) {
        participant.qr = $scope.buildQrText(participant);
      });
      $scope.participants = participants;
    };

    $scope.buildQrText = function(participant) {
      if (!participant) {
        throw new Error('participant is not defined');
      }
      if (!participant.uid) {
        throw new Error('participant UID is not defined');
      }
      console.log(type);
      if (type === 'code') {
          return participant.uid;
      }
      return participant._id;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('PrintCredentialsController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Participant,
    Config,
    Store,
    Group,
    Global,
    Template,
    LocalError,
    AttQr,
    HelperTemplate,
    HelperTemplateType
  ) {
    var room_id = $state.params.room_id;
    var area_id = $state.params.area_id;
    var template_id = $state.params.template_id;
    var group_id = $state.params.group_id || null;
    var page = $state.params.page;
    var template = null;
    var background = null;

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    Store.save('print_limit', $scope.limit, true);

    var query = {
      area_id: area_id,
      rooms: room_id,
      groups: group_id,
      limit: $scope.limit,
      page: page,
      order: Config.loadOrder()
    };

    $scope.getParticipants = function() {
      Participant.search_order_by(query, function(response) {
        $scope.participants = response;
        HelperTemplate.generate_containers($scope.participants);
        $scope.participants.forEach(function(participant) {
          var layer = HelperTemplate.get_layer(participant._id, template.config.container);
          HelperTemplateType.draw_background(layer, template.config.container, background);
          HelperTemplate.draw_template(template, layer, participant, $scope.properties);
        });
      }, LocalError.request);
    }

    Template.properties(function(res) {
      $scope.properties = res;
      Template.get({
        _id: template_id
      }, function(res) {
        template = res;
        $scope.build_credentials();
      });
    }, LocalError.request);

    $scope.build_credentials = function() {
      HelperTemplateType.load_image(template.image, function(imageObject) {
        background = imageObject;
        $scope.getParticipants();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('PrintAssetQrController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $location,
    Asset,
    AssetConfig,
    Store,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    var page = $state.params.page;
    var type = $location.search().type;

    $scope.limit = parseInt(Store.load('print_limit', true)) || 20;
    $scope.size = parseInt(Store.load('print_size', true)) || 100;
    Store.save('print_limit', $scope.limit, true);
    Store.save('print_size', $scope.size, true);

    var query = {
      area_id: area_id,
      limit: $scope.limit,
      page: page,
      order: AssetConfig.loadOrder()
    };

    Asset.search_order_by(query, function(response) {
      $scope.updateAssetList(response);
    }, LocalError.request);

    $scope.updateAssetList = function(assets) {
      assets.forEach(function(asset) {
        asset.qr = $scope.buildQrText(asset);
      });
      $scope.assets = assets;
    };

    $scope.buildQrText = function(asset) {
      if (!asset) {
        throw new Error('asset is not defined');
      }
      if (!asset.uid) {
        throw new Error('asset UID is not defined');
      }
      console.log(type);
      if (type === 'code') {
          return asset.uid;
      }
      return asset._id;
    }
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
      var base_url = 'app/attendance/detail/template';

      $stateProvider.state('attendance.detail.template.update', {
        url: '/update/:template_id',
        templateUrl: base_url + '/update/index.html',
        controller: 'AreaDetailTemplateUpdateController'
      });
      $stateProvider.state('attendance.detail.template.create', {
        url: '/create',
        templateUrl: base_url + '/create/index.html',
        controller: 'AreaDetailTemplateCreateController'
      });
      $stateProvider.state('attendance.detail.template.main', {
        url: '/main',
        templateUrl: base_url + '/main/index.html',
        controller: 'AreaDetailTemplateMainController'
      });
    }

  })();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperTemplate', service);

  function service($state, Gate, LocalError, Global, AttQr, moment) {
    var IMAGE_PATH = Global.PATH_FILES + '/assets/images/original/';

    return {
      select_value: function(key, properties) {
        var value = null;
        properties.forEach(function(property) {
          if (property.key === key) {
            value = property;
          }
        });
        return value || { value: 'NULL' };
      },
      cleanup_containers: function() {
        var container = $('#credential-container');
        container.empty();
      },
      generate_containers: function(participants) {
        var container = $('#credential-container');
        participants.forEach(function(participant) {
          container.append([
            '<div style="page-break-inside:avoid;float:left;padding:1px;">',
            '   <div id="' + participant._id + '"></div>',
            '</div>'
          ].join(''));
        });
      },
      get_layer: function(container_id, config) {
        var stage = new Konva.Stage({
            container: container_id,
            width: config.width,
            height: config.height
        });
        var layer = new Konva.Layer();
        stage.add(layer);
        return layer;
      },
      draw_qr: function(layer, item, value) {
         var canvas = document.createElement('canvas');
         var qr_image_string = AttQr.render(
           canvas,
           value,
           3,
           0,
           item.size,
           'text'
         );
        var qr = new Image();
        qr.src = qr_image_string;
        qr.onload = function() {
          var qr_canvas = new Konva.Image({
            image: qr,
            x: item.x,
            y: item.y,
            width: item.size,
            height: item.size
          });
          layer.add(qr_canvas);
          layer.draw();
        };
      },
      draw_text: function(layer, item, value) {
        var simpleText = new Konva.Text({
          x: item.x,
          y: item.y,
          fontSize: item.size,
          text: value,
          fontFamily: item.font,
          fill: '#000000',
          padding: 10
        });
        layer.add(simpleText);
        layer.draw();
      },
      draw_indexer: function(layer, container, value) {
        var simpleText = new Konva.Text({
          x: 10,
          y: container.height - 15,
          fontSize: 12,
          text: value,
          fontFamily: 'monospace',
          fill: '#444444'
        });
        layer.add(simpleText);
        layer.draw();
      },
      draw_logo: function(layer, container) {
        var shadow = new Konva.Text({
          x: container.width - 145,
          y: container.height - 15,
          fontSize: 12,
          text: 'www.attendance.ninja',
          fontFamily: 'monospace',
          fill: '#444444',
        });
        layer.add(shadow);
        layer.draw();
      },
      draw_image: function(layer, item, value) {
        var url = value ? IMAGE_PATH + value : 'assets/images/participant.png';
        var qr = new Image();
        qr.src = url;
        qr.onload = function() {
          var qr_canvas = new Konva.Image({
            image: qr,
            x: item.x,
            y: item.y,
            width: item.width,
            height: item.height
          });
          layer.add(qr_canvas);
          layer.draw();
        };
      },
      draw_template: function(template, layer, participant, properties) {
        var self = this;
        template.config.config.forEach(function(item) {
            var value = self.select_value(item.key, properties);
            switch (value.type) {
              case 'image':
                self.draw_image(layer, item, participant[item.key]);
                break;
              case 'qr':
                self.draw_qr(layer, item, participant[item.key]);
                break;
              case 'text':
                self.draw_text(layer, item, participant[item.key]);
                break;
              default:
                  throw new Error('Type is not implemented');
            }
        });
        self.draw_logo(layer, template.config.container);
        self.draw_indexer(layer, template.config.container, participant.index);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperTemplateType', service);

  function service($state, Gate, LocalError, Global, moment) {
    var IMAGE_PATH = Global.PATH_FILES + '/assets/images/original/';

    return {
      fonts: [
        'Calibri',
        'Monospace',
        'Fantasy',
        'Courier New',
        'Comic Sans',
        'Sans-serif',
        'Serif',
        'Helvetica',
        'Verdana',
        'Gill Sans',
        'Times New Roman',
        'Georgia',
        'Arial',
        'Arial Black'
      ],
      select_value: function(key, properties) {
        var value = null;
        properties.forEach(function(property) {
          if (property.key === key) {
            value = property;
          }
        });
        return value || { value: 'NULL' };
      },
      load_image: function(file_name, callback) {
        var url = IMAGE_PATH + file_name;
        var imageObject = new Image();
        imageObject.src = url;
        imageObject.onload = function() {
          callback(imageObject);
        };
      },
      get_layer: function(config) {
        var stage = new Konva.Stage({
            container: 'att-canvas-container',
            width: config.width,
            height: config.height
        });
        var layer = new Konva.Layer();
        stage.add(layer);
        return layer;
      },
      draw_background: function(layer, config, imageObject) {
        var background = new Konva.Image({
          x: 0,
          y: 0,
          image: imageObject,
          width: config.width,
          height: config.height
        });
        layer.add(background);
        layer.draw();
      },
      draw_default_image: function(layer, item, callback) {
        var qr = new Image();
        qr.src = item.data;
        qr.onload = function() {
          var qr_canvas = new Konva.Image({
            image: qr,
            x: item.x,
            y: item.y,
            width: item.width,
            height: item.height,
            draggable: true
          });
          qr_canvas.att_key = item.key;
          qr_canvas.att_type = 'image';
          qr_canvas.on('mousedown', function() {
            callback(this);
          });
          layer.add(qr_canvas);
          layer.draw();
        };
      },
      draw_default_qr: function(layer, item, callback) {
        var qr = new Image();
        qr.src = item.data;
        qr.onload = function() {
          var qr_canvas = new Konva.Image({
            image: qr,
            x: item.x,
            y: item.y,
            width: item.size,
            height: item.size,
            draggable: true
          });
          qr_canvas.att_key = item.key;
          qr_canvas.att_type = 'qr';
          qr_canvas.on('mousedown', function() {
            callback(this);
          });
          layer.add(qr_canvas);
          layer.draw();
        };
      },
      draw_text: function(layer, item, properties, callback) {
        var property = this.select_value(item.key, properties);
        var simpleText = new Konva.Text({
          x: item.x,
          y: item.y,
          fontSize: item.size,
          text: '{{' + property.value + '}}',
          fontFamily: item.font,
          padding: 10,
          draggable: true
        });
        simpleText.att_key = item.key;
        simpleText.att_type = 'text';
        simpleText.on('mousedown', function() {
          callback(this);
        });
        layer.add(simpleText);
        layer.draw();
      },
      get_canvas_config: function(layer) {
        var config = [];
        var children = layer.getChildren();
        children.forEach(function(child) {
          if (child.att_key) {
            switch (child.className) {
              case 'Text':
                  config.push({
                    key: child.att_key,
                    x: child.x(),
                    y: child.y(),
                    size: child.textHeight,
                    font: child.fontFamily()
                  });
                break;
              case 'Image':
                  if (child.att_type === 'qr') {
                    config.push({
                      key: child.att_key,
                      x: child.x(),
                      y: child.y(),
                      size: child.getWidth()
                    });
                  } else {
                    config.push({
                      key: child.att_key,
                      x: child.x(),
                      y: child.y(),
                      width: child.getWidth(),
                      height: child.getHeight()
                    });
                  }
                break;
              default:
                throw new Error('type is not implemented');
            }
          }
        });
        return config;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailTemplateController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    Template,
    UploadImages,
    Store,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    var IMAGE_PATH = Global.PATH + '/assets/images/original/';

    $scope.properties = [];
    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;

    if (!area_id) {
      throw new Error('area_id us indefined');
    }

    $scope.load_templates = function() {
      Template.query({
        area_id: area_id
      }, function(res) {
        $scope.templates = res;
      }, LocalError.request);
    };

    $scope.select_template = function(template) {
      template.isDefault = true;
      template.$update(function(res) {
      }, LocalError.request);
      $scope.templates.forEach(function(item) {
        if (template._id !== item._id) {
          item.isDefault = false;
          item.$update(function(res) {
          }, LocalError.request);
        }
      })
    };

    $scope.load_templates();

    $scope.go_to_update = function(template) {
      $scope.templates.forEach(function(item) {
        item.selected = false;
      })
      template.selected = true;
      $state.go('attendance.detail.template.update', {
        template_id: template._id
      });
    };

    Template.properties(function(res) {
      $scope.properties = res;
    }, LocalError.request);
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/studio';

    $stateProvider.state('attendance.detail.studio.create', {
      url: '/create',
      templateUrl: base_url + '/create/index.html',
      controller: 'DetailStudioCreateController'
    });
    $stateProvider.state('attendance.detail.studio.list', {
      url: '/list',
      templateUrl: base_url + '/list/index.html',
      controller: 'DetailStudioListController'
    });
    $stateProvider.state('attendance.detail.studio.update', {
      url: '/update/:studio_id',
      templateUrl: base_url + '/update/index.html',
      controller: 'DetailStudioUpdateController'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailStudioController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    LocalError
  ) {
    $scope.create_screen = function() {
      $state.go('attendance.detail.studio.create');
    };

    $scope.selectItem = function(item) {
      $state.go('attendance.detail.studio.update', {
        studio_id: item._id
      });
    };

    $scope.deleteItem = function(item) {
      Toast.show('Cargando...');
      item.$delete(function(response) {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.detail.studio.list');
      }, LocalError.request);
    };

    $scope.updateItem = function(item) {
      Toast.show('Cargando...');
      item.$update(function(response) {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.detail.studio.list');
      }, LocalError.request);
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('wargos')
      .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
      var base_url = 'app/attendance/detail/settings';

      $stateProvider.state('attendance.detail.settings.main', {
        url: '/main',
        templateUrl: base_url + '/main/index.html',
        controller: 'AreaDetailSetMainController'
      });
      $stateProvider.state('attendance.detail.settings.states', {
        url: '/states',
        templateUrl: base_url + '/states/index.html',
        controller: 'AtteDetailSetStatesController'
      });
      $stateProvider.state('attendance.detail.settings.update', {
        url: '/update',
        templateUrl: base_url + '/update/index.html',
        controller: 'AreaDetailSetUpdateController'
      });
      $stateProvider.state('attendance.detail.settings.administrators', {
        url: '/administrators',
        templateUrl: base_url + '/administrators/index.html',
        controller: 'AreaDetailSetAdministratorsController'
      });
      $stateProvider.state('attendance.detail.settings.udfs', {
        url: '/udfs',
        templateUrl: base_url + '/udfs/index.html',
        controller: 'AreaDetailSetUdfController'
      });
    }
  })();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailSettingsController', controller);

  /** @ngInject */
  function controller($scope) {
    $scope.openEventMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/room';

    $stateProvider.state('attendance.detail.room.people', {
      url: '/people',
      templateUrl: base_url + '/people/index.html',
      controller: 'AreaDetailRoomPeopleController'
    });
    $stateProvider.state('attendance.detail.room.import', {
      url: '/import',
      templateUrl: base_url + '/import/index.html',
      controller: 'AreaDetailImportController'
    });
    $stateProvider.state('attendance.detail.room.export', {
      url: '/export',
      templateUrl: base_url + '/export/index.html',
      controller: 'AreaDetailExportController'
    });
    $stateProvider.state('attendance.detail.room.qr', {
      url: '/qr',
      templateUrl: base_url + '/qr/index.html',
      controller: 'AreaDetailQrController'
    });
    $stateProvider.state('attendance.detail.room.credentials', {
      url: '/credentials',
      templateUrl: base_url + '/credentials/index.html',
      controller: 'AreaDetailCredentialsController'
    });
    $stateProvider.state('attendance.detail.room.groups', {
      url: '/groups',
      templateUrl: base_url + '/groups/index.html',
      controller: 'AreaDetailGroupsController'
    });
    $stateProvider.state('attendance.detail.room.update', {
      url: '/update',
      templateUrl: base_url + '/update/index.html',
      controller: 'AreaDetailRoomUpdateController'
    });
    $stateProvider.state('attendance.detail.room.settings', {
      url: '/settings',
      templateUrl: base_url + '/settings/index.html',
      controller: 'AreaDetailRoomSettingsController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailRoomController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Room,
    LocalError,
    Toast,
    $mdDialog
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    $scope.set_room = function(room) {
        $scope.room = room;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/people';

    $stateProvider.state('attendance.detail.people.main', {
      url: '/main',
      templateUrl: base_url + '/list/index.html',
      controller: 'AttendanceDetailPeopleListController'
    });
    $stateProvider.state('attendance.detail.people.gate', {
      url: '/gate',
      abstract: true,
      template: '<ui-view/>'
    });
    $stateProvider.state('attendance.detail.people.gate.create', {
      url: '/create',
      templateUrl: base_url + '/gate/create/index.html',
      controller: 'AttendanceDetailPeopleGateCreateController'
    });
    $stateProvider.state('attendance.detail.people.gate.update', {
      url: '/update/:gate_id',
      templateUrl: base_url + '/gate/update/index.html',
      controller: 'AttendanceDetailPeopleGateUpdateController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailPeopleController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $mdDialog,
    Gate,
    Toast,
    Incident,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.gate = null;
    $scope.gates = [];

    // gate
    Gate.query({
      area_id: area_id
    }, function(res) {
        $scope.gates = res;
    }, LocalError.request);

    $scope.save_incident = function(participant, config) {
        if (!$scope.gate) {
          Toast.show('No esta seleccionado un incidente');
        }
        var item = {
          area_id: area_id,
          gate_id: $scope.gate._id,
          participant_id: participant._id,
          text: config.text,
          state: config.option.key
        };
        Incident.save(item, function(res) {
          Toast.show('El incidente ya fue guardado');
        }, LocalError.request);
    };

    $scope.select_gate = function(gate) {
      $scope.gate = gate;
    }

    $scope.go_to_gate = function(gate) {
      $state.go('attendance.detail.people.gate.update', {
        gate_id: gate._id
      });
    }

    // Dialog
    $scope.select_incident = function(participant, index, ev) {
      if (!$scope.gate) {
        Toast.show('No esta seleccionado un incidente');
        return;
      }
      $scope.show_options_dialog(ev, $scope.gate, function(item) {
        $scope.show_incident_dialog(ev, item, function(res) {
          $scope.save_incident(participant, res);
        });
      });
    }

    $scope.show_options_dialog = function(ev, item, cb) {
      $mdDialog.show({
        controller: DialogSlectListController,
        templateUrl: 'app/attendance/detail/people/list/list.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        fullscreen: false, // Only for -xs, -sm breakpoints.
        locals: {
           item: item
        }
      })
      .then(function(answer) {
        cb(answer);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    };

    $scope.show_incident_dialog = function(ev, item, cb) {
      $mdDialog.show({
        controller: DialogIncidentController,
        templateUrl: 'app/attendance/detail/people/list/incident.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        fullscreen: false, // Only for -xs, -sm breakpoints.
        locals: {
           item: item
        }
      })
      .then(function(answer) {
        cb(answer);
      }, function() {
        console.info('You cancelled the dialog.');
      });
    };
  };

  function DialogSlectListController($scope, $mdDialog, item) {
    var convert = function(obj) {
      return [{ key: 'in', value: obj.in}, { key: 'out', value: obj.out}];
    }
    $scope.item = null;
    $scope.items = (item.type === 'pair') ? convert(item.pair) : item.states;

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }

  function DialogIncidentController($scope, $mdDialog, item) {
    $scope.item = {
      option: item
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailParticipantController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $window,
    Participant,
    LocalError,
    UploadImages,
    Toast,
    Room,
    Note
  ) {
    var area_id = $state.params.area_id;
    var participant_id = $state.params.participant_id;
    UploadImages.init($scope);
    $scope.upload = UploadImages.upload;
    $scope.item = {};
    $scope.update = {
      text: ''
    };

    if (participant_id) {
      var itemParams = {
        _id: participant_id
      };
      Participant.get(itemParams, function(response) {
        $scope.item = response;
      });
    }

    $scope.remove = function(item) {
      var itemParams = {
        _id: participant_id
      };
      item.$remove(itemParams, function(response) {
        $scope.goToBack();
      }, LocalError.request);
    }

    $scope.update = function(item) {
      var itemParams = {
        _id: participant_id
      };
      item.$update(itemParams, function(response) {
        $scope.goToBack();
      }, LocalError.request);
    }

    $scope.load_notes = function(room) {
      Note.find_room_notes({
        room_id: room._id,
        participant_id: participant_id
      }, function(response) {
        response.forEach(function(note) {
          note.start = new Date(note.start);
          note.end = new Date(note.end);
        });
        room.notes = response;
      }, LocalError.request);
    }

    Room.query({
      area_id: area_id
    }, function(response) {
      $scope.rooms = response;
      response.forEach(function(item) {
        $scope.load_notes(item);
      });
    }, LocalError.request);

    $scope.update_note = function(note) {
      note.text = $scope.update.text;
      var event = note.event;
      note.$update(function(response) {
        response.event = event;
        Toast.show('Se guardo correctamente la nota');
      });
    }

    $scope.remove_note = function(note, notes, index) {
      note.$remove(function(response) {
        notes.splice(index, 1);
        Toast.show('Se elimino la nota');
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/loans';

    $stateProvider.state('attendance.detail.loans', {
      url: '/loans',
      templateUrl: base_url + '/index.html',
      controller: 'AttendanceDetailLoansController'
    });
    $stateProvider.state('attendance.detail.loans.main', {
      url: '/main',
      templateUrl: base_url + '/main/index.html',
      controller: 'AttendanceDetailLoansMainController'
    });
    $stateProvider.state('attendance.detail.loans.objects', {
      url: '/assets',
      templateUrl: base_url + '/objects/index.html',
      controller: 'AttendanceDetailLoansAssetsController'
    });
    $stateProvider.state('attendance.detail.loans.qr', {
      url: '/qr',
      templateUrl: base_url + '/qr/index.html',
      controller: 'AttendanceDetailLoansQrController'
    });
    $stateProvider.state('attendance.detail.loans.stores', {
      url: '/stores',
      templateUrl: base_url + '/stores/index.html',
      controller: 'AttendanceDetailLoansStoresController'
    });
    $stateProvider.state('attendance.detail.loans.stores_create', {
      url: '/stores/create',
      templateUrl: base_url + '/stores/create/index.html',
      controller: 'AttendanceDetailLoansStoresCreateController'
    });
    $stateProvider.state('attendance.detail.loans.stores_update', {
      url: '/stores/:store_id',
      templateUrl: base_url + '/stores/update/index.html',
      controller: 'AttendanceDetailLoansStoresUpdateController'
    });
    $stateProvider.state('attendance.detail.loans.assets_update', {
      url: '/assets/:asset_id',
      templateUrl: base_url + '/objects/update/index.html',
      controller: 'AttendanceDetailLoansAssetsUpdateController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailLoansController', controller);

  /** @ngInject */
  function controller(
  ) {
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail/incident';

    $stateProvider.state('attendance.detail.incident.main', {
      url: '/main',
      templateUrl: base_url + '/list/index.html',
      controller: 'AttendanceDetailIncidentListController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailIncidentController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $mdDialog,
    Gate,
    Toast,
    Incident,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    $scope.gate = null;
    $scope.gates = [];

    // gate
    Gate.query({
      area_id: area_id
    }, function(res) {
        $scope.gates = res;
    }, LocalError.request);

    $scope.select_gate = function(gate) {
      $scope.gate = gate;
    }
  };
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaOldController', controller);

  /** @ngInject */
  function controller(
    $scope,
    Toast,
    $state,
    Area,
    Global,
    LocalError
  ) {
    $scope.items = [];
    $scope.count = 1000;

    $scope.update_area = function(item, index) {
      item.enabled = true;
      $scope.updateItem(item, function() {
        $scope.items.splice(index, 1);
      });
    }

    $scope.query = {
      users: Global.user._id,
      enabled: false,
      limit: 15,
      page: 1
    };

    function success(items) {
      $scope.items = items;
    };

    $scope.getItems = function() {
      Area.pagination($scope.query, success).$promise;
    };

    $scope.getItems();
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaListController', controller);

  /** @ngInject */
  function controller(
    $scope,
    Toast,
    $state,
    Area,
    Global,
    LocalError
  ) {
    Area.query({
      users: Global.user._id,
      enabled: true
    }, function(response) {
      $scope.items = response;
    });

    $scope.update_area = function(item, index) {
      item.enabled = false;
      $scope.updateItem(item, function() {
        $scope.items.splice(index, 1);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AreaDetailController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Toast,
    Global,
    Area,
    Users,
    UploadImages,
    LocalError
  ) {
    UploadImages.init($scope);
    var area_id = $state.params.area_id;
    if (!area_id) {
      throw new Error('params is empty');
    }

    $scope.load = function() {
      Area.get({
        _id: area_id
      }, function(response) {
        $scope.item = response;
        UploadImages.add_current_image(response.image);
        $scope.loadListOfAdministrators();
      });
    };

    $scope.load();
    $scope.upload = UploadImages.upload;

    $scope.updateArea = function(item) {
      item.$update(function() {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.area.list');
        $scope.loadToolbar();
      }, LocalError.request);
    };
  }
})();

function UpdateUserController($scope, $mdDialog, Global, Toast, LocalError, Users, Store) {

  $scope.item = Global.user;

   $scope.hide = function() {
     $mdDialog.hide();
   };
   $scope.cancel = function() {
     $mdDialog.cancel();
   };
   $scope.answer = function(answer) {
     $mdDialog.hide(answer);
   };
   $scope.update = function(user) {
    if (user.new_password != user.confirm_password) {
      Toast.show('los passwords no son iguales');
      return;
    }
    user.password = user.new_password;
    Users.update(user, function(response) {
      Global.user = response;
      Store.save('user', user);
      $mdDialog.hide();
    }, LocalError.request);
   };
 }

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('SessionRegisterController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Session,
    Users,
    LocalError,
    Sess,
    Store,
    Global
  ) {
    $scope.template = 'app/session/templates/signup.message.html';
    $scope.loading = false;

    $scope.register = function(item) {
      $scope.loading = true;
      Users.save(null, item, function() {
        var sessionCredentiales = {
          email: item.email,
          password: item.password
        };
        Session.login(sessionCredentiales, function(user) {
          Sess.login(user, function() {
            console.info('starts session');
            $scope.loading = false;
            $state.go('attendance.home');
          });
        });
      }, function(err) {
        $scope.loading = false;
        LocalError.request(err);
      } );
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('SessionLoginController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Session,
    Sess,
    LocalError,
    Global
  ) {
    $scope.template = 'app/session/templates/signup.message.html';
    $scope.loading = false;
    // $scope.item = {
    //   email: 'wolf@wolf.com',
    //   password: 'wolf'
    // };

    $scope.login = function(item) {
      $scope.loading = true;
      Session.login(item, function(user) {
        Sess.login(user, function() {
          console.info('starts session');
          $scope.loading = false;
          $state.go('attendance.home');
        });
      }, function(err) {
        $scope.loading = false;
        LocalError.request(err);
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Studio', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/studios/:_id';

    return $resource(url, {
      _id: '@_id'
    }, {
      update: {
        method: 'PUT'
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Incident', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/incidents';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       },
       search: {
         method: 'POST',
         isArray: true,
         url: Global.PATH_ATT + '/v3/areas/:area_id/gates/:gate_id/incidents'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Gate', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/gates';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AboutController', controller);

  /** @ngInject */
  function controller($scope, Options) {
    $scope.options = Options.nav;
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('UploadImages', service);

  function service($state, Upload, Toast, LocalError, Global) {
    var local_scope = null;

    var STORE_PATH = Global.PATH_FILES + '/v1/assets/images';
    var IMAGE_PATH = Global.PATH_FILES + '/assets/images/original/';
    console.log(IMAGE_PATH);
    var add_current_image = function(image) {
      if (image) {
        console.log(IMAGE_PATH);
        console.log(image);
        local_scope.current_image = IMAGE_PATH + image;
      }
    };
    var callback = null;

    return {
      init: function(scope) {
        local_scope = scope;
      },
      add_current_image: add_current_image,
      callback: function(call) {
        callback = call;
      },
      upload: function(file) {
        var count = 0;
        Upload.upload({
              url: STORE_PATH,
              data: {avatar: file}
          }).then(function (resp) {
            var data = resp.data;
            local_scope.item.image = data.file_name;
            // Load image
            add_current_image(data.file_name);
            if (callback) callback(data);
          }, function (resp) {
              LocalError.display(resp.status);
          }, function (evt) {
              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
              var msg = 'progress: ' + progressPercentage + '% ';
              Toast.show(msg);
          });
      },
      loadImage: function(imageName) {
        if (!imageName) {
          return 'assets/images/participant.png';
        }

        return IMAGE_PATH + imageName;
      },
      loadImageGroup: function(imageName) {
        if (!imageName) {
          return 'assets/images/groups.png';
        }

        return IMAGE_PATH + imageName;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('UploadFiles', service);

  function service($state, Upload, Toast, LocalError, Global) {
    var local_scope = null;
    var STORE_PATH = Global.PATH_FILES + '/v1/assets/files';
    var FILE_PATH = Global.PATH_FILES + '/public/files/';

    var importCallback = null;
    return {
      FILE_PATH: FILE_PATH,
      init: function(scope) {
        local_scope = scope;
      },
      setImportCallback: function(callback) {
        importCallback = callback;
      },
      upload: function(file) {
        var count = 0;
        Upload.upload({
              url: STORE_PATH,
              data: {avatar: file}
          }).then(function (resp) {
            var data = resp.data;
            local_scope.item.file = data.file_name;
            // Load data
            importCallback();
          }, function (resp) {
              LocalError.display(resp.status);
          }, function (evt) {
              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
              var msg = 'progress: ' + progressPercentage + '% ';
              Toast.show(msg);
          });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('wargos')
    .factory('ModelParser', service);

  function service () {
    return {
      attendance: function (response) {
        response.forEach(function (item) {
          item.id = parseInt(item.id, 10);
          item.category = parseFloat(item.category);
          item.enabled = item.enabled === '1';
          item.create_date = new Date(item.create_date);
        });
        return item;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('CommonToolbar', service);

  function service($state) {
    var scope = null;
    var getScope = function () {
      if (!scope) {
        throw new Error('model is empty');
      }
      return scope;
    };

    return {
      init: function(localScope) {
        scope = localScope;
      },
      add_label: function(position, item) {
        if (!position) {
          throw new Error('position is empty');
        }
        if (!item) {
          throw new Error('item is empty');
        }
        position = position > 0 ? --position : 0;
        getScope().labels[position] = item;
        for (var i = 0; i < getScope().labels.length; i++) {
          if (i > position) {
            getScope().labels.splice(i, 1);
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Common', service);

  function service($state, LocalError) {
    var model = null;
    var getModel = function() {
      if (!model) {
        throw new Error('model is empty');
      }
      return model;
    };

    var validator = function() {
    };

    return {
      init: function(localModel) {
        model = localModel;
      },
      validator: validator,
      save: function(item, callback) {
        getModel().save(item, function(response) {
          if (callback) {
            callback();
          }
        }, LocalError.request);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('AttQr', service);

  function service($state, LocalError) {
    var model = null;

    var draw = function(context, qr, modules, tile) {
      for (var row = 0; row < modules; row++) {
        for (var col = 0; col < modules; col++) {
          var w = (Math.ceil((col + 1) * tile) - Math.floor(col * tile)),
              h = (Math.ceil((row + 1) * tile) - Math.floor(row * tile));
          context.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
          context.fillRect(Math.round(col * tile), Math.round(row * tile), w, h);
        }
      }
    };

    return {
      render: function(canvas, value, typeNumber, correction, size, inputMode) {
        var trim = /^\s+|\s+$/g;
        var text = value.replace(trim, '');

        //   var correction = {
        //   'L': 1,
        //   'M': 0,
        //   'Q': 3,
        //   'H': 2
        // };
        var qr = new QRCode(typeNumber, correction, inputMode);
        qr.addData(text);
        qr.make();

        var context = canvas.getContext('2d');

        var modules = qr.getModuleCount();
        var tile = size / modules;
        canvas.width = canvas.height = size;

        draw(context, qr, modules, tile);
        return canvas.toDataURL() || null;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Store', service);

  function service() {
    var validateKey = function(key) {
      if (!key) {
        throw new Error('key is undefined');
      }
    };

    return {
      save: function(key, value, state) {
        validateKey(key);
        if (!value) {
          throw new Error('value is undefined');
        }
        if (state) {
          localStorage.setItem(key, value);
        } else {
          localStorage.setItem(key, JSON.stringify(value));
        }
      },
      load: function(key, state) {
        validateKey(key);
        if (state) {
            return localStorage.getItem(key);
        }
        return JSON.parse(localStorage.getItem(key));
      },
      remove: function(key) {
        validateKey(key);
        localStorage.removeItem(key);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('AssetConfig', service);

  function service(Store) {
    return {
      saveOrder: function(value) {
        Store.save('asset-order', value, true);
      },
      loadOrder: function() {
        return Store.load('asset-order', true) || '-created';
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Config', service);

  function service(Store) {
    return {
      saveOrder: function(value) {
        Store.save('order', value, true);
      },
      loadOrder: function() {
        return Store.load('order', true) || '-created';
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .directive('headerNavbar', directiveComponent);

  /** @ngInject */
  function directiveComponent($state, Auth, Sess) {

    var user = null;

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {
          options: '='
      },
      controller: headerController
    };
    return directive;

    /** @ngInject */
    function headerController($scope, $mdSidenav) {
      Auth.subcrive(function(user) {
        $scope.user = user;
      });

      $scope.logout = function() {
        Sess.logout(function() {
            console.info('closed session');
            $state.go('home');
        });
      };

      $scope.toggleSidenav = function(menuId) {
        $mdSidenav(menuId).toggle();
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Toast', service);

  function service($mdToast) {

    var display = function(msg) {
      if (!msg) {
        throw new Error('msg is not defined');
      }
      $mdToast.show(
        $mdToast.simple(msg)
          .content(msg)
          .position('top right')
          // .position('bottom left')
          .hideDelay(3000)
      );
    };

    return {
      show: function(msg) {
        display(msg);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('AttSocket', service);

  function service(Global) {
      // SERVICE PATH
      // socket
      // function loadjscssfile(filename, callback) {
      //   if (Global.socket) {
      //     return;
      //   }
      //   var fileref = document.createElement('script');
      //   fileref.setAttribute("type", "text/javascript");
      //   fileref.setAttribute("src", filename);
      //   fileref.onload = callback;

      //   if (typeof fileref != "undefined") {
      //     document.getElementsByTagName("head")[0].appendChild(fileref);
      //   }
      // }

      // var socket_module = {};
      // var create = function(module) {
      //   var socket = io(Global.PATH_SOCKET);
      //   module.version = "v0.0.1";
      //   module.emit = function(channel, msg) {
      //     socket.emit(channel, msg);
      //   };
      //   module.on = function(channel, callback) {
      //     socket.on(channel, callback);
      //   };
      // };

      // loadjscssfile(Global.PATH_SOCKET + '/socket.io/socket.io.js', function() {
      //   create(socket_module);
      // });

      // return socket_module;
      return null;
    }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('LocalError', service);

  function service($mdToast) {

    var displayError = function(msg) {
      if (!msg) {
        throw new Error('msg is not defined');
      }
      $mdToast.show(
        $mdToast.simple(msg)
          .content(msg)
          .position('bottom left')
          .hideDelay(3000)
      );
    };

    return {
      request: function(response) {
        var msg;
        if (response.status === -1) {
          msg = 'ERROR: ' + 'CONEXION RECHAZADA';
          displayError(msg);
          return;
        }
        if (response.status === 408) {
          msg = 'ERROR: ' + response.data;
          displayError(msg);
          return;
        }
        if (response.data) {
          msg = 'ERROR: ' + response.data.message;
          displayError(msg);
          return;
        } else {
          console.log('NOT HANDLED ERROR:', response);
          return;
        }
      },
      display: function(error) {
        var msg = "ERROR: " + error;
        displayError(msg);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Global', service);

  function service(Store) {
      // SERVICE PATH
      // http://files.wargos-solutions.com/
      var PATH_USERS = 'https://accounts.unboliviano.com';
      var PATH_FILES = 'https://files.unboliviano.com';
      var PATH_ATT = 'https://atts.unboliviano.com';

      // DEPRECATED
      //var PATH_SOCKET = 'http://socket.attendance.ninja';

      // SERVICE PATH
      // var PATH_USERS = 'http://192.168.56.102:10101';
      // var PATH_FILES = 'http://192.168.56.102:10201';
      // var PATH_ATT = 'http://192.168.56.102:10011';

      // DEPRECATED
      // var PATH_SOCKET = 'http://192.168.56.102:10401';

      var start = function() {
        console.info('Starts the application!!');
        _service.user = Store.load('user');
        console.log(this);
      };

      var _service = {
        PATH_USERS: PATH_USERS,
        PATH_FILES: PATH_FILES,
        //PATH_SOCKET: PATH_SOCKET,
        PATH_ATT: PATH_ATT,
        user: null,
        socket: false,
        start: start
      };
      return _service;
    }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Dialog', service);

  function service($mdDialog) {
    return {
      removeItem: function(ev, okCallback, noCallback) {
        var confirm = $mdDialog.confirm()
              .title('Estas de acuerdo en eliminar?')
              .content('se perderan todos los datos.')
              .ariaLabel('Lucky day')
              .targetEvent(ev)
              .ok('SI')
              .cancel('NO');
        $mdDialog.show(confirm).then(
          okCallback, noCallback);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('ListBottomSheetCtrl', controller);

  /** @ngInject */
  function controller($scope, $mdBottomSheet) {
    $scope.items = [
      {
        name: 'Proveedor',
        icon: 'attendance',
        route: 'attendance.provider.list'
      }, {
        name: 'Ventas',
        icon: 'attach_money',
        route: 'attendance'
      }, {
        name: 'Ganacias',
        icon: 'trending_up',
        route: 'attendance.trending_up'
      }
    ];

    $scope.listItemClick = function($index) {
      var clickedItem = $scope.items[$index];
      console.log(clickedItem);
      $mdBottomSheet.hide(clickedItem);
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/provider';

    $stateProvider.state('attendance.provider.actor', {
      url: '/actor',
      templateUrl: base_url + '/actor/index.html',
      controller: 'ProviderActorController'
    });
    $stateProvider.state('attendance.provider.category', {
      url: '/category',
      templateUrl: base_url + '/category/index.html',
      controller: 'ProviderCategoryController'
    });
    $stateProvider.state('attendance.provider.director', {
      url: '/director',
      templateUrl: base_url + '/director/index.html',
      controller: 'ProviderDirectorController'
    });
    $stateProvider.state('attendance.provider.studio', {
      url: '/studio',
      templateUrl: base_url + '/studio/index.html',
      controller: 'ProviderStudioController'
    });
    $stateProvider.state('attendance.provider.quality', {
      url: '/quality',
      templateUrl: base_url + '/quality/index.html',
      controller: 'ProviderQualityController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceProviderController', controller);

  /** @ngInject */
  function controller($scope, $mdSidenav, Options, $mdBottomSheet, Auth) {
    $scope.pages = [
      {
        title: 'Estudio',
        route: 'attendance.provider.studio.list'
      }
    ];
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceHomeController', controller);

  /** @ngInject */
  function controller(
    $scope
  ) {
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('UUID', service);

  function service($state) {
    return {
      next: function() {
        var code = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
        return code;
      },
      generate: function() {
        return Math.random().toString(40).slice(2);
      },
      randomString: function(length) {
          return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
      },
      att: function() {
        var code = 'xxxxx-xxxxx-xxxxx-xxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
        return code;
      },
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperDetailRoute', service);

  function service($state) {
    return {
      goToParticipant: function(participant) {
        $state.go('attendance.detail.participant', {
          participant_id: participant._id
        });
      },
      goToRoom: function(room) {
        $state.go('attendance.detail.room.update', {
          room_id: room._id
        });
      },
      goToEvent: function(event) {
        $state.go('attendance.detail.eventupdate', {
          event_id: event._id
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperParticipant', service);

  function service($state, Room, LocalError, Global, UUID, Participant) {
    var scope = null;

    return {
      init: function(local_scope) {
        scope = local_scope;
      },
      createParticipant: function() {
        console.info('DEPRECATE: HelperParticipant.createParticipant()');
        var uuid = UUID.next();
        var data = {
          area_id: scope.area._id,
          uid: uuid,
          first_name: 'FIRST NAME',
          last_name: 'LAST NAME',
          image: null,
          cel: '70100000',
          ci: '10000001',
          address: 'ADDRESS',
          email: 'example@wargos.ninja',
          rooms: [scope.room._id]
        };
        Participant.save(data, function(response) {
          scope.participants.unshift(response);
        }, LocalError.request);
      },
      loadParticipants: function(room_id) {
        Participant.query({
          rooms: room_id
        }, function(response) {
          scope.participants = response;
        }, LocalError.request);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperEvent', service);

  function service($state, Event, LocalError, Global, moment, UUID) {
    var scope = null;
    var page = 1;

    var getDateFormated = function(newDate) {
      var day = newDate || new Date();
      return moment(day).format('YYYY-MM-DD HH:mm');
    }

    var loadEvents = function(data) {
      data.limit = 10;
      Event.pagination(data, function(response) {
        page = data.page;
        response.forEach(function(item) {
          item.start = new Date(item.start);
          item.end = new Date(item.end);
          scope.events.push(item);
        });
        if (scope.events[0]) {
          scope.selectEvent(scope.events[0]);
        }
      }, LocalError.request);
    }

    return {
      init: function(local_scope) {
        scope = local_scope;
      },
      createEvent: function(room_id) {
        var data = {
          // start: getDateFormated(),
          // end: getDateFormated(),
          name: getDateFormated(),
          slackTime: 5,
          temp: UUID.next(),
          enabled: true
        }
        Event.save({
          area_id: scope.area._id,
          room_id: room_id
        }, data, function(response) {
          scope.selectEvent(response);
          scope.events.unshift(response);
        }, LocalError.request);
      },
      loadEvents: function(room_id) {
        page = 1;
        scope.events.length = 0;
        var data = {
          page: page,
          room_id: room_id
        };
        loadEvents(data);
      },
      loadMoreEvents: function(room_id) {
        var data = {
          page: ++page,
          room_id: room_id
        };
        loadEvents(data);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('HelperGate', service);

  function service($state, Gate, LocalError, Global, moment) {
    var scope = null;
    var page = 1;

    var getDateFormated = function(newDate) {
      var day = newDate || new Date();
      return moment(day).format('YYYY-MM-DD HH:mm');
    }

    var load = function(data) {
      data.limit = 10;
      Gate.pagination(data, function(res) {
        page = data.page;
        res.forEach(function(item) {
          scope.events.push(item);
        });
      }, LocalError.request);
    }

    return {
      init: function(local_scope) {
        scope = local_scope;
      },
      // create: function(area_id) {
      //   var data = {
      //     // start: getDateFormated(),
      //     // end: getDateFormated(),
      //     // title: getDateFormated(),
      //     enabled: true
      //   }
      //   Gate.save({
      //     area_id: area_id
      //   }, data, function(response) {
      //     scope.events.unshift(response);
      //   }, LocalError.request);
      // },
      load: function(area_id) {
        page = 1;
        scope.gates.length = 0;
        var data = {
          page: page,
          area_id: area_id
        };
        load(data);
      },
      loadMoreGates: function(area_id) {
        var data = {
          page: ++page,
          area_id: area_id
        };
        load(data);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance/detail';

    $stateProvider.state('attendance.detail.people', {
      url: '/people',
      templateUrl: base_url + '/people/index.html',
      controller: 'AttendanceDetailPeopleController'
    });
    $stateProvider.state('attendance.detail.incident', {
      url: '/incident',
      templateUrl: base_url + '/incident/index.html',
      controller: 'AttendanceDetailIncidentController'
    });
    $stateProvider.state('attendance.detail.room', {
      url: '/room/:room_id',
      templateUrl: base_url + '/room/index.html',
      controller: 'AreaDetailRoomController'
    });
    $stateProvider.state('attendance.detail.template', {
      url: '/template',
      templateUrl: base_url + '/template/index.html',
      controller: 'AreaDetailTemplateController'
    });
    $stateProvider.state('attendance.detail.settings', {
      url: '/settings',
      templateUrl: base_url + '/settings/index.html',
      controller: 'AreaDetailSettingsController'
    });

    // TODO validate if this routes are still used
    $stateProvider.state('attendance.detail.studio', {
      url: '/studio',
      templateUrl: base_url + '/studio/index.html',
      controller: 'AreaDetailStudioController'
    });
    $stateProvider.state('attendance.detail.participant', {
      url: '/participant/:participant_id',
      templateUrl: base_url + '/participant/index.html',
      controller: 'AreaDetailParticipantController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceDetailController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    UploadImages,
    Area,
    LocalError,
    Room,
    Toast,
    $mdDialog,
    $window
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;

    $scope.room = null;
    $scope.rooms = [];
    $scope.participants = [];
    $scope.area = {
      config: {
        areas: 10,
        participants: 50
      }
    };

    // images
    $scope.loadImage = UploadImages.loadImage;

    $scope.goToBack = function() {
      $window.history.back();
    }

    $scope.set_area = function(area) {
      $scope.area = area;
    }

    // helper room
    $scope.createRoom = function() {
      var data = {
        name: 'SALA',
        parent: room_id,
        area_id: area_id
      }
      Room.save(data, function(response) {
        $scope.rooms.unshift(response);
      }, LocalError.request);
    }

    $scope.loadRooms = function(room_id) {
      Room.query({
        parent: room_id
      }, function(response) {
        $scope.rooms = response;
      }, LocalError.request);
    }

    $scope.go_to = function(route) {
      $state.go(route, {
        area_id: area_id,
        room_id: $scope.room._id
      });
    }

    $scope.load_room = function(room_id) {
      Room.get({
        _id: room_id
      }, function(res) {
        $scope.room = res;
      }, LocalError.request);
    }

    $scope.selectRoom = function(room) {
      room_id = room._id;
      $state.go('attendance.detail.room.att', {
        area_id: area_id,
        room_id: room._id
      });
      $scope.room = room;
      $scope.loadRooms(room._id);
    }

    $scope.select_main_room = function() {
      room_id = $scope.area.room_id;
      $state.go('attendance.detail.room.att', {
        area_id: $scope.area._id,
        room_id: $scope.area.room_id
      });
      $scope.load_room($scope.area.room_id);
      $scope.loadRooms($scope.area.room_id);
    }

    $scope.show_confirm = function(ev) {
      var confirm = $mdDialog.confirm()
      .title('¿Esta seguro que desea eliminar esta area?')
      .textContent('Todos los elementos asociados se eliminaran (Salas, Personas, Eventos, Etc)')
      .ariaLabel('confirmation-modal')
      .targetEvent(ev)
      .ok('Aceptar')
      .cancel('Cancelar');

      $mdDialog.show(confirm)
      .then(function() {
          $scope.delete_area($scope.area);
      }, function() {
          console.log('cancel');
      });
    }

    $scope.delete_area = function(item) {
      item.$delete(function(response) {
        Toast.show('Se elimino correctamente');
        $state.go('attendance.area.list');
        $scope.loadToolbarAreas();
      }, LocalError.request);
    }

    Area.get({
      _id: area_id
    }, function(response) {
      $scope.area = response;
      Room.get({
        _id: $scope.area.room_id
      }, function(res) {
        $scope.room = res;
      }, LocalError.request);
    }, LocalError.request);

    if (!room_id) {
      console.log('Principal room is undefined');
      return;
    }
    $scope.loadRooms(room_id);

    $scope.openEventMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    $scope.go_to_room = function(room) {
      $state.go('attendance.detail.room.update', {
        room_id: room._id
      });
    }

    $scope.go_to_participants = function(room) {
      console.log(room);
      $state.go('attendance.detail.room.settings', {
        room_id: room._id
      });
    }

    $scope.show_confirm_remove_room = function(room, ev) {
      var confirm = $mdDialog.confirm()
      .title('¿Esta seguro que desea eliminar esta sala?')
      .textContent('Todos los elementos asociados se eliminaran (Personas, Eventos, Etc)')
      .ariaLabel('confirmation-modal')
      .targetEvent(ev)
      .ok('Aceptar')
      .cancel('Cancelar');
      $mdDialog.show(confirm)
      .then(function() {
          $scope.delete_room(room);
      }, function() {
          console.log('cancel');
      });
    }

    $scope.generate_registration_token = function(room, ev) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: 'app/attendance/detail/token/index.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
           room: room
        }
      })
      .then(function(answer) {
      }, function() {
      });
    }

    $scope.delete_room = function(item) {
      if ($scope.area.room_id === item._id) {
        Toast.show('No se puede eliminar un sala principal');
        return;
      }
      item.$delete(function(response) {
        $scope.select_main_room();
      }, LocalError.request);
    }

    $scope.openMenu = function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }
  }

  function DialogController($scope, $mdDialog, UUID, LocalError, room) {
    $scope.room = room;

    $scope.go_to_staff_page = function() {
      $scope.room.temp = $scope.room.temp || UUID.next();
      $scope.room.$update(function(res) {
        var STAFF_URL = 'http://staff.attendance.ninja/tokens/' + res.temp;
        var win = window.open(STAFF_URL, '_blank');
        win.focus();
        $scope.answer();
      }, LocalError.request);
    }

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    }

    $scope.cancel = function() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig ($stateProvider) {
    var base_url = 'app/attendance/area';

    $stateProvider.state('attendance.area.list', {
      url: '/list',
      templateUrl: base_url + '/list/index.html',
      controller: 'AreaListController'
    });
    $stateProvider.state('attendance.area.detail', {
      url: '/detail/:area_id',
      templateUrl: base_url + '/detail/index.html',
      controller: 'AreaDetailController'
    });
    $stateProvider.state('attendance.area.old', {
      url: '/old',
      templateUrl: base_url + '/old/index.html',
      controller: 'AreaOldController'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AttendanceAreaController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $mdDialog,
    $state,
    Toast,
    Global,
    LocalError,
    Area
  ) {

    $scope.openPage = function() {
      $state.go('attendance.area.create');
    };

    $scope.deleteItem = function(item) {
      item.$delete(function(response) {
        Toast.show('Se actualizo correctamente');
        $state.go('attendance.area.list');
        $scope.loadToolbar();
      }, LocalError.request);
    };

    $scope.selectItem = function(item) {
      $state.go('attendance.area.detail', {
        area_id: item._id
      });
    };

    $scope.create_area = function() {
      Area.save({
        users: [Global.user._id],
        name: 'AREA',
        user_id: Global.user._id,
        enabled: true
      }, function(response) {
        $state.go('attendance.area.detail', {
          area_id: response._id
        });
        $scope.loadToolbar();
      }, LocalError.request);
    };

    $scope.updateItem = function(item, callback) {
      item.$update(function(response) {
        Toast.show('Se actualizo correctamente');
        $scope.loadToolbar();
        if (callback) {
          callback();
        }
      }, LocalError.request);
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('AccessibilityController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    Participant,
    Area,
    Room,
    Event,
    Store,
    UploadImages,
    AttSocket,
    LocalError
  ) {
    var area_id = $state.params.area_id;
    var room_id = $state.params.room_id;
    var event_id = $state.params.event_id;

    $scope.loadImage = UploadImages.loadImage;
    $scope.participant_atts = [];

    var participant = null;
    Participant.query({
      area_id: area_id,
      rooms: room_id
    }, function(res) {
      $scope.participants = res;
    }, LocalError.request);

    $scope.find_participant = function(participant_id) {
        var result = null;
        $scope.participants.forEach(function(participant) {
            if (participant._id === participant_id) {
              result = participant;
            }
        });
        return result;
    }

    // setTimeout(function() {
    //   AttSocket.on('atts-take', function(message) {
    //     var data = JSON.parse(message);
    //     if (data.channel == 'areas/' + area_id + '/rooms/' + room_id + '/events/' + event_id) {
    //       var person = $scope.find_participant(data.participant_id);
    //       if (person) {
    //         $scope.$apply(function() {
    //           $scope.participant = person;
    //           $scope.participant_atts.unshift(person);
    //           if ($scope.participant_atts.length >= 20) {
    //               $scope.participant_atts.pop();
    //           }
    //         });
    //       }
    //     }
    //   });
    // }, 3000);



  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Users', service);

  function service($resource, Global) {
    var url = Global.PATH_USERS + '/p1/accounts';
     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       findByEmail: {
         method: 'GET',
         // TODO made an specific method
         isArray: true
       }
     });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('SessionsController', controller);

  /** @ngInject */
  function controller() {
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Session', service);

  function service($resource, Global) {
    var url = Global.PATH_USERS + '/p1/auth/login';

     return $resource(url, {
       id: '@id'
     }, {
       login: {
         method: 'POST'
       },
       user: {
         method: 'GET'
       }
     });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    var base_url = 'app/session';

    $stateProvider.state('home.register', {
      url: 'register',
      templateUrl: base_url + '/register/index.html',
      controller: 'SessionRegisterController'
    });

    $stateProvider.state('home.login', {
      url: 'login',
      templateUrl: base_url + '/login/index.html',
      controller: 'SessionLoginController'
    });

    $stateProvider.state('home.forgot', {
      url: 'forgot',
      templateUrl: base_url + 'forgot.html',
      controller: 'SessionsController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Sess', service);

  function service($http, Store, Auth, Global) {

    var saveUser = function(user) {
      if (!user) {
        throw new Error('user is undefined');
      }
      if (!user.token) {
        throw new Error('token is undefined');
      }
      var token = user.token;
      // Saving on local storage
      delete user['token'];
      Store.save('token', token);
      Store.save('user', user);

      // TODO it's repeated on index.config
      if (token) {
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + token.session_id;
      }
    };

    var service = {
      //login
      login: function(user, callback) {
        localStorage.clear();
        saveUser(user);
        Auth.loadUser();
        Global.start();
        callback();
      },
      logout: function(callback) {
        localStorage.clear();
        Auth.loadUser();
        Global.start();
        callback();
      }
    };
    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Auth', service);

  function service($rootScope, Store) {

    var subcriptors = [];

    return {
      loadUser: function() {
        service.user = Store.load('user');
        subcriptors.forEach(function(item) {
          item(service.user);
        });
      },
      subcrive: function(func) {
        subcriptors.push(func);
        this.loadUser();
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('authInterceptor', service);

  function service($rootScope, $q, $location) {
    return {
      responseError: function(response) {
        if (response.status === 401) {
          $location.path('/login');
        }
        return $q.reject(response);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Template', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/templates';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v1/templates'
       },
       properties: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v2/templates/properties'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('AttStore', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/stores';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('State', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/states';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       },
       query_order_by: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v3/areas/:area_id/states'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Room', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/rooms';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id',
       page: '@page'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas/:area_id/rooms'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Reports', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v2/reports';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       att_report: {
         method: 'GET',
         url: Global.PATH_ATT + '/v2/reports/rooms/:room_id/att'
       },
       att_report_by_group: {
         method: 'GET',
         url: Global.PATH_ATT + '/v2/reports/rooms/:room_id/groups/:group_id/att'
       },
       arrive: {
         method: 'GET',
         url: url + '/events/:event_id/arrive/page/:page/limit/:limit',
         isArray: true
       },
       att_groups_report: {
         method: 'GET',
         url: url + '/rooms/:room_id/events/:event_id/groups',
         isArray: true
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Participant', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/participants';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas/:area_id/participants'
       },
       save_import: {
         method: 'POST',
         url: Global.PATH_ATT + '/v3/areas/:area_id/participants'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       },
       get_size: {
         method: 'GET',
         url: url + '/size'
       },
       search: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v2/areas/:area_id/participants/page/:page/limit/:limit'
       },
       search_order_by: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v2/areas/:area_id/participants/page/:page/limit/:limit/order'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Note', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/notes';

     return $resource(url + '/:_id', {
       _id: '@_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v3/areas/:area_id/rooms/:room_id/events/:event_id/notes'
       },
       find_note: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v3/areas/:area_id/rooms/:room_id/events/:event_id/notes'
       },
       find_room_notes: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v3/participants/:participant_id/rooms/:room_id/notes'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Loan', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/loans';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       },
       search: {
         method: 'POST',
         isArray: true,
         url: Global.PATH_ATT + '/v3/areas/:area_id/assets/:asset_id/loans'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Group', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/groups';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id'
     }, {
       query: {
         method: 'GET',
         url: Global.PATH_ATT + '/v2/groups',
         isArray: true
       },
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas/:area_id/groups'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Files', service);

  function service($resource, Global) {
    var url = Global.PATH_FILES + '/p1/reader/files/excel';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       read: {
         method: 'POST',
         isArray: true
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Event', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/events';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id',
       room_id: '@room_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas/:area_id/rooms/:room_id/events'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('AttendanceAtts', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/atts';

     return $resource(url + '/:_id', {
       _id: '@_id',
       room_id: '@room_id',
       event_id: '@event_id',
       area_id: '@area_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v3/areas/:area_id/rooms/:room_id/events/:event_id/atts'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Asset', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/assets';

     return $resource(url + '/:_id', {
       _id: '@_id',
       area_id: '@area_id'
     }, {
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas/:area_id/assets'
       },
       update: {
         method: 'PUT'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       },
       search_order_by: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v2/areas/:area_id/assets/page/:page/limit/:limit/order'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Area', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/areas';

     return $resource(url + '/:_id', {
       _id: '@_id'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v2/areas'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Alibi', service);

  function service($resource, Global) {
    var url = Global.PATH_ATT + '/v1/alibis';

     return $resource(url + '/:_id', {
       _id: '@_id',
       page: '@page',
       limit: '@limit'
     }, {
       update: {
         method: 'PUT'
       },
       save: {
         method: 'POST',
         url: Global.PATH_ATT + '/v3/areas/:area_id/rooms/:room_id/events/:event_id/alibis'
       },
       find_alibi: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v3/areas/:area_id/rooms/:room_id/events/:event_id/alibis'
       },
       find_room_alibi: {
         method: 'GET',
         isArray: true,
         url: Global.PATH_ATT + '/v3/participants/:participant_id/rooms/:room_id/alibis'
       },
       pagination: {
         method: 'GET',
         isArray: true,
         url: url + '/page/:page/limit/:limit'
       }
     });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/home';

    $stateProvider.state('home.about', {
      url: 'about',
      templateUrl: base_url + '/about/index.html',
      controller: 'AboutController'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('HomeController', controller);

  /** @ngInject */
  function controller($scope, Options) {
    $scope.options = Options.nav;
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var base_url = 'app/attendance';

    $stateProvider.state('attendance', {
      url: '/attendance',
      templateUrl: base_url + '/index.html',
      controller: 'StoreController',
      resolve: {
       simpleObj: function(Global) {
         Global.start();
       }
      }
    });

    $stateProvider.state('attendance.area', {
      url: '/area',
      templateUrl: base_url + '/area/index.html',
      controller: 'AttendanceAreaController'
    });

    $stateProvider.state('attendance.home', {
      url: '/home',
      templateUrl: base_url + '/home/index.html',
      controller: 'AttendanceHomeController'
    });

    $stateProvider.state('printparticipants', {
      url: '/print/qr/areas/:area_id/rooms/:room_id/page/:page',
      templateUrl: base_url + '/print/qr/index.html',
      controller: 'PrintQrController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });
    $stateProvider.state('printgroups', {
      url: '/print/qr/areas/:area_id/rooms/:room_id/groups/:group_id/page/:page',
      templateUrl: base_url + '/print/qr/index.html',
      controller: 'PrintQrController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });
    $stateProvider.state('printcredential', {
      url: '/print/credential/:template_id/areas/:area_id/rooms/:room_id/page/:page',
      templateUrl: base_url + '/print/credentials/index.html',
      controller: 'PrintCredentialsController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });
    $stateProvider.state('printcredentialgroup', {
      url: '/print/credential/:template_id/areas/:area_id/rooms/:room_id/groups/:group_id/page/:page',
      templateUrl: base_url + '/print/credentials/index.html',
      controller: 'PrintCredentialsController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });
    $stateProvider.state('printobjects', {
      url: '/print/assets/areas/:area_id/page/:page',
      templateUrl: base_url + '/print/assets-qr/index.html',
      controller: 'PrintAssetQrController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });

    $stateProvider.state('accessibility', {
      url: '/accessibility/areas/:area_id/rooms/:room_id/events/:event_id',
      templateUrl: base_url + '/accessibility/index.html',
      controller: 'AccessibilityController',
      resolve: {
        simpleObj: function(Global) {
          Global.start();
        }
      }
    });

    $stateProvider.state('attendance.provider', {
      url: '/provider',
      templateUrl: base_url + '/provider/index.html',
      controller: 'AttendanceProviderController'
    });
    $stateProvider.state('attendance.detail', {
      url: '/:area_id',
      templateUrl: base_url + '/detail/index.html',
      controller: 'AttendanceDetailController'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .controller('StoreController', controller);

  /** @ngInject */
  function controller(
    $scope,
    $state,
    $mdSidenav,
    Options,
    $mdBottomSheet,
    Auth,
    Sess,
    Toast,
    Area,
    Global,
    LocalError,
    UploadImages,
    moment,
    $mdDialog
  ) {
    $scope.enabled = false;

    // images
    $scope.loadImageGroup = UploadImages.loadImageGroup;

    Auth.subcrive(function(user) {
      $scope.user = user;
    });

    $scope.logout = function() {
      Sess.logout(function() {
          console.info('closed session');
          $state.go('home');
      });
    };

    $scope.create_area_toolbar = function() {
      Area.save({
        users: [Global.user._id],
        name: 'AREA',
        user_id: Global.user._id,
        enabled: true
      }, function(response) {

        $scope.areas.unshift(response);
        $state.go('attendance.detail.room.att', {
          area_id: response._id,
          room_id: response.room_id
        });
        $mdSidenav('left').close();
      }, LocalError.request);
    };

    $scope.loadToolbarAreas = function() {
      Area.query({
        users: Global.user._id,
        enabled: true
      }, function(response) {
        $scope.areas = response;
        var area_id = $state.params.area_id;
        var current_area = $scope.areas[0];
        if (!area_id && current_area) {
          $state.go('attendance.detail.room.att', {
            area_id: current_area._id,
            room_id: current_area.room_id
          });
        }
      }, LocalError.request);
    }

    $scope.loadToolbar = function() {
      Area.query({
        users: Global.user._id,
        enabled: true
      }, function(response) {
        $scope.areas = response;
      }, LocalError.request);
    }
    $scope.loadToolbarAreas();

    $scope.options = [{
      title: 'Administrar areas',
      route: 'attendance.area.list'
    }];

    $scope.selectOption = function(option) {
      if(!option) {
        throw new Error('option is empty');
      }
      $mdSidenav('left').close();
      $state.go(option.route);
    };

    $scope.selectArea = function(area) {
      $state.go('attendance.detail.room.att', {
        area_id: area._id,
        room_id: area.room_id
      }); // }, {reload: true});
      $mdSidenav('left').close();
    };

    $scope.toggleSidenav = function(menuId) {
      $mdSidenav(menuId).toggle();
    };

    $scope.admin = [
      {
        link: '',
        title: 'Trash',
        icon: 'delete'
      },
      {
        link: 'showListBottomSheet($event)',
        title: 'Settings',
        icon: 'settings'
      }
    ];

    $scope.showAdd = function(ev) {
      console.log('add');
    };

    // LIST BOTTOM
    $scope.showGridBottomSheet = function() {
      $scope.alert = '';
      $mdBottomSheet.show({
        templateUrl: 'app/attendance/templates/list-bottom.html',
        controller: 'ListBottomSheetCtrl',
        //clickOutsideToClose: false
      }).then(function(clickedItem) {
        $state.go(clickedItem.route);
      });
    };

    // GENERIC
    $scope.imageUrl = Global.IMAGE_PATH;

    $scope.getDate = function (newDate) {
      var day = newDate || new Date();
      return moment(day).format('YYYY-MM-DD HH:mm:ss');
    };

    // update user
    $scope.showDialog = function(ev) {
      $mdDialog.show({
        controller: UpdateUserController,
        templateUrl: 'app/session/update/update.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
      .then(function(answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function() {
        $scope.status = 'You cancelled the dialog.';
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .factory('Options', service);

  function service() {
    var nav = [
      {
        route: 'attendance.home',
        value: 'Principal'
      }
    ];

    return {
      nav: nav
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('home', {
      url: '/',
      templateUrl: 'app/home/index.html',
      controller: 'HomeController',
      resolve: {
         simpleObj: function(Global) {
            Global.start();
         }
      }
    });
    $urlRouterProvider.otherwise('/');
  }
})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('wargos')
    .constant('moment', moment);
})();

(function() {
  'use strict';

  angular
    .module('wargos')
    .config(config);

  /** @ngInject */
  function config($logProvider, $mdThemingProvider, $httpProvider) {
    $mdThemingProvider.theme('default')
      .primaryPalette('cyan');
      // .dark();

    // Session
   $httpProvider.interceptors.push('authInterceptor');

    // Enable log
    $logProvider.debugEnabled(true);

    // Loading token
    var token = localStorage.getItem('token');
    if (token) {
      try {
        var session = JSON.parse(token).session_id;
        $httpProvider.defaults.headers.common['Authorization'] = 'Bearer ' + session;
      } catch (e) {
        console.log('Session is no longer alive');
      }
    }
  }
})();

angular.module("wargos").run(["$templateCache", function($templateCache) {$templateCache.put("app/attendance/index.html","<div layout=\"row\" layout-fill=\"\"><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z4\" md-whiteframe=\"10\" md-component-id=\"left\"><md-toolbar class=\"md-tall md-hue-2\"><span flex=\"\"></span><div layout=\"column\" class=\"md-toolbar-tools-bottom inset\"><user-avatar></user-avatar><span></span><div ng-click=\"showDialog($event)\">{{user.name}}</div><div ng-click=\"showDialog($event)\">{{user.email}}</div></div></md-toolbar><md-list><md-subheader>Areas</md-subheader><div ng-if=\"areas.length == 0\" class=\"wargos-text-align\"><b>No existe <i>areas</i> registrados</b><p>Para crear uno <b>click</b> en el boton <b>Administrar areas</b></p></div><md-list-item ng-repeat=\"area in areas\" ng-click=\"selectArea(area)\"><img ng-src=\"{{loadImageGroup(area.image)}}\" class=\"md-avatar\"><p>{{area.name}}</p></md-list-item><div layout=\"row\"><div flex=\"\"></div><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"create_area_toolbar($event)\"><ng-md-icon icon=\"add\"></ng-md-icon>Area</md-button></div><md-divider></md-divider><md-subheader class=\"md-no-sticky\">Opciones globales</md-subheader><md-list-item ng-repeat=\"option in options\" ng-click=\"selectOption(option)\"><ng-md-icon icon=\"done\" style=\"fill: black\"></ng-md-icon><p>{{option.title}}</p></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">Salir</md-subheader><md-list-item ng-click=\"logout()\"><ng-md-icon icon=\"logout\"></ng-md-icon><p>salir</p></md-list-item><md-divider></md-divider></md-list></md-sidenav><ui-view layout=\"column\" layout-fill=\"\"></ui-view></div>");
$templateCache.put("app/home/index.html","<div layout=\"column\" layout-fill=\"\" class=\"att-home\"><header-navbar options=\"options\"></header-navbar><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"><div class=\"main-image\"><div class=\"title\"><div hide=\"\" show-gt-sm=\"\"><h1 class=\"md-display-4\">Attendance</h1><h4 class=\"md-display-2\">Porque la asistencia es cuestión de educación y respeto.</h4><h2 class=\"md-headline\">#asistencia #eventos #incidentes #credenciales</h2></div><div hide=\"\" show-sm=\"\"><h1 class=\"md-display-3\">Attendance</h1><h4 class=\"md-display-1\">Porque la asistencia es cuestión de educación y respeto.</h4><h2 class=\"md-headline\">#asistencia #eventos #incidentes #credenciales</h2></div><div hide=\"\" show-xs=\"\"><h1 class=\"md-display-2\">Attendance</h1><h4>Porque la asistencia es cuestión de educación y respeto.</h4><h2 class=\"md-headline\">#asistencia #eventos #incidentes #credenciales</h2></div><div><div class=\"play-link\"><a href=\"https://play.google.com/store/apps/details?id=ninjas.wargos.attendance&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\"><img alt=\"Disponible en Google Play\" src=\"https://play.google.com/intl/en_us/badges/images/generic/es_badge_web_generic.png\"></a></div></div><div class=\"media\"><a target=\"_blank\" href=\"https://www.facebook.com/NinjaAttendance/\"><img ng-src=\"assets/images/icon-facebook.png\"></a></div></div></div></ui-view></md-content></div>");
$templateCache.put("app/attendance/accessibility/index.html","<md-content class=\"accessibility\" layout=\"column\" layout-fill=\"\"><div layout=\"row\"><div layout=\"column\" flex=\"\"><div class=\"image\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"></div><div class=\"participant-name\"><h3>{{participant.last_name}} {{participant.first_name}}</h3></div></div><div layout=\"column\" flex=\"20\"><md-list-item ng-click=\"changeStatus(participant, $index)\" class=\"md-2-line\" ng-repeat=\"participant in participant_atts\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3><b>{{participant.count}}</b> {{participant.last_name}} {{participant.first_name}}</h3><p ng-if=\"participant.att\">{{participant.att.created | date : \'HH:mm:ss\'}}</p></div><md-button ng-if=\"participant.isloading\" aria-label=\"isloading\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"done\" style=\"fill: black\"></ng-md-icon></md-button><md-button ng-if=\"participant.color\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.color }}\"><ng-md-icon icon=\"done_all\"></ng-md-icon></md-button><md-button ng-if=\"participant.alibi\" aria-label=\"layers\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.alibi.color }}\"><ng-md-icon icon=\"layers\"></ng-md-icon></md-button><md-button ng-if=\"participant.note\" aria-label=\"message\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"message\"></ng-md-icon></md-button></md-list-item></div></div></md-content><style media=\"screen\">\r\n.accessibility {\r\n\r\n}\r\n.accessibility img {\r\n  margin-top: 50px;\r\n  max-width: 400px;\r\n  max-height: 400px;\r\n}\r\n.accessibility .image {\r\n  text-align: center;\r\n}\r\n.accessibility .participant-name {\r\n  text-align: center;\r\n}\r\n.accessibility .participant-name h3 {\r\n  font-size: 40px;\r\n}\r\n</style>");
$templateCache.put("app/attendance/area/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Menu\" ng-click=\"toggleSidenav(\'left\')\"><ng-md-icon icon=\"menu\"></ng-md-icon></md-button><h3>Areas</h3></div></md-toolbar><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Habilitados\" ui-sref=\"attendance.area.list\"></md-tab><md-tab label=\"Deshabilitados\" ui-sref=\"attendance.area.old\"></md-tab></md-tabs><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content>");
$templateCache.put("app/attendance/detail/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Menu\" ng-click=\"toggleSidenav(\'left\')\"><ng-md-icon icon=\"menu\"></ng-md-icon></md-button><h3>{{area.name}}</h3><span flex=\"\"></span><md-button aria-label=\"room\" ui-sref=\"attendance.detail.loans.main\"><ng-md-icon icon=\"book\"></ng-md-icon>Prestamos</md-button><md-button aria-label=\"room\" ui-sref=\"attendance.detail.people.main\"><ng-md-icon icon=\"room\"></ng-md-icon>Incidentes</md-button><md-button aria-label=\"copy\" ui-sref=\"attendance.detail.template.main\"><ng-md-icon icon=\"now_wallpaper\"></ng-md-icon>Plantilla</md-button></div></md-toolbar><md-content flex=\"\"><div layout=\"row\" layout-fill=\"\"><div layout=\"column\"><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>{{room.name}}</h1><span flex=\"\"></span><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openEventMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ui-sref=\"attendance.detail.room.settings\"><ng-md-icon icon=\"people\"></ng-md-icon>Agregar participantes</md-button></md-menu-item><md-menu-item><md-button ng-click=\"go_to_room(room)\"><ng-md-icon icon=\"edit\"></ng-md-icon>Editar</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content flex=\"\"><md-list><md-subheader class=\"md-no-sticky\">General</md-subheader><md-list-item ng-click=\"go_to(\'attendance.detail.room.att\')\"><ng-md-icon icon=\"done\"></ng-md-icon><p>Asistencia</p></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.people.main\')\"><ng-md-icon icon=\"people\"></ng-md-icon><p>Participantes</p><md-button class=\"md-icon-button\" aria-label=\"add\" ng-click=\"go_to(\'attendance.detail.room.people.create\')\"><ng-md-icon icon=\"add\"></ng-md-icon></md-button></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.groups\')\"><ng-md-icon icon=\"group_add\"></ng-md-icon><p>Grupos</p></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.qr\')\"><ng-md-icon icon=\"fingerprint\"></ng-md-icon><p>Identificadores</p></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.credentials\')\"><ng-md-icon icon=\"recent_actors\"></ng-md-icon><p>Credenciales</p></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.import\')\"><ng-md-icon icon=\"attachment\"></ng-md-icon><p>Importar</p></md-list-item><md-list-item ng-click=\"go_to(\'attendance.detail.room.export\')\"><ng-md-icon icon=\"import_export\"></ng-md-icon><p>Exportar</p></md-list-item><md-list-item ui-sref=\"attendance.detail.settings.update\"><ng-md-icon icon=\"settings\"></ng-md-icon><p>Configuración</p></md-list-item><md-subheader class=\"md-no-sticky\">Ambientes</md-subheader><md-list-item ng-click=\"select_main_room()\"><ng-md-icon icon=\"home\"></ng-md-icon><p>Principal</p></md-list-item><md-list-item ng-if=\"rooms.length == 0\" class=\"wargos-text-align\"><p>No existe <i>salas</i> registrados</p></md-list-item><md-list-item ng-repeat=\"room in rooms\" ng-click=\"selectRoom(room, $index)\"><img alt=\"{{room.name}}\" ng-src=\"{{loadImageGroup(room.image)}}\" class=\"md-avatar\"><p>{{room.name}}</p><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"go_to_participants(room)\"><ng-md-icon icon=\"people\"></ng-md-icon>Agregar participantes</md-button></md-menu-item><md-menu-item><md-button ng-click=\"generate_registration_token(room)\"><ng-md-icon icon=\"link\"></ng-md-icon>Generar token de registro</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"go_to_room(room)\"><ng-md-icon icon=\"edit\"></ng-md-icon>Editar</md-button></md-menu-item><md-menu-item><md-button ng-click=\"show_confirm_remove_room(room, $event)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></md-list><div layout=\"row\"><div flex=\"\"></div><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"createRoom($event)\"><ng-md-icon icon=\"add\"></ng-md-icon>Sala</md-button></div></md-content></div><div layout=\"column\" flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></div></div></md-content>");
$templateCache.put("app/attendance/home/index.html","<md-toolbar class=\"md-whiteframe-4dp\"><div class=\"md-toolbar-tools wargos-main-header\"><md-button class=\"md-icon-button\" aria-label=\"Menu\" ng-click=\"toggleSidenav(\'left\')\"><ng-md-icon icon=\"menu\"></ng-md-icon></md-button><h3>Attendance</h3></div></md-toolbar><md-content layout-padding=\"\"><div class=\"att-home-main-image\"><img src=\"assets/images/attendance-logo.png\" alt=\"logo\"></div><blockquote><div layout-padding=\"\" layout=\"row\"><div flex=\"\"></div><div><b>Para crear un area haga <i>click</i> en este icono<ng-md-icon icon=\"menu\"></ng-md-icon>ubicado en la parte superior izquierdo.</b></div><div flex=\"\"></div></div><div layout=\"row\"><div flex=\"\"></div><md-button class=\"md-raised md-primary\" ui-sref=\"attendance.area.list\">Administrar areas</md-button><div flex=\"\"></div></div></blockquote><blockquote><h1>Funcionalidad</h1><h3>V1.1.0</h3><ul><li>Refactored all services</li><li>Refactores web project</li><li>Refactores database model schemas</li><li>Updated project theme to pink</li><li>Updated project Rest API to V3 (version 3)</li></ul><h3>V1.0.6</h3><ul><li>Offline Scaned show latest participant</li><li>Online Scaned show latest participant</li></ul><h3>V1.0.5</h3><ul><li>Hide left toolbar</li><li>Add easy access area configuration icons</li><li>Refactor administrator panel</li><li>Refactor disable and enable management area\'s buttons</li><li>Fixed room manager problem</li><li>Fixed event update problem</li><li>BUG: Camera scan for offline mode is not working for < android 6.0</li><li>BUG: NFC scanner is slow it should be faster</li></ul><h3>V1.0.4</h3><ul><li>Android updated support for 6.1</li><li>NFC support to take attendance</li><li>Implemented android NFC scanner</li><li>BUG: Scanner does not work on adroid 6.0.1</li></ul><h3>V1.0.3</h3><ul><li>Back-end was migrated to ES6</li><li>BUG: Fixed overlaping of participant label and the list</li></ul><h3>V1.0.2</h3><ul><li>Added search filter on people and room manager</li><li>Added Toast service and delete notes functionality</li><li>Adding notes to attendance</li><li>Updated home page</li><li>BUG: Att home header is not displaying when it has an alive session</li><li>BUG: qr is not generation because its not alpha numeric keys</li></ul><h3>V1.0.1</h3><ul><li>Added search filter on people and room manager</li><li>Generated reports by groups</li><li>Generated reports by groups</li><li>Added skeleton about QR generator template</li><li>Updated QR generator library</li><li>Removed counter references</li><li>BUG: remove UUID generator, Implement an small one less than 25 alpha-numeric</li><li>BUG: when user is updationg an area and save it. it does not redirect to areas list screen</li><li>BUG: typo error and added change log page</li></ul><h3>V1.0.0</h3><ul><li>WEB</li><ul><li>Asistencia</li><li>Mutiple administradores</li><li>Areas</li><li>Salas</li><li>Importar</li><li>Exportar</li><li>Reporte</li><ul><li>Grupos</li><li>Primero en llegar</li><li>Tiempo real por grupos</li></ul></ul><li>Mobile</li><ul><li>Off-line</li><li>Asistencia</li></ul></ul></blockquote></md-content>");
$templateCache.put("app/attendance/messages/index.html","<md-dialog aria-label=\"Message\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mensaje</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close dialog\" ng-click=\"cancel()\"><ng-md-icon icon=\"close\"></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Nota:</label> <textarea ng-model=\"item.text\" md-maxlength=\"350\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><p><i>Las notas se encuentran en el detalle del participante</i></p></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\">cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"answer(item)\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/attendance/provider/index.html","<div layout=\"column\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ng-click=\"toggleSidenav(\'left\')\" hide-gt-md=\"\" aria-label=\"Menu\"><ng-md-icon icon=\"menu\"></ng-md-icon></md-button><h3>Proveedores</h3><div layout=\"row\" hide-xs=\"\" hide-sm=\"\"><md-button ng-repeat=\"page in pages\" ui-sref=\"{{page.route}}\">{{page.title}}</md-button></div><span flex=\"\"></span><md-button aria-label=\"Search\" ng-click=\"showSearch = !showSearch\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button><md-button aria-label=\"Open Settings\" ng-click=\"showGridBottomSheet($event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button></div></md-toolbar><ui-view layout=\"column\" layout-fill=\"\"></ui-view></div>");
$templateCache.put("app/attendance/templates/list-bottom.html","<md-bottom-sheet class=\"md-grid\" layout=\"column\" ng-cloak=\"\"><div layout=\"row\" layout-align=\"center center\"><h4>With clickOutsideToClose option, drag down or press ESC to close</h4></div><div><md-list flex=\"\" layout=\"row\" layout-align=\"center center\"><md-list-item ng-repeat=\"item in items\"><md-button class=\"md-grid-item-content\" ng-click=\"listItemClick($index)\"><ng-md-icon icon=\"{{item.icon}}\" size=\"64\" style=\"width: 64px;height: 55px;\"></ng-md-icon><div class=\"md-grid-text\">{{item.name}}</div></md-button></md-list-item></md-list></div></md-bottom-sheet>");
$templateCache.put("app/components/header/header.html","<md-toolbar layout=\"row\" ng-if=\"!user\" class=\"att-toolbar\"><div class=\"md-toolbar-tools att-toolbar-tools\"><a ui-sref=\"home\"><h3>Attendance</h3></a><h5 class=\"att-header-h5\" hide=\"\" show-gt-sm=\"\">Una solucion para el control de asistencia...</h5><span flex=\"\"></span><div layout=\"row\" class=\"att-row\"><a ui-sref=\"home.about\">¿que es attendance?</a> <a ui-sref=\"home.register\">¿quienes somos?</a> <a ui-sref=\"home.register\">registrarse</a></div><div layout=\"row\" class=\"att-row\"><md-button class=\"md-raised\" ui-sref=\"home.login\">iniciar sesion</md-button></div></div></md-toolbar><md-toolbar layout=\"row\" ng-if=\"user\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"toggleSidenav(\'left\')\" hide-gt-sm=\"\" class=\"md-icon-button\"><ng-md-icon icon=\"menu\"></ng-md-icon></md-button><a ui-sref=\"attendance.home\"><h1>Attendance</h1></a><div layout=\"row\" hide-xs=\"\" hide-sm=\"\"><md-button ng-repeat=\"option in options\" ui-sref=\"{{option.route}}\">{{option.value}}</md-button></div><span flex=\"\"></span><div layout=\"row\"><md-button aria-label=\"username\">{{user.name}}</md-button><md-button class=\"md-raised\" ng-click=\"logout()\" style=\"color: #333\">cerrar session</md-button></div></div></md-toolbar><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" hide-gt-sm=\"\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 ui-sref=\"home\">Attendance</h1></div></md-toolbar><div layout=\"column\"><md-button ng-repeat=\"option in options\" ui-sref=\"{{option.route}}\">{{option.value}}</md-button></div></md-sidenav>");
$templateCache.put("app/home/about/index.html","<md-content class=\"att-about\"><div class=\"title\"><h2 class=\"md-display-1 text-center\">ACERCA DE ATTENDANCE</h2></div><div class=\"content\"><div layout=\"row\"><div hide=\"\" show-xs=\"\" flex=\"100\"><p>Attendance es una startup para el control de asistencia, una herramienta web y movil que ayuda en el proceso de tomar asistencia mas rapido y facil.</p><md-list><md-list-item><p>Inportar desde un excel</p></md-list-item><md-list-item><p>Generar los identificadores QR desde la aoplicacion</p></md-list-item><md-list-item><p>Usar los dispositivos moviles como scanners para controlar la asistencia</p></md-list-item></md-list></div><div hide=\"\" show-gt-xs=\"\" flex=\"20\"></div><div hide=\"\" show-gt-xs=\"\" flex=\"60\"><p>Attendance es una startup para el control de asistencia, una herramienta web y movil que ayuda en el proceso de tomar asistencia mas rapido y facil.</p><md-list><md-list-item><p>Inportar desde un excel</p></md-list-item><md-list-item><p>Generar los identificadores QR desde la aoplicacion</p></md-list-item><md-list-item><p>Usar los dispositivos moviles como scanners para controlar la asistencia</p></md-list-item></md-list></div></div><div hide=\"\" show-gt-xs=\"\" flex=\"20\"></div></div><div class=\"media-container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"25\" flex-sm=\"0\" flex-xs=\"100\"></div><div flex=\"25\" flex-sm=\"50\" flex-xs=\"100\"><div class=\"container\" layout=\"row\" id=\"fb-root\"><div class=\"fb-page\" data-href=\"https://web.facebook.com/NinjaAttendance\" data-width=\"380\" data-hide-cover=\"false\" data-show-facepile=\"false\" data-show-posts=\"false\"></div></div></div><div flex=\"25\" flex-sm=\"50\" flex-xs=\"100\"><div class=\"play-link\"><a href=\"https://play.google.com/store/apps/details?id=ninjas.wargos.attendance&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\"><img alt=\"Disponible en Google Play\" src=\"https://play.google.com/intl/en_us/badges/images/generic/es_badge_web_generic.png\"></a></div></div><div flex=\"25\" flex-sm=\"0\" flex-xs=\"100\"></div></div></div><div class=\"app-preview\" layout=\"row\" layout-xs=\"column\"><div flex=\"25\" flex-sm=\"0\" flex-xs=\"100\"></div><div layout-padding=\"\" flex=\"25\" flex-sm=\"50\" flex-xs=\"100\"><img ng-src=\"assets/images/mobile-att.jpg\" class=\"md-card-image\" alt=\"Washed Out\"></div><div class=\"right\" layout-padding=\"\" flex=\"25\" flex-sm=\"50\" flex-xs=\"100\"><div><img ng-src=\"assets/images/04012017230740.png\" class=\"md-card-image\" alt=\"Washed Out\"></div><div><img ng-src=\"assets/images/04012017230755.png\" class=\"md-card-image\" alt=\"Washed Out\"></div><div><img ng-src=\"assets/images/04012017232626.png\" class=\"md-card-image\" alt=\"Washed Out\"></div><div><img ng-src=\"assets/images/04012017232852.png\" class=\"md-card-image\" alt=\"Washed Out\"></div></div><div flex=\"25\" flex-sm=\"0\" flex-xs=\"100\"></div></div></md-content>");
$templateCache.put("app/session/login/index.html","<md-content><div class=\"main-login\"><md-toolbar class=\"att-toolbar\"><h1 class=\"md-toolbar-tools att-toolbar-tools\">Attendance</h1></md-toolbar><div layout=\"row\"><div flex=\"50\"><md-content layout-padding=\"\"><div ng-include=\"template\"></div><md-content></md-content></md-content></div><div flex=\"50\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-card layout-padding=\"\" ng-if=\"!loading\"><md-card-title><md-card-title-text><span class=\"md-headline\">Iniciar session</span></md-card-title-text></md-card-title><md-card-content><form ng-submit=\"login(item)\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Email</label> <input ng-model=\"item.email\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Password</label> <input ng-model=\"item.password\" type=\"password\" required=\"\"></md-input-container><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-primary\">Iniciar session</md-button></md-card-actions></form></md-card-content></md-card></div></div></div></md-content>");
$templateCache.put("app/session/register/index.html","<md-content><div class=\"reguister-login\"><md-toolbar class=\"att-toolbar\"><h1 class=\"md-toolbar-tools att-toolbar-tools\">Attendance</h1></md-toolbar><div layout=\"row\"><div flex=\"50\"><md-content layout-padding=\"\"><div ng-include=\"template\"></div><md-content></md-content></md-content></div><div flex=\"50\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-card layout-padding=\"\" ng-if=\"!loading\"><md-card-title><md-card-title-text><span class=\"md-headline\">Registrar nuevo usuario</span></md-card-title-text></md-card-title><md-card-content><form name=\"loginForm\" ng-submit=\"register(item)\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Email</label> <input required=\"\" type=\"email\" ng-model=\"item.email\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Password</label> <input required=\"\" ng-model=\"item.password\" type=\"password\"><div ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-divider></md-divider><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre</label> <input required=\"\" ng-model=\"item.first_name\"><div ng-messages=\"loginForm.first_name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Apellido</label> <input required=\"\" ng-model=\"item.last_name\"><div ng-messages=\"loginForm.last_name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Numero de celular</label> <input required=\"\" ng-model=\"item.phone\"><div ng-messages=\"loginForm.phone.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"home\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Aceptar</md-button></div></form></md-card-content></md-card></div></div></div></md-content>");
$templateCache.put("app/session/templates/signup.message.html","<div><p>Ofrece un servicio hasta <b>1000 participantes</b> de forma <b>gratuita</b>.</p><ul><li><b>Generador de credenciales</b></li><li>Reguistrar asistencia</li><li>Guardar insidentes</li><li>Credenciales con QR</li><li>Aplicación android</li><li><b>Credenciales digitales</b></li><li>Importar desde un excel tu lista de participantes</li><li>Exportar a un exel la asistencia generada por tus participantes</li></ul><p>Integración</p><ul><li>Integración son otros sistemas</li><li>Rest API</li></ul><p>Al registrarse y al iniciar sesión en este servicio, usted acepta nuestro:</p><ul><li><a href=\"#\">Politica de privacidad</a></li><li><a href=\"#\">Attendance Terminos y condiciones</a></li></ul><p>Nuestro equipo continua trabajado para mejorar el sistema...</p><p>Gracias por las molestias.</p><p>Consultas llamar al Cel: <b><i>+591 70156988</i></b> o escribirnos al whatsapp</p></div>");
$templateCache.put("app/session/update/update.tmpl.html","<md-dialog aria-label=\"Update user\" style=\"width: 500px;\"><form ng-cloak=\"\" name=\"loginForm\" ng-submit=\"update(item)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Update user</h2></div></md-toolbar><md-dialog-content layout-padding=\"\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Email</label> <input required=\"\" type=\"email\" name=\"clientEmail\" ng-model=\"item.email\"><div ng-messages=\"loginForm.clientEmail.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Name</label> <input required=\"\" ng-model=\"item.name\"><div ng-messages=\"loginForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Password nuevo</label> <input required=\"\" ng-model=\"item.new_password\" type=\"password\"><div ng-messages=\"loginForm.new_password.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Confirmar password nuevo</label> <input required=\"\" ng-model=\"item.confirm_password\" type=\"password\"><div ng-messages=\"loginForm.confirm_password.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Numero de celular</label> <input required=\"\" ng-model=\"item.cel\"><div ng-messages=\"loginForm.clientName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\">Actualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/session/views/forgot.html","<div>Aun no esta Implementado!</div>");
$templateCache.put("app/attendance/area/detail/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Actualizar area</h1></div></md-toolbar><md-content layout-padding=\"\" class=\"md-inline-form\"><div layout=\"row\"><div flex=\"70\"><form ng-submit=\"updateArea(item)\"><div layout=\"column\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>titulo</label> <input ng-model=\"item.name\" type=\"text\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Image</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"><div ng-messages=\"containerForm.image.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised\" ui-sref=\"attendance.area.list\">Cancelar</md-button><md-button class=\"md-raised md-primary\" type=\"submit\">Actualizar</md-button></div></div></form></div><div flex=\"30\"><img class=\"md-card-image\" ng-src=\"{{current_image}}\"> <button ngf-select=\"upload($file)\">Cargar una foto</button></div></div></md-content>");
$templateCache.put("app/attendance/area/list/index.html","<md-content><md-list><md-subheader class=\"md-no-sticky\">Areas</md-subheader><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised md-primary\" ng-click=\"create_area()\"><ng-md-icon icon=\"add\"></ng-md-icon>Crear nueva area</md-button></div><md-list-item ng-repeat=\"item in items\" ng-click=\"selectItem(item)\"><p>{{item.name}}</p><md-button class=\"md-raised md-primary\" ng-click=\"update_area(item, $index)\">deshabilitar</md-button></md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/attendance/area/old/index.html","<md-content><md-list><md-subheader class=\"md-no-sticky\">Areas historicas</md-subheader></md-list><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"query.page\" md-total=\"{{count}}\" md-on-paginate=\"getItems\" md-page-select=\"\"></md-table-pagination><md-list><md-list-item ng-repeat=\"item in items\" ng-click=\"selectItem(item)\"><p>{{item.name}}</p><md-button class=\"md-raised md-primary\" ng-click=\"update_area(item, $index)\">habilitar</md-button></md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/attendance/detail/incident/index.html","<div layout=\"row\" layout-fill=\"\"><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"true\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><h1>Incidentes</h1><span flex=\"\"></span><h1>{{gate.type}}</h1></div></md-toolbar><md-content flex=\"\"><md-subheader class=\"md-no-sticky\">Actual</md-subheader><div ng-if=\"gate === null\" class=\"wargos-text-align\"><b>seleccione un incidentes actual</b></div><div ng-if=\"gate != null\" class=\"wargos-text-align\"><p>{{gate.name}}</p></div><md-subheader class=\"md-no-sticky\">Antiguos</md-subheader><div ng-if=\"gates.length == 0\" class=\"wargos-text-align\"><b>No existe <i>incidentes</i> registrados</b></div><md-list><md-list-item ng-repeat=\"gate in gates\" ng-click=\"select_gate(gate)\"><p>{{gate.name}}</p></md-list-item></md-list></md-content></md-sidenav></div>");
$templateCache.put("app/attendance/detail/loans/index.html","<div layout=\"row\" layout-fill=\"\"><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"true\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><h1>Pestamos</h1><span flex=\"\"></span></div></md-toolbar><md-content flex=\"\"><md-subheader class=\"md-no-sticky\">Configuración</md-subheader><md-list><md-list-item ui-sref=\"attendance.detail.loans.stores()\"><ng-md-icon icon=\"store\"></ng-md-icon><p>Almacenes</p></md-list-item><md-list-item ui-sref=\"attendance.detail.loans.objects()\"><ng-md-icon icon=\"label_outline\"></ng-md-icon><p>Objectos</p></md-list-item><md-list-item ui-sref=\"attendance.detail.loans.qr()\"><ng-md-icon icon=\"fingerprint\"></ng-md-icon><p>Identificadores</p></md-list-item></md-list></md-content></md-sidenav></div><style media=\"screen\">\r\n.stores-qr-container {\r\n  text-align: center;\r\n}\r\n.stores-qr-container h6 {\r\n  margin: 0px;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/participant/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Actualizar participante</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"update(item)\"><md-input-container class=\"md-block\"><label>CODIGO</label> <input required=\"\" type=\"text\" name=\"uid\" ng-model=\"item.uid\"><div ng-messages=\"containerForm.uid.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Apellidos</label> <input required=\"\" type=\"text\" name=\"last_name\" ng-model=\"item.last_name\"><div ng-messages=\"containerForm.last_name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"first_name\" ng-model=\"item.first_name\"><div ng-messages=\"containerForm.first_name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Celular</label> <input required=\"\" type=\"text\" name=\"cel\" ng-model=\"item.cel\"><div ng-messages=\"containerForm.cel.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Email</label> <input required=\"\" type=\"text\" name=\"email\" ng-model=\"item.email\"><div ng-messages=\"containerForm.email.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Dirección</label> <input type=\"text\" name=\"address\" ng-model=\"item.address\"><div ng-messages=\"containerForm.address.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>CI</label> <input type=\"text\" name=\"ci\" ng-model=\"item.ci\"><div ng-messages=\"containerForm.ci.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Imagen</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"></md-input-container><button class=\"button\" ngf-select=\"upload($file)\">Cargar una foto</button><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"goToBack()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form><md-toolbar><h1 class=\"md-toolbar-tools\">Notas</h1></md-toolbar><md-content><section ng-repeat=\"room in rooms\"><md-subheader class=\"md-primary\">{{room.name}}</md-subheader><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"note in room.notes\"><md-card><md-card-header><md-card-avatar><ng-md-icon icon=\"message\"></ng-md-icon></md-card-avatar><md-card-header-text><span class=\"md-title\">{{note.event.name}}</span> <span class=\"md-subhead\">{{note.event.start | date: \'yyyy-MM-dd HH:mm\'}} - {{note.event.end | date: \'yyyy-MM-dd HH:mm\'}}</span></md-card-header-text></md-card-header><md-card-content><p ng-if=\"!note.update\">{{note.text}}</p><md-input-container class=\"md-block\" ng-if=\"note.update\"><label>Note</label> <textarea ng-model=\"update.text\" md-maxlength=\"350\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"remove_note(note, room.notes, $index)\"><ng-md-icon icon=\"delete\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"edit\" ng-if=\"note.update\"><ng-md-icon icon=\"close\" ng-click=\"note.update = false; update.text = \'\'\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"edit\"><ng-md-icon icon=\"edit\" ng-click=\"note.update = true; update.text = note.text\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"save\" ng-click=\"update_note(note)\"><ng-md-icon icon=\"save\"></ng-md-icon></md-button></md-card-actions></md-card></div></div></section></md-content><md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"remove(item)\">Eliminar</md-button></div></md-content></md-content>");
$templateCache.put("app/attendance/detail/people/index.html","<div layout=\"row\" layout-fill=\"\"><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"true\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><h2>Incidentes</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Edit\" ui-sref=\"attendance.detail.people.gate.create()\"><ng-md-icon icon=\"add\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"history\" ui-sref=\"attendance.detail.incident.main\"><ng-md-icon icon=\"history\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\"><md-subheader class=\"md-no-sticky\">Actual</md-subheader><div ng-if=\"gate == null\" class=\"wargos-text-align\"><b>seleccione el incidentes actual</b></div><div ng-if=\"gate != null\" class=\"wargos-text-align\"><p>{{gate.name}}</p></div><md-subheader class=\"md-no-sticky\">Antiguos</md-subheader><div ng-if=\"gates.length == 0\" class=\"wargos-text-align\"><b>No existe <i>incidentes</i> registrados</b></div><md-list><md-list-item ng-repeat=\"gate in gates\" ng-click=\"select_gate(gate)\"><p>{{gate.name}}</p><ng-md-icon icon=\"edit\" ng-click=\"go_to_gate(gate, $index, $event)\" aria-label=\"Go to gate\" class=\"md-secondary md-hue-3\"></ng-md-icon></md-list-item></md-list></md-content></md-sidenav></div>");
$templateCache.put("app/attendance/detail/room/index.html","<md-content flex=\"\" class=\"md-whiteframe-5dp\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content>");
$templateCache.put("app/attendance/detail/settings/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"home\" ui-sref=\"attendance.detail.settings.main\"><ng-md-icon icon=\"home\"></ng-md-icon></md-button><md-button aria-label=\"states\" ui-sref=\"attendance.detail.settings.udfs\"><ng-md-icon icon=\"dashboard\"></ng-md-icon>UDFs</md-button><md-button aria-label=\"states\" ui-sref=\"attendance.detail.settings.states.main\"><ng-md-icon icon=\"layers\"></ng-md-icon>Estados</md-button><md-button aria-label=\"settings\" ui-sref=\"attendance.detail.settings.administrators\"><ng-md-icon icon=\"settings\"></ng-md-icon>Administradores</md-button><md-button aria-label=\"edit\" ui-sref=\"attendance.detail.settings.update\"><ng-md-icon icon=\"edit\"></ng-md-icon>Editar</md-button><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openEventMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"show_confirm($event)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content flex=\"\" class=\"md-whiteframe-5dp\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content>");
$templateCache.put("app/attendance/detail/studio/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Estudio</h1></md-toolbar><md-content><ui-view></ui-view></md-content>");
$templateCache.put("app/attendance/detail/studio/item.html","<md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre</label> <input ng-model=\"item.name\" required=\"\"></md-input-container>");
$templateCache.put("app/attendance/detail/template/index.html","<div layout=\"row\" layout-fill=\"\"><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content><md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"true\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><h2>Plantillas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Crear\" ui-sref=\"attendance.detail.template.create\"><ng-md-icon icon=\"add\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\"><md-subheader class=\"md-no-sticky\">Templates</md-subheader><md-list><div ng-if=\"templates.length == 0\" class=\"wargos-text-align\"><b>No existe <i>plantillas</i> registrados</b></div><md-list-item ng-repeat=\"template in templates\" ng-click=\"go_to_update(template)\" ng-class=\"{isSelected: template.selected}\"><p>{{template.name}}</p><md-button ng-click=\"select_template(template, $index)\" aria-label=\"message\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"play_arrow\" ng-class=\"{isDefault: template.isDefault}\"></ng-md-icon></md-button></md-list-item></md-list></md-content></md-sidenav></div>");
$templateCache.put("app/attendance/detail/token/index.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Token de registro</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div flex-gt-xs=\"\"><h4>Determine la duracion del token.</h4><md-datepicker ng-model=\"room.duration\" md-placeholder=\"Enter date\"></md-datepicker></div><md-button class=\"md-raised md-primary\" ng-click=\"go_to_staff_page()\">Ir a la pagina de registro</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/attendance/print/assets-qr/index.html","<div layout-fill=\"\"><div ng-repeat=\"asset in assets\" style=\"float:left;padding:10px;text-align: center;\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"size\" input-mode=\"\'text\'\" text=\"asset.qr\"></qr><div style=\"text-align: center;\"><h5 style=\"padding: 0px; margin:0px; font-size: 10px;\">{{asset.name}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{asset.qr}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{asset.index}}</h5></div></div></div>");
$templateCache.put("app/attendance/print/credentials/index.html","<div layout-fill=\"\"><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div id=\"credential-container\"></div></div>");
$templateCache.put("app/attendance/print/qr/index.html","<div layout-fill=\"\"><div ng-repeat=\"participant in participants\" style=\"float:left;padding:10px;text-align: center;\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"size\" input-mode=\"\'text\'\" text=\"participant.qr\"></qr><div style=\"text-align: center;\"><h5 style=\"padding: 0px; margin:0px; font-size: 10px;\">{{participant.first_name}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{participant.last_name}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{participant.qr}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{participant.index}}</h5></div></div></div>");
$templateCache.put("app/attendance/provider/studio/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Estudio</h1></md-toolbar><md-content><ui-view></ui-view></md-content>");
$templateCache.put("app/attendance/provider/studio/item.html","<md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre</label> <input ng-model=\"item.name\" required=\"\"></md-input-container>");
$templateCache.put("app/attendance/detail/incident/list/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Incidentes - {{gate.name}}</h1><span flex=\"\"></span><h1>{{participant.last_name}} {{participant.first_name}}</h1><md-button ng-if=\"participant\" class=\"md-icon-button\" aria-label=\"cancel\" ng-click=\"unselect_participant()\"><ng-md-icon icon=\"cancel\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\"><div layout=\"column\"><div layout=\"row\"><div><div layout=\"column\"><md-subheader class=\"md-no-sticky\">Participantes</md-subheader><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div></div><md-list><md-list-item ng-repeat=\"participant in participants\" ng-click=\"select_participant(participant, $index, $event)\"><img ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><p>{{participant.last_name}} {{participant.first_name}}</p></md-list-item></md-list><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div></div><div flex=\"\"><div layout=\"column\"><div layout=\"row\"><div flex-gt-xs=\"\"><h4>Inicio</h4><md-datepicker ng-model=\"timer.start\" md-placeholder=\"Enter date\"></md-datepicker><input type=\"time\" ng-model=\"timer.start\"></div><div flex-gt-xs=\"\"><h4>Fin</h4><md-datepicker ng-model=\"timer.end\" md-placeholder=\"Enter date\"></md-datepicker><input type=\"time\" ng-model=\"timer.end\"></div><div><h4>-</h4><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"find_markers(timer)\"><ng-md-icon icon=\"search\"></ng-md-icon>Buscar</md-button></div></div></div><md-divider></md-divider><md-table-container ng-if=\"gate.type === \'states\'\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Fecha</th><th md-column=\"\">Participante</th><th md-column=\"\">Incidente</th><th md-column=\"\">notas</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"incident\" md-select-id=\"_id\" md-auto-select=\"\" ng-repeat=\"incident in incidents\"><td md-cell=\"\">{{incident.created | date:\"MM/dd/yyyy HH:mm:ss\"}}</td><td md-cell=\"\">{{incident.participant.last_name}} {{incident.participant.first_name}}</td><td md-cell=\"\">{{incident.state}}</td><td md-cell=\"\">{{incident.text}}</td></tr></tbody></table></md-table-container><md-table-container ng-if=\"gate.type === \'pair\'\"><md-subheader class=\"md-no-sticky\">{{participant.last_name}} {{participant.first_name}} {{incidents.length}}</md-subheader><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Fecha</th><th md-column=\"\">{{gate.pair.in}}</th><th md-column=\"\">Fecha</th><th md-column=\"\">{{gate.pair.out}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"incident\" md-select-id=\"_id\" md-auto-select=\"\" ng-repeat=\"incident in incidents\"><td md-cell=\"\">{{incident.in.created | date:\"MM/dd/yyyy HH:mm:ss\"}}</td><td md-cell=\"\">{{incident.in.text}}</td><td md-cell=\"\">{{incident.out.created | date:\"MM/dd/yyyy HH:mm:ss\"}}</td><td md-cell=\"\">{{incident.out.text}}</td></tr></tbody></table></md-table-container><div ng-if=\"incidents.length == 0\" class=\"wargos-text-align\"><b>No existe <i>incidentes</i> registrados</b></div></div></div></div></md-content>");
$templateCache.put("app/attendance/detail/loans/main/index.html","<md-content flex=\"\"><div class=\"att-stores\"><div ng-repeat=\"store in stores\" class=\"att-store\"><div class=\"store-container\"><div layout=\"raw\" class=\"att-store-tool\"><ng-md-icon icon=\"refresh\" ng-click=\"refresh_assets(store, $index)\"></ng-md-icon><div flex=\"\"></div><ng-md-icon icon=\"close\" ng-click=\"remove_store(store, $index)\"></ng-md-icon></div><div ng-if=\"store.type === \'store\'\" class=\"att-store-header\"><div ng-if=\"!store.data.image\"><img ng-src=\"assets/images/store-icon.png\"></div><div ng-if=\"store.data.image\"><img ng-src=\"{{loadImage(store.data.image)}}\"></div><h4 ui-sref=\"attendance.detail.loans.stores_update({store_id: store._id})\">{{store.data.name}}</h4></div><div ng-if=\"store.type === \'participant\'\" class=\"att-store-header\"><div><img ng-src=\"{{loadImage(store.data.image)}}\"></div><h4 ui-sref=\"attendance.detail.participant({participant_id: store._id})\">{{store.data.last_name}} {{store.data.first_name}}</h4></div><div class=\"store-form\"><input type=\"text\" name=\"search\" placeholder=\"Buscar\" ng-model=\"store.search\" ng-change=\"search_assets(store, store.search)\"></div><md-list class=\"store-assets-list\"><md-list-item ng-repeat=\"asset in store.assets\" ui-sref=\"attendance.detail.loans.assets_update({asset_id: asset._id})\" class=\"md-2-line\"><div class=\"md-list-item-text att-store-list-item\"><h3>{{asset.name}}</h3><p style=\"font-size: 10px;\">{{asset.uid}}</p></div><md-button aria-label=\"isloading\" ng-click=\"move_asset(asset, store, $index)\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"arrow_forward\"></ng-md-icon></md-button></md-list-item><md-divider></md-divider></md-list><div layout=\"raw\" ng-if=\"!store.isCreating\"><div flex=\"\"></div><md-button class=\"md-raised md-mini\" ng-click=\"open_create_asset(store)\" aria-label=\"changestatus\"><ng-md-icon icon=\"add\"></ng-md-icon>Almacen</md-button></div><div ng-if=\"store.isCreating\"><div class=\"store-form\"><h3>Almacen</h3><form ng-submit=\"save_asset(store.asset, store)\"><input type=\"text\" name=\"uid\" ng-model=\"store.asset.uid\" placeholder=\"Codigo\"><br><input type=\"text\" name=\"name\" ng-model=\"store.asset.name\" placeholder=\"Nombre\"><br><input type=\"text\" name=\"description\" ng-model=\"store.asset.description\" placeholder=\"Descripción\"><div layout=\"raw\"><div flex=\"\"></div><md-button class=\"md-raised md-primary\" type=\"submit\"><ng-md-icon icon=\"add\"></ng-md-icon>Crear</md-button></div></form></div></div></div></div><div><div><md-button class=\"md-raised md-mini\" ng-click=\"select_store()\" aria-label=\"changestatus\"><ng-md-icon icon=\"add\"></ng-md-icon>Almacen</md-button></div><div><md-button class=\"md-raised md-mini\" ng-click=\"select_participant()\" aria-label=\"changestatus\"><ng-md-icon icon=\"add\"></ng-md-icon>Participante</md-button></div></div></div></md-content><style media=\"screen\">\r\n.att-stores {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-x: scroll;\r\n  display: flex;\r\n}\r\n.att-store {\r\n  display: inline-block;\r\n  float: left;\r\n}\r\n.store-container {\r\n  width: 290px;\r\n  height: 100%;\r\n  /*height: 100%;*/\r\n  overflow-y: scroll;\r\n}\r\n.att-stores .att-store-list-item {\r\n  overflow: hidden;\r\n}\r\n.att-stores .att-store-header {\r\n  /*height: 100px;*/\r\n  padding: 5px;\r\n  text-align: center;\r\n}\r\n.att-stores .att-store-header img {\r\n  height: 50px;\r\n}\r\n.att-stores .att-store-header h4 {\r\n  padding: 3px;\r\n  margin: 0px;\r\n  /*text-align: center;*/\r\n}\r\n.att-store-tool {\r\n  padding: 3px;\r\n}\r\n.att-stores .store-form {\r\n  margin: 5px;\r\n}\r\n.att-stores .store-form h3 {\r\n  margin: 5px;\r\n}\r\n.att-stores .store-form input {\r\n  width: 96%;\r\n  margin: 1%;\r\n  padding: 1%;\r\n}\r\n.att-stores .store-assets-list {\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/loans/main/select-participant.html","<md-dialog aria-label=\"Actualizar evento\" class=\"att-event-update\"><md-toolbar><h1 class=\"md-toolbar-tools\">Seleccionar almacen</h1></md-toolbar><md-dialog-content flex=\"\"><md-content layout-padding=\"\"><div layout=\"column\"><md-subheader class=\"md-no-sticky\">Participantes</md-subheader><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div></div><md-list><md-list-item ng-repeat=\"participant in participants\" ng-click=\"select_participant(participant, $index, $event)\"><img ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><p>{{participant.last_name}} {{participant.first_name}}</p></md-list-item></md-list><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"></div><md-button ng-click=\"cancel()\">Cancelar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/attendance/detail/loans/main/select-store.html","<md-dialog aria-label=\"Actualizar evento\" class=\"att-store-dialog\"><md-toolbar><h1 class=\"md-toolbar-tools\">Seleccionar almacen</h1></md-toolbar><md-dialog-content flex=\"\"><md-content layout-padding=\"\"><md-list><md-list-item ng-repeat=\"store in stores\" ng-click=\"select_item(store)\"><p>{{store.name}}</p><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"2\"><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"store_print(store)\"><ng-md-icon icon=\"message\"></ng-md-icon>Imprimir</md-button></md-menu-item><md-menu-item><md-button ng-click=\"store_remove(store, $index)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar almacen</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><md-divider></md-divider></md-list><form ng-submit=\"create_store(item)\" name=\"containerForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre del almacen</label> <input type=\"text\" name=\"name\" ng-model=\"item.name\" required=\"\"><div ng-messages=\"containerForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><div flex=\"\"></div><md-button type=\"submit\" class=\"md-raised md-primary\">Crear</md-button></div></form></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"></div><md-button ng-click=\"cancel()\">Cancelar</md-button></md-dialog-actions></md-dialog><style media=\"screen\">\r\n.att-store-dialog {\r\n  width: 350px;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/loans/objects/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Objectos</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Nombre</label> <input ng-model=\"query.name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_asset(query.name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span></div></md-toolbar><md-content><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><md-button ng-class=\"{\'-created\':\'md-mini md-fab\', \'created\': \'md-icon-button\', \'name\': \'md-icon-button\'}[order]\" aria-label=\"keyboard_arrow_down\" ng-click=\"change_order(\'-created\')\"><ng-md-icon icon=\"keyboard_arrow_down\"></ng-md-icon></md-button><md-button ng-class=\"{\'-created\': \'md-icon-button\', \'created\': \'md-mini md-fab\', \'name\': \'md-icon-button\'}[order]\" aria-label=\"keyboard_arrow_up\" ng-click=\"change_order(\'created\')\"><ng-md-icon icon=\"keyboard_arrow_up\"></ng-md-icon></md-button><md-button ng-class=\"{\'-created\': \'md-icon-button\', \'created\': \'md-icon-button\', \'name\': \'md-mini md-fab\'}[order]\" aria-label=\"reorder\" ng-click=\"change_order(\'name\')\"><ng-md-icon icon=\"reorder\"></ng-md-icon></md-button><span flex=\"\"></span></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[21, 30, 39]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"get_assets\" md-page-select=\"\"></md-table-pagination><div ng-if=\"assets.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"asset in assets\"><md-list-item ng-click=\"go_to_asset(asset, $index)\"><ng-md-icon icon=\"label_outline\"></ng-md-icon><p><b>{{asset.index}}</b> {{asset.name}}</p></md-list-item></div></div></md-content><style media=\"screen\">\r\nng-md-icon.backrpu {\r\n  color: white;\r\n  background: black;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/loans/qr/index.html","<md-content><md-content layout-padding=\"\"><div layout=\"row\" layout-align=\"end\"><md-button aria-label=\"buscar\" class=\"md-raised {{ idLabel }}\" ng-click=\"changeIdentificar()\">Identificador</md-button><md-button aria-label=\"buscar\" class=\"md-raised {{ codeLabel }}\" ng-click=\"changeIdentificar()\">Codigo</md-button><span flex=\"\"></span> <input type=\"number\" class=\"wargos-qr-input\" ng-change=\"updateDefaultData()\" ng-model=\"size\" placeholder=\"200\"> <input type=\"number\" class=\"wargos-qr-input\" ng-change=\"updateDefaultData()\" ng-model=\"limit\" placeholder=\"15\"><md-button aria-label=\"buscar\" class=\"md-raised md-primary\" ng-click=\"getAssets()\">Buscar</md-button><a class=\"md-button md-raised\" target=\"_blank\" ng-href=\"{{print_url}}\" ng-mousedown=\"print()\">Imprimir</a></div></md-content><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Objetos</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Nombre</label> <input ng-model=\"query.name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_assets(query.name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"previous\" ng-click=\"previous()\"><ng-md-icon icon=\"chevron_left\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"reset\" ng-click=\"reset()\">{{query.page}}</md-button><md-button class=\"md-icon-button\" aria-label=\"next\" ng-click=\"next()\"><ng-md-icon icon=\"chevron_right\"></ng-md-icon></md-button></div></md-toolbar><md-content md-theme=\"default\"><div ng-if=\"assets.length == 0\" class=\"wargos-text-align\"><b>No existe <i>objetos</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div layout-padding=\"\" ng-repeat=\"asset in assets\" class=\"qr-body-container\"><a href=\"#/attendance/{{area_id}}/loans/assets/{{asset._id}}\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"size\" input-mode=\"\'text\'\" text=\"asset.qr\" image=\"true\"></qr></a><div class=\"qr-footer\"><h5>{{asset.name}}</h5><h6>{{asset.qr}}</h6><div style=\"padding: 0px; margin:0px; font-size: 8px;\">{{asset.index}}</div></div></div></div></md-content></md-content><style media=\"screen\">\r\n.qr-footer h5, .qr-footer h4, .qr-footer h6 {\r\n  text-align: center;\r\n  padding: 0mm;\r\n  margin: 0mm;\r\n}\r\n.qr-body-container {\r\n  text-align: center;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/loans/stores/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h2>Almacenes</h2><span flex=\"\"></span><md-button aria-label=\"add\" ui-sref=\"attendance.detail.loans.stores_create\"><ng-md-icon icon=\"add\"></ng-md-icon>nuevo almacen</md-button></div></md-toolbar><md-content><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[21, 30, 39]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"get_stores\" md-page-select=\"\"></md-table-pagination><div ng-if=\"stores.length == 0\" class=\"wargos-text-align\"><b>No existe <i>almacenes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"store in stores\"><md-list-item ng-click=\"go_to_store(store, $index)\"><ng-md-icon icon=\"store\"></ng-md-icon><p>{{store.name}}</p></md-list-item></div></div></md-content><style media=\"screen\">\r\nng-md-icon.backrpu {\r\n  color: white;\r\n  background: black;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/people/list/incident.html","<md-dialog aria-label=\"Message\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Crear un nuevo incidente</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close dialog\" ng-click=\"cancel()\"><ng-md-icon icon=\"close\"></ng-md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div class=\"incident-title\"><h1>{{item.option.value}}</h1></div><md-input-container class=\"md-block\"><label>Nota:</label> <textarea ng-model=\"item.text\" md-maxlength=\"350\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\">cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"answer(item)\">Guardar</md-button></md-dialog-actions></form></md-dialog><style media=\"screen\">\r\n.incident-title {\r\n  text-align: center;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/people/list/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-input-container><label>Grupos</label><md-select ng-model=\"select.group\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content flex=\"\"><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[25, 30, 35]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"select_incident(participant, $index, $event)\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><p><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</p><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"go_to_participant(participant, $index)\"><ng-md-icon icon=\"account_box\"></ng-md-icon>Detalle</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></div></div></md-content>");
$templateCache.put("app/attendance/detail/people/list/list.html","<md-dialog aria-label=\"Message\"><md-list><md-list-item ng-repeat=\"item in items\" ng-click=\"answer(item)\"><p>{{item.value}}</p></md-list-item></md-list></md-dialog>");
$templateCache.put("app/attendance/detail/room/credentials/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h2>Credenciales</h2></div></md-toolbar><md-content><md-content layout-padding=\"\"><div><div class=\"template-images\" ng-if=\"templates.length > 0\"><img alt=\"{{template.image}}\" ng-src=\"{{loadImage(template.image)}}\" ng-repeat=\"template in templates\" ng-click=\"change_template(template, $index)\" class=\"md-avatar\"></div></div><div layout=\"row\" layout-align=\"end\"><span flex=\"\"></span> <input type=\"number\" class=\"wargos-qr-input\" ng-change=\"updateDefaultData()\" ng-model=\"limit\" placeholder=\"15\"><md-button aria-label=\"buscar\" class=\"md-raised md-primary\" ng-click=\"getParticipants()\">Buscar</md-button><a class=\"md-button md-raised\" target=\"_blank\" ng-href=\"{{print_url}}\" ng-mousedown=\"print()\">Imprimir</a></div></md-content><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"previous\" ng-click=\"previous()\"><ng-md-icon icon=\"chevron_left\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"reset\" ng-click=\"reset()\">{{query.page}}</md-button><md-button class=\"md-icon-button\" aria-label=\"next\" ng-click=\"next()\"><ng-md-icon icon=\"chevron_right\"></ng-md-icon></md-button><md-input-container><label>Grupos</label><md-select ng-model=\"select.group_id\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content layout-padding=\"\" md-theme=\"default\"><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div id=\"credential-container\"></div></md-content></md-content><style media=\"screen\">\r\n.template-images {\r\n    display: flex;\r\n    overflow-x: scroll;\r\n    height: 100px;\r\n}\r\n.template-images img {\r\n  height: 80px;\r\n  display: inline-block;\r\n  width: auto;\r\n  margin-left: 5px;\r\n  float: left;\r\n}\r\n.template-images img:hover {\r\n  opacity: 0.5;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/export/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Reportes</span> <span flex=\"\"></span><md-input-container><label>Grupos</label><md-select ng-model=\"select.group\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container><md-button class=\"md-raised\" ng-click=\"generateReport()\">Generar reporte</md-button></div></md-toolbar><md-list><md-subheader class=\"md-no-sticky\">Reportes generados</md-subheader><md-divider></md-divider><div ng-if=\"reports.length == 0\" class=\"wargos-text-align\"><b>No existe <i>reportes</i> generados</b></div><md-list-item ng-repeat=\"report in reports\"><a href=\"{{report.url}}\" target=\"_blank\">{{report.name}}</a></md-list-item></md-list>");
$templateCache.put("app/attendance/detail/room/groups/index.html","<md-content flex=\"\"><div layout=\"row\" layout-fill=\"\"><div layout=\"column\" flex=\"\"><md-content><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-input-container><label>Grupos</label><md-select ng-model=\"select.group\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[25, 30, 35]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"addParticipantToGroup(participant, $index)\" ng-class=\"{selectedItem: select.group != null && isMember(participant.groups, select.group)}\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><p><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</p><div ng-if=\"select.group != null\"><div ng-if=\"!isMember(participant.groups, select.group)\"><ng-md-icon icon=\"exposure_plus_1\" aria-label=\"posi\"></ng-md-icon></div></div></md-list-item></div></div></md-content></md-content></div><div layout=\"column\" flex=\"20\"><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h2>Grupos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Crear\" ng-click=\"isCreating = true\"><ng-md-icon icon=\"add\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-whiteframe-5dp\"><md-list><div ng-if=\"groups.length == 0\" class=\"wargos-text-align\"><b>No existe <i>grupos</i> registrados</b></div><md-list-item ng-repeat=\"group in groups\" ng-click=\"select_group(group)\"><p>{{group.name}}</p><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openEventMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"removeGroup(group, $index)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></md-list><div layout-padding=\"\" ng-if=\"isCreating\"><input ng-model=\"title\"><div layout=\"row\"><div flex=\"\"></div><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"createGroup(title)\"><ng-md-icon icon=\"add\"></ng-md-icon>Crear</md-button></div></div></md-content></div></div></md-content><style media=\"screen\">\r\n.selectedItem {\r\n  /*background: rgba(218, 217, 217, 0.99);*/\r\n  background: rgba(158, 158, 158, 0.2);\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/import/index.html","<md-content><md-toolbar class=\"md-whiteframe-5dp\"><h1 class=\"md-toolbar-tools\">Crear desde un archivo excel</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"importfromExcel(item)\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre del archivo</label> <input required=\"\" type=\"text\" name=\"file\" ng-model=\"item.file\"><div ng-messages=\"containerForm.file.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><button class=\"button\" ngf-select=\"upload($file)\">Cargar un archivo excel</button></md-input-container><div><i><b>NOTE:</b> descargar el archivo <a href=\"{{url}}\" target=\"_blank\">{{url}}</a></i></div><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Importar</md-button></div></form></md-content><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><span>Participantes</span></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><div>{{selected.length}} {{selected.length > 1 ? \'items\' : \'item\'}} selected</div><md-button aria-label=\"create\" class=\"md-raised\" ng-click=\"remove_participants(\'done\')\"><ng-md-icon icon=\"done\"></ng-md-icon>Eliminar correctos</md-button><md-button aria-label=\"create\" class=\"md-raised\" ng-click=\"remove_participants(\'fail\')\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar fallidos</md-button><md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"createAlistOfParticipants()\"><ng-md-icon icon=\"save\"></ng-md-icon>Guardar</md-button></div></md-toolbar><md-content><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"participant.uid\"><span>UID</span></th><th md-column=\"\">Apellidos Nombre</th><th md-column=\"\">Email</th><th md-column=\"\">Celular</th><th md-column=\"\">Direccion</th><th md-column=\"\">Grupo</th><th md-column=\"\">States</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"participant\" md-select-id=\"uid\" md-auto-select=\"\" ng-repeat=\"participant in participants\"><td md-cell=\"\">{{participant.uid}}</td><td md-cell=\"\">{{participant.last_name}} {{participant.first_name}}</td><td md-cell=\"\">{{participant.email}}</td><td md-cell=\"\">{{participant.cel}}</td><td md-cell=\"\">{{participant.address}}</td><td md-cell=\"\">\"{{participant.group_helper.name}}\"</td><td md-cell=\"\">{{participant.status.message}}</td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"attendance.detail.room\">Cancelar</md-button></div></md-content></md-content>");
$templateCache.put("app/attendance/detail/room/people/index.html","<ui-view></ui-view>");
$templateCache.put("app/attendance/detail/room/qr/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h2>Identificadores</h2></div></md-toolbar><md-content><md-content layout-padding=\"\"><div layout=\"row\" layout-align=\"end\"><md-button aria-label=\"buscar\" class=\"md-raised {{ idLabel }}\" ng-click=\"changeIdentificar()\">Identificador</md-button><md-button aria-label=\"buscar\" class=\"md-raised {{ codeLabel }}\" ng-click=\"changeIdentificar()\">Codigo</md-button><span flex=\"\"></span> <input type=\"number\" class=\"wargos-qr-input\" ng-change=\"updateDefaultData()\" ng-model=\"size\" placeholder=\"200\"> <input type=\"number\" class=\"wargos-qr-input\" ng-change=\"updateDefaultData()\" ng-model=\"limit\" placeholder=\"15\"><md-button aria-label=\"buscar\" class=\"md-raised md-primary\" ng-click=\"getParticipants()\">Buscar</md-button><a class=\"md-button md-raised\" target=\"_blank\" ng-href=\"{{print_url}}\" ng-mousedown=\"print()\">Imprimir</a></div></md-content><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"previous\" ng-click=\"previous()\"><ng-md-icon icon=\"chevron_left\"></ng-md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"reset\" ng-click=\"reset()\">{{query.page}}</md-button><md-button class=\"md-icon-button\" aria-label=\"next\" ng-click=\"next()\"><ng-md-icon icon=\"chevron_right\"></ng-md-icon></md-button><md-input-container><label>Grupos</label><md-select ng-model=\"select.group_id\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content md-theme=\"default\"><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div layout-padding=\"\" ng-repeat=\"participant in participants\" class=\"qr-body-container\"><a href=\"#/attendance/{{area_id}}/participant/{{participant._id}}\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"size\" input-mode=\"\'text\'\" text=\"participant.qr\" image=\"true\"></qr></a><div class=\"qr-footer\"><h5>{{participant.first_name}}</h5><h5 style=\"padding: 0px; margin:0px; font-size: 8px;\">{{participant.last_name}}</h5><h6>{{participant.qr}}</h6><div style=\"padding: 0px; margin:0px; font-size: 8px;\">{{participant.index}}</div></div></div></div></md-content></md-content><style media=\"screen\">\r\n.qr-footer h5, .qr-footer h4, .qr-footer h6 {\r\n  text-align: center;\r\n  padding: 0mm;\r\n  margin: 0mm;\r\n}\r\n.qr-body-container {\r\n  text-align: center;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/reports/index.html","<div layout=\"row\" layout-fill=\"\"><div layout=\"column\" flex=\"\" layout-fill=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\"></span><div layout=\"row\"><md-button ng-click=\"go_to_take_attendance(\'attendance.detail.room.reports.arrive\')\">primero en llegar</md-button><md-button ng-click=\"go_to_take_attendance(\'attendance.detail.room.reports.pieful\')\">Reporte de grupos</md-button><md-button ng-click=\"go_to_take_attendance(\'attendance.detail.room.reports.donut\')\">Tiempo real</md-button></div></div></md-toolbar><md-content flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></md-content></div></div>");
$templateCache.put("app/attendance/detail/room/settings/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span></div></md-toolbar><md-content><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[20, 25, 30]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"add_participant_to_room(participant, $index)\" ng-class=\"{selectedItem: validate_if_user_is_added(participant)}\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.img)}}\" class=\"md-avatar\"><p>{{participant.first_name}} {{participant.last_name}}</p><div ng-if=\"!validate_if_user_is_added(participant)\"><ng-md-icon icon=\"exposure_plus_1\" ng-click=\"add_participant_to_room(participant, $index)\" aria-label=\"posi\"></ng-md-icon></div></md-list-item></div></div></md-content><style media=\"screen\">\r\n.selectedItem {\r\n  /*background: rgba(218, 217, 217, 0.99);*/\r\n  background: rgba(158, 158, 158, 0.2)\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/update/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><h1 class=\"md-toolbar-tools\">Actualizar sala</h1></md-toolbar><md-content layout-padding=\"\"><form ng-submit=\"update(item)\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.first_name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/settings/administrators/index.html","<md-content><md-toolbar class=\"md-whiteframe-5dp\"><h1 class=\"md-toolbar-tools\">Administradores</h1></md-toolbar><md-content layout-padding=\"\"><md-table-container class=\"area-detail-administrators\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Email</th><th md-column=\"\">Nombre</th><th md-column=\"\">Celular</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"admin in administrators\"><td md-cell=\"\">{{admin.email}}</td><td md-cell=\"\">{{admin.name}}</td><td md-cell=\"\">{{admin.cel}}</td><td md-cell=\"\"><md-button type=\"submit\" class=\"md-raised\" ng-click=\"removeAdministrator(admin, $index)\">Eliminar</md-button></td></tr></tbody></table></md-table-container><div ng-if=\"administrators.length == 0\" class=\"wargos-text-align\"><b>No existe <i>administradores</i> registrados</b></div></md-content><md-toolbar><h1 class=\"md-toolbar-tools\">Agregar nuevo</h1></md-toolbar><md-content layout-padding=\"\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Email</label> <input required=\"\" type=\"text\" ng-model=\"userEmail\"></md-input-container><div><md-button type=\"submit\" class=\"md-raised md-primary\" ng-click=\"addAdministrator(userEmail)\">Agregar nuevo administrador</md-button></div></md-content></md-content><style media=\"screen\">\r\ntable.md-table th.md-column, table.md-table td.md-cell {\r\n   color: #fff;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/settings/main/index.html","Hello");
$templateCache.put("app/attendance/detail/settings/states/index.html","<md-content flex=\"\"><div layout=\"row\" layout-fill=\"\"><div layout=\"column\" flex=\"20\"><md-toolbar><h1 class=\"md-toolbar-tools md-whiteframe-5dp\">Estados</h1></md-toolbar><md-content flex=\"\"><md-list><div ng-if=\"states.length == 0\" class=\"wargos-text-align\"><b>No existe <i>Estados</i> registrados</b></div><md-list-item ng-repeat=\"state in states\" ui-sref=\"attendance.detail.settings.states.update({state_id: state._id})\"><div style=\"background-color: {{state.color}}; padding: 0px 10px; margin: 0px 10px;\">C</div><p>{{state.name}}</p></md-list-item></md-list><div layout=\"row\"><div flex=\"\"></div><md-button aria-label=\"create\" class=\"md-raised md-primary\" ui-sref=\"attendance.detail.settings.states.create\"><ng-md-icon icon=\"add\"></ng-md-icon>Estados</md-button></div></md-content></div><div layout=\"column\" flex=\"\"><ui-view layout=\"column\" layout-fill=\"\"></ui-view></div></div></md-content>");
$templateCache.put("app/attendance/detail/settings/udfs/index.html","<md-content layout-padding=\"\"><p>UDFs</p></md-content>");
$templateCache.put("app/attendance/detail/settings/update/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Actualizar area</h1></div></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><div flex=\"70\"><form ng-submit=\"updateArea(item)\"><div layout=\"column\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>titulo</label> <input ng-model=\"item.name\" type=\"text\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Image</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"><div ng-messages=\"containerForm.image.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised md-primary\" type=\"submit\">Actualizar</md-button></div></div></form></div><div flex=\"30\"><img class=\"md-card-image\" ng-src=\"{{current_image}}\"> <button ngf-select=\"upload($file)\">Cargar una foto</button></div></div></md-content>");
$templateCache.put("app/attendance/detail/studio/create/index.html","<md-content layout-padding=\"\"><form ng-submit=\"create(item)\"><md-content><div ng-include=\"template.item\"></div><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"attendance.detail.studio.list\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Crear</md-button></div></md-content></form></md-content>");
$templateCache.put("app/attendance/detail/studio/delete/index.html","<md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"deleteItem(item)\">Eliminar</md-button></div></md-content>");
$templateCache.put("app/attendance/detail/studio/list/index.html","<md-content layout-padding=\"\"><div layout=\"row\" layout-align=\"end\"><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"create_screen($event)\"><ng-md-icon icon=\"add\"></ng-md-icon>Nuevo</md-button></div><div ng-if=\"details.length == 0\" class=\"wargos-text-align\"><b>No existe elementos registrados</b></div><md-list><md-list-item ng-repeat=\"detail in details\" ng-click=\"selectItem(detail)\"><p>{{detail.name}}</p></md-list-item></md-list></md-content>");
$templateCache.put("app/attendance/detail/studio/update/index.html","<md-content layout-padding=\"\"><form ng-submit=\"updateItem(item)\"><md-content><div ng-include=\"template.item\"></div><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"attendance.detail.studio.list\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></md-content></form><div ng-include=\"template.remove\"></div></md-content>");
$templateCache.put("app/attendance/detail/template/create/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Crear una plantilla</h1><div flex=\"\"></div><md-button type=\"button\" ng-click=\"clear()\">Limpiar</md-button></div></md-toolbar><md-content flex=\"\"><div layout=\"row\"><div flex=\"20\"><md-list><md-subheader class=\"md-no-sticky\">Información</md-subheader><md-list-item ng-if=\"properties.length == 0\" class=\"wargos-text-align\"><p>No existe <i>propiedades</i> de los participantes</p></md-list-item><md-list-item ng-repeat=\"property in properties\" ng-click=\"select_property(property, $index)\"><ng-md-icon icon=\"text_fields\"></ng-md-icon><p>{{property.value}}</p></md-list-item></md-list></div><div flex=\"80\" layout-padding=\"\"><form ng-submit=\"create_template(item)\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div class=\"md-block\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"re_draw()\" ng-model=\"container.width\" placeholder=\"400\"> <input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"re_draw()\" ng-model=\"container.height\" placeholder=\"600\"></div><div class=\"md-block\"><md-button class=\"md-raised md-primary\" type=\"submit\">Crear</md-button></div></div></form><div class=\"att-template\"><div ng-if=\"info.type === \'qr\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.size\"></div><div ng-if=\"info.type === \'image\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.width\"> <input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.height\"></div><div ng-if=\"info.type === \'text\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.size\"><select ng-model=\"property.font\" class=\"wargos-input-font\" ng-change=\"populate_default_canvas()\"><option ng-value=\"font\" ng-repeat=\"font in fonts\">{{font}}</option></select></div></div><div class=\"att-template-container\"><div id=\"att-canvas-container\"></div></div><div layout=\"column\"><md-button class=\"md-raised\" type=\"button\" ngf-select=\"upload($file)\">Cargar una foto</md-button></div></div></div></md-content><style media=\"screen\">\r\n.att-template-container {\r\n  width: 100%;\r\n  text-align:center;\r\n}\r\n#att-canvas-container {\r\n  margin: auto;\r\n  display: inline-block;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/template/main/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Plantillas</h1></div></md-toolbar><md-content flex=\"\" class=\"md-whiteframe-5dp\" layout-padding=\"\"><div class=\"wargos-text-align\"><b>Seleccione una <i>plantillas</i></b></div></md-content>");
$templateCache.put("app/attendance/detail/template/update/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><h1>Editar un plantilla</h1><span flex=\"\"></span><md-button type=\"button\" ng-click=\"clear()\">Limpiar</md-button><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openEventMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"show_confirm_template($event)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content flex=\"\" class=\"md-whiteframe-5dp\"><div layout=\"row\"><div flex=\"20\"><md-list><md-subheader class=\"md-no-sticky\">Información</md-subheader><md-list-item ng-if=\"properties.length == 0\" class=\"wargos-text-align\"><p>No existe <i>propiedades</i> de los participantes</p></md-list-item><md-list-item ng-repeat=\"property in properties\" ng-click=\"select_property(property, $index)\"><ng-md-icon icon=\"text_fields\"></ng-md-icon><p>{{property.value}}</p></md-list-item></md-list></div><div flex=\"80\" layout-padding=\"\"><form ng-submit=\"update_template(item)\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div class=\"md-block\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"re_draw()\" ng-model=\"container.width\" placeholder=\"400\"> <input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"re_draw()\" ng-model=\"container.height\" placeholder=\"600\"></div><div class=\"md-block\"><md-button class=\"md-raised md-primary\" type=\"submit\">Guardar</md-button></div></div></form><div class=\"att-template\"><div ng-if=\"info.type === \'qr\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.size\"></div><div ng-if=\"info.type === \'image\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.width\"> <input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.height\"></div><div ng-if=\"info.type === \'text\'\"><input type=\"number\" class=\"wargos-input-qr-size\" ng-change=\"populate_default_canvas()\" ng-model=\"property.size\"><select ng-model=\"property.font\" class=\"wargos-input-font\" ng-change=\"populate_default_canvas()\"><option ng-value=\"font\" ng-repeat=\"font in fonts\">{{font}}</option></select></div></div><div class=\"att-template-container\"><div id=\"att-canvas-container\"></div></div><div layout=\"column\"><md-button class=\"md-raised\" type=\"button\" ngf-select=\"upload($file)\">Cargar una foto</md-button></div><md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"remove_template(item)\">Eliminar</md-button></div></md-content></div></div></md-content><style media=\"screen\">\r\n.att-template-container {\r\n  width: 100%;\r\n  text-align:center;\r\n}\r\n#att-canvas-container {\r\n  margin: auto;\r\n  display: inline-block;\r\n}\r\n</style>");
$templateCache.put("app/attendance/provider/studio/create/index.html","<md-content layout-padding=\"\"><form ng-submit=\"create(item)\"><md-content><div ng-include=\"template.item\"></div><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"attendance.provider.studio.list\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Crear</md-button></div></md-content></form></md-content>");
$templateCache.put("app/attendance/provider/studio/delete/index.html","<md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"deleteItem(item)\">Eliminar</md-button></div></md-content>");
$templateCache.put("app/attendance/provider/studio/list/index.html","<md-content layout-padding=\"\"><div layout=\"row\" layout-align=\"end\"><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"create_screen($event)\"><ng-md-icon icon=\"add\"></ng-md-icon>Nuevo</md-button></div><div ng-if=\"providers.length == 0\" class=\"wargos-text-align\"><b>No existe elementos registrados</b></div><md-list><md-list-item ng-repeat=\"provider in providers\" ng-click=\"selectItem(provider)\"><p>{{provider.name}}</p></md-list-item></md-list></md-content>");
$templateCache.put("app/attendance/provider/studio/update/index.html","<md-content layout-padding=\"\"><form ng-submit=\"updateItem(item)\"><md-content><div ng-include=\"template.item\"></div><div layout=\"row\"><md-button class=\"md-raised\" ui-sref=\"attendance.provider.studio.list\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></md-content></form><div ng-include=\"template.remove\"></div></md-content>");
$templateCache.put("app/attendance/detail/loans/objects/update/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Actualizar objecto</h1></md-toolbar><md-content layout-padding=\"\"><div class=\"stores-qr-container\" ng-if=\"item\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"150\" input-mode=\"\'text\'\" text=\"item.qr\" image=\"true\"></qr><h6>{{item.qr}}</h6><div><md-button aria-label=\"buscar\" class=\"md-raised {{ idLabel }}\" ng-click=\"changeIdentificar(item)\">Identificador</md-button><md-button aria-label=\"buscar\" class=\"md-raised {{ codeLabel }}\" ng-click=\"changeIdentificar(item)\">Codigo</md-button></div></div><form name=\"containerForm\" ng-submit=\"update_store(item)\"><md-input-container class=\"md-block\" flex=\"\"><label>Codigo</label> <input required=\"\" type=\"text\" name=\"uid\" ng-model=\"item.uid\"><div ng-messages=\"containerForm.uid.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Grupos</label><md-select ng-model=\"item.data_id\" ng-change=\"select_group()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"store._id\" ng-repeat=\"store in stores\">{{store.name}}</md-option></md-optgroup></md-select></md-input-container><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"goToBack()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form><div class=\"store-asset-table\"><div layout=\"row\" class=\"search-tools\"><h4>Inicio</h4><div><md-datepicker ng-model=\"timer.start\" md-placeholder=\"Enter date\"></md-datepicker><input type=\"time\" ng-model=\"timer.start\"></div><h4>Fin</h4><div><md-datepicker ng-model=\"timer.end\" md-placeholder=\"Enter date\"></md-datepicker><input type=\"time\" ng-model=\"timer.end\"></div><div><md-button aria-label=\"create\" class=\"md-raised md-primary\" ng-click=\"find_markers(timer)\"><ng-md-icon icon=\"search\"></ng-md-icon>Buscar</md-button></div><div><md-button aria-label=\"create\" class=\"md-raised\" ng-click=\"save_report()\"><ng-md-icon icon=\"print\"></ng-md-icon>Exportar</md-button></div></div><table><thead><tr><th>Fecha</th><th>Desde</th><th></th><th>Donde</th></tr></thead><tbody><tr ng-repeat=\"loan in loans\"><td>{{loan.created | date:\"MM/dd/yyyy HH:mm:ss\"}}</td><td ng-class=\"{\'store\': \'asset-store\', \'participant\': \'\'}[loan.from.type]\">{{loan.from.title}}</td><td>></td><td ng-class=\"{\'store\': \'asset-store\', \'participant\': \'\'}[loan.to.type]\">{{loan.to.title}}</td></tr></tbody></table></div></md-content><style media=\"screen\">\r\n.store-asset-table .search-tools {\r\n  padding-left: 250px;\r\n}\r\n.store-asset-table .search-tools h4 {\r\n  margin: 10px;\r\n}\r\n.store-asset-table table {\r\n  margin: auto;\r\n}\r\n.store-asset-table tr {\r\n  padding: 5px;\r\n}\r\n.store-asset-table td {\r\n  padding: 5px;\r\n}\r\n.store-asset-table .asset-store, .store-asset-table .asset-store {\r\n  background-color: #00ffff;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/loans/stores/create/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Crear almacen</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"create_store(item)\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Descripción</label> <input required=\"\" type=\"text\" name=\"description\" ng-model=\"item.description\"><div ng-messages=\"containerForm.description.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Imagen</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"></md-input-container><button class=\"button\" ngf-select=\"upload($file)\">Cargar una foto</button><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"goToBack()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/loans/stores/update/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Actualizar almacen</h1></md-toolbar><md-content layout-padding=\"\"><div class=\"stores-qr-container\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"150\" input-mode=\"\'text\'\" text=\"item._id\" image=\"true\"></qr><h6>{{item._id}}</h6></div><form name=\"containerForm\" ng-submit=\"update_store(item)\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Descriptcion</label> <input required=\"\" type=\"text\" name=\"description\" ng-model=\"item.description\"><div ng-messages=\"containerForm.description.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Imagen</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"></md-input-container><button class=\"button\" ngf-select=\"upload($file)\">Cargar una foto</button><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"goToBack()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/people/gate/create/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><h1 class=\"md-toolbar-tools\">Crear un nuevo incidente</h1></md-toolbar><md-content layout-padding=\"\"><form ng-submit=\"create(item)\" name=\"containerForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Titulo</label> <input type=\"text\" name=\"name\" ng-model=\"item.name\" required=\"\"><div ng-messages=\"containerForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><div flex=\"30\"><md-radio-group ng-model=\"item.type\"><md-radio-button value=\"pair\" class=\"md-primary\">Entrada/Salida</md-radio-button><md-radio-button value=\"states\">Estados</md-radio-button></md-radio-group></div><div flex=\"70\"><div ng-if=\"item.type === \'pair\'\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>IN</label> <input type=\"text\" name=\"in\" ng-model=\"pair.in\" required=\"\"><div ng-messages=\"containerForm.value.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>OUT</label> <input type=\"text\" name=\"out\" ng-model=\"pair.out\" required=\"\"><div ng-messages=\"containerForm.value.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div ng-if=\"item.type === \'states\'\"><md-list class=\"md-dense\"><md-subheader class=\"md-no-sticky\">Estados</md-subheader><div ng-if=\"states.length == 0\" class=\"wargos-text-align\"><b>No existe <i>estados</i> registrados</b></div><md-list-item class=\"md-2-line\" ng-repeat=\"state in states\"><ng-md-icon icon=\"send\"></ng-md-icon><div class=\"md-list-item-text\"><h3>{{state.value}}</h3><p>{{state.key}}</p></div><div flex=\"\"></div><ng-md-icon icon=\"delete\" ng-click=\"delete_state($index)\"></ng-md-icon></md-list-item></md-list><md-divider></md-divider><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Key</label> <input type=\"text\" name=\"title\" ng-model=\"interrupt_state.key\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Value</label> <input type=\"text\" name=\"title\" ng-model=\"interrupt_state.value\"></md-input-container><div><md-button type=\"button\" ng-click=\"new_state(interrupt_state)\" class=\"md-raised md-primary\">Crear estado</md-button></div></div></div></div></div><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Crear</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/people/gate/update/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><h1 class=\"md-toolbar-tools\">Editar un nuevo incidente</h1></md-toolbar><md-content layout-padding=\"\"><form ng-submit=\"update(item)\" name=\"containerForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Titulo</label> <input type=\"text\" name=\"name\" ng-model=\"item.name\" required=\"\"><div ng-messages=\"containerForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><div flex=\"30\"><md-radio-group ng-model=\"item.type\"><md-radio-button value=\"pair\" class=\"md-primary\">Entrada/Salida</md-radio-button><md-radio-button value=\"states\">Estados</md-radio-button></md-radio-group></div><div flex=\"70\"><div ng-if=\"item.type === \'pair\'\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>IN</label> <input type=\"text\" name=\"in\" ng-model=\"pair.in\" required=\"\"><div ng-messages=\"containerForm.value.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>OUT</label> <input type=\"text\" name=\"out\" ng-model=\"pair.out\" required=\"\"><div ng-messages=\"containerForm.value.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div ng-if=\"item.type === \'states\'\"><md-list class=\"md-dense\"><md-subheader class=\"md-no-sticky\">Estados</md-subheader><div ng-if=\"states.length == 0\" class=\"wargos-text-align\"><b>No existe <i>estados</i> registrados</b></div><md-list-item class=\"md-2-line\" ng-repeat=\"state in states\"><ng-md-icon icon=\"send\"></ng-md-icon><div class=\"md-list-item-text\"><h3>{{state.value}}</h3><p>{{state.key}}</p></div><div flex=\"\"></div><ng-md-icon icon=\"delete\" ng-click=\"delete_state($index)\"></ng-md-icon></md-list-item></md-list><md-divider></md-divider><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Key</label> <input type=\"text\" name=\"title\" ng-model=\"interrupt_state.key\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Value</label> <input type=\"text\" name=\"title\" ng-model=\"interrupt_state.value\"></md-input-container><div><md-button type=\"button\" ng-click=\"new_state(interrupt_state)\" class=\"md-raised md-primary\">Crear estado</md-button></div></div></div></div></div><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content><md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"remove(item)\">Eliminar</md-button></div></md-content>");
$templateCache.put("app/attendance/detail/room/att/onlyone/event-update.html","<md-dialog aria-label=\"Actualizar evento\" class=\"att-event-update\"><md-toolbar><h1 class=\"md-toolbar-tools\">Actualizar evento</h1></md-toolbar><md-dialog-content flex=\"\"><md-content layout-padding=\"\"><form ng-submit=\"update(item)\" name=\"containerForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Titulo</label> <input type=\"text\" name=\"name\" ng-model=\"item.name\" required=\"\"><div ng-messages=\"containerForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" flex=\"\"><label>Start time</label> <input type=\"datetime-local\" name=\"start\" ng-model=\"item.start\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" flex=\"\"><label>End time</label> <input type=\"datetime-local\" name=\"end\" ng-model=\"item.end\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" flex=\"\"><label>Tolerancia (minutos)</label> <input type=\"number\" name=\"end\" ng-model=\"item.slackTime\"></md-input-container><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form><md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"remove(item)\">Eliminar</md-button></div></md-content></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"></div><md-button ng-click=\"cancel()\">Cancelar</md-button></md-dialog-actions></md-dialog><style media=\"screen\">\r\n.att-event-update {\r\n  width: 600px;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/att/onlyone/index.html","<div layout=\"row\" layout-fill=\"\"><div layout=\"column\" flex=\"\" layout-fill=\"\"><md-content flex=\"\"><md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-input-container><label>Grupos</label><md-select ng-model=\"select.group\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content><md-content><div class=\"md-toolbar-tools\"><md-button class=\"md-raised md-mini\" aria-label=\"changestatus\" style=\"color: #47a447\"><ng-md-icon icon=\"done_all\"></ng-md-icon>PUNTUAL</md-button><md-button class=\"md-raised\" aria-label=\"changestatus\" style=\"color:#ed9c28\"><ng-md-icon icon=\"done_all\"></ng-md-icon>ATRASADO</md-button><md-button class=\"md-raised\" aria-label=\"changestatus\" ng-repeat=\"state in states\" style=\"color:{{state.color}}\"><ng-md-icon icon=\"layers\"></ng-md-icon>{{state.name}}</md-button><md-button class=\"md-raised\" aria-label=\"message\"><ng-md-icon icon=\"message\"></ng-md-icon>Nota</md-button><div flex=\"\"></div><md-button class=\"md-raised\" aria-label=\"report\" ng-click=\"go_to_report()\"><ng-md-icon icon=\"trending_up\"></ng-md-icon></md-button><md-button class=\"md-raised\" aria-label=\"unique\" ng-click=\"go_to_unique()\"><ng-md-icon icon=\"assignment_ind\"></ng-md-icon></md-button><md-button class=\"md-raised\" aria-label=\"accessibility\" ng-click=\"go_to_accessibility()\"><ng-md-icon icon=\"accessibility\"></ng-md-icon></md-button></div></md-content><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[15, 20, 25]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"50\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"changeStatus(participant, $index)\" class=\"md-2-line\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</h3><p ng-if=\"participant.att\">{{participant.att.created | date : \'HH:mm:ss\'}}</p></div><md-button ng-if=\"participant.isloading\" aria-label=\"isloading\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"done\" style=\"fill: black\"></ng-md-icon></md-button><md-button ng-if=\"participant.color\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.color }}\"><ng-md-icon icon=\"done_all\"></ng-md-icon></md-button><md-button ng-if=\"participant.alibi\" aria-label=\"layers\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.alibi.color }}\"><ng-md-icon icon=\"layers\"></ng-md-icon></md-button><md-button ng-if=\"participant.note\" aria-label=\"message\" class=\"md-fab md-raised md-mini\"><ng-md-icon icon=\"message\"></ng-md-icon></md-button><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"state in states\"><md-button ng-click=\"take_alibi(participant, state, $index)\"><ng-md-icon icon=\"done\" style=\"color:{{state.color}}\"></ng-md-icon>{{state.name}}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"add_message(participant, $index, $event)\"><ng-md-icon icon=\"message\"></ng-md-icon>Mensaje</md-button></md-menu-item><md-menu-item><md-button ng-click=\"go_to_participant(participant, $index)\"><ng-md-icon icon=\"account_box\"></ng-md-icon>Detalle</md-button></md-menu-item><md-menu-item ng-if=\"participant.att\"><md-button ng-click=\"remove_attendance_events(participant)\"><ng-md-icon icon=\"delete\"></ng-md-icon>Eliminar asistencia</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></div></div><md-content></md-content></md-content></md-content></div><div layout=\"column\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><h2>Eventos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Edit\" ng-click=\"createEvent()\"><ng-md-icon icon=\"add\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-whiteframe-5dp\"><md-subheader class=\"md-no-sticky\">Eventos</md-subheader><div ng-if=\"events.length == 0\" class=\"wargos-text-align\"><b>No existe <i>eventos</i> registrados</b></div><md-list><md-list-item ng-repeat=\"event in events\" ng-click=\"selectEvent(event)\" ng-class=\"{isSelected: event.selected}\"><p>{{event.name}}</p><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"openEventMenu($mdOpenMenu, $event)\"><ng-md-icon icon=\"more_vert\"></ng-md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"generate_qr(event, $index, $event)\"><ng-md-icon icon=\"fingerprint\"></ng-md-icon>Generar QR</md-button></md-menu-item><md-menu-item><md-button ng-click=\"goToEvent(event, $index, $event)\"><ng-md-icon icon=\"edit\"></ng-md-icon>Editar</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></md-list><div ng-if=\"events.length > 0\" class=\"wargos-text-align\"><b ng-click=\"loadMoreEvents()\">Cargar Mas</b></div></md-content></div></div>");
$templateCache.put("app/attendance/detail/room/att/onlyone/qr-generator.html","<md-dialog aria-label=\"QR Generator\" class=\"qr-generator\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>QR Generator - {{title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close dialog\" ng-click=\"cancel()\"><ng-md-icon icon=\"close\"></ng-md-icon></md-button></div></md-toolbar><md-dialog-content class=\"qr-content\" flex=\"\"><div ng-if=\"qr\"><qr type-number=\"3\" correction-level=\"\'M\'\" size=\"300\" input-mode=\"ALPHA_NUM\" text=\"qr\" image=\"true\"></qr><h3>{{title}}</h3><h4>{{qr}}</h4></div></md-dialog-content><md-dialog-actions layout=\"row\"><p>Refrescar cada</p><h1 style=\"padding: 0px 10px\">{{counter}}</h1><p>segundos</p><md-button class=\"md-raised md-primary\" ng-click=\"start()\" ng-if=\"!isRunning\">Empesar</md-button><md-button class=\"md-raised md-warn\" ng-click=\"stop()\" ng-if=\"isRunning\">Parar</md-button><md-button class=\"md-raised md-button\" ng-click=\"update()\">Generar uno nuevo</md-button><div flex=\"\"></div><md-button ng-click=\"cancel()\">Cancelar</md-button></md-dialog-actions></md-dialog><style media=\"screen\">\r\nmd-dialog.md-dialog-fullscreen {\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n  border-radius: 0;\r\n}\r\n.qr-generator .qr-content {\r\n  background-color: #fff;\r\n  text-align: center;\r\n  padding: 0mm;\r\n  margin: 0mm;\r\n  color: black;\r\n}\r\n.qr-generator .qr-content div {\r\n  padding: 100px;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/att/unique/index.html","<div layout=\"\" layout-sm=\"column\" layout-fill=\"\"><md-content flex=\"\"><md-list><md-subheader class=\"md-no-sticky\">Participantes</md-subheader><md-list-item class=\"md-2-line contact-item\" ng-repeat=\"participant in check_participants track by $index\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</h3><p ng-if=\"participant.att\">{{participant.att.created | date : \'HH:mm:ss\'}}</p></div><md-button ng-if=\"participant.color\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.color }}\"><ng-md-icon icon=\"done_all\"></ng-md-icon></md-button></md-list-item></md-list></md-content><md-content flex=\"\"><md-list><md-subheader class=\"md-no-sticky\">Tomar asistencia por codigo</md-subheader></md-list><form name=\"containerForm\" ng-submit=\"changeUserAttendanceReportsState(item)\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Codigo</label> <input ng-model=\"item.code\"></md-input-container><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Validar codigo</md-button></div></form><md-list><md-subheader class=\"md-no-sticky\">Codigo Inexistente</md-subheader><md-content class=\"md-padding\" layout=\"column\"><md-chips><md-chip ng-repeat=\"code in failed_codes track by $index\">{{code}}</md-chip></md-chips></md-content></md-list></md-content><md-content flex=\"\"><div layout=\"\" layout-sm=\"column\"><div flex=\"20\"></div><div flex=\"60\"><md-card ng-if=\"current_participant\"><md-card-content><img class=\"md-card-image att-unique-img\" ng-src=\"{{loadImage(current_participant.image)}}\"><h2 class=\"md-title att-md-title\">{{current_participant.uid}}</h2><h1 class=\"att-md-title\">{{current_participant.first_name}} {{current_participant.last_name}}</h1></md-card-content></md-card></div><div flex=\"20\"></div></div></md-content></div><style media=\"screen\">\r\n.att-unique-img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n.att-md-title {\r\n  text-align: center;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/people/create/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Crear participante</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"create_participant(item)\"><md-input-container class=\"md-block\"><label>UID (Identificador unico)</label> <input required=\"\" type=\"text\" name=\"uid\" ng-model=\"item.uid\"><div ng-messages=\"containerForm.uid.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Apellidos</label> <input required=\"\" type=\"text\" name=\"last_name\" ng-model=\"item.last_name\"><div ng-messages=\"containerForm.last_name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"first_name\" ng-model=\"item.first_name\"><div ng-messages=\"containerForm.first_name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Celular</label> <input required=\"\" type=\"text\" name=\"cel\" ng-model=\"item.cel\"><div ng-messages=\"containerForm.cel.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Email</label> <input required=\"\" type=\"text\" name=\"email\" ng-model=\"item.email\"><div ng-messages=\"containerForm.email.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Dirección</label> <input type=\"text\" name=\"address\" ng-model=\"item.address\"><div ng-messages=\"containerForm.address.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>CI</label> <input type=\"text\" name=\"ci\" ng-model=\"item.ci\"><div ng-messages=\"containerForm.ci.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Imagen</label> <input type=\"text\" name=\"image\" ng-model=\"item.image\"></md-input-container><button class=\"button\" ngf-select=\"upload($file)\">Cargar una foto</button><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"goToBack()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/room/people/main/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools\"><div ng-if=\"!search.alive\"><span ng-click=\"discartGroup()\" ng-if=\"!search.alive\">Participantes</span><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search.alive = true\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><div ng-if=\"search.alive\" class=\"search\"><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"cancel_search()\"><ng-md-icon icon=\"keyboard_backspace\"></ng-md-icon></md-button><md-input-container><label>Apellido</label> <input ng-model=\"query.last_name\"></md-input-container><md-input-container><label>Nombre</label> <input ng-model=\"query.first_name\"></md-input-container><md-button class=\"md-icon-button\" aria-label=\"search\" ng-click=\"search_participant(query.last_name, query.first_name)\"><ng-md-icon icon=\"search\"></ng-md-icon></md-button></div><span flex=\"\"></span><md-input-container><label>Grupos</label><md-select ng-model=\"select.group\" ng-change=\"selectGroup()\" class=\"group-select-width-limit\"><md-optgroup label=\"grupos\"><md-option ng-value=\"group._id\" ng-repeat=\"group in groups\">{{group.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-toolbar><md-content><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><md-button ng-class=\"{\'-created\':\'md-mini md-fab\', \'created\': \'md-icon-button\', \'last_name\': \'md-icon-button\'}[order]\" aria-label=\"keyboard_arrow_down\" ng-click=\"change_order(\'-created\')\"><ng-md-icon icon=\"keyboard_arrow_down\"></ng-md-icon></md-button><md-button ng-class=\"{\'-created\': \'md-icon-button\', \'created\': \'md-mini md-fab\', \'last_name\': \'md-icon-button\'}[order]\" aria-label=\"keyboard_arrow_up\" ng-click=\"change_order(\'created\')\"><ng-md-icon icon=\"keyboard_arrow_up\"></ng-md-icon></md-button><md-button ng-class=\"{\'-created\': \'md-icon-button\', \'created\': \'md-icon-button\', \'last_name\': \'md-mini md-fab\'}[order]\" aria-label=\"reorder\" ng-click=\"change_order(\'last_name\')\"><ng-md-icon icon=\"reorder\"></ng-md-icon></md-button><span flex=\"\"></span><md-button aria-label=\"create\" class=\"md-raised\" ng-click=\"createParticipant($event)\"><ng-md-icon icon=\"person_add\"></ng-md-icon>Participante</md-button></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[21, 30, 39]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"goToParticipant(participant, $index)\"><img ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><p><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</p></md-list-item></div></div></md-content><style media=\"screen\">\r\nng-md-icon.backrpu {\r\n  color: white;\r\n  background: black;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/reports/arrive/index.html","<md-toolbar class=\"md-whiteframe-5dp\"><div class=\"md-toolbar-tools md-default\"><h2 ui-sref=\"event.att.list\">Primero en llegar</h2></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[15, 20, 25]\" md-page=\"query.page\" md-total=\"{{area.config.participants}}\" md-on-paginate=\"getParticipants\" md-page-select=\"\"></md-table-pagination><div ng-if=\"participants.length == 0\" class=\"wargos-text-align\"><b>No existe <i>participantes</i> registrados</b></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"participant in participants\"><md-list-item ng-click=\"changeStatus(participant, $index)\" class=\"md-2-line\"><img alt=\"{{participant.first_name}}\" ng-src=\"{{loadImage(participant.image)}}\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3><b>{{participant.index}}</b> {{participant.last_name}} {{participant.first_name}}</h3><p ng-if=\"participant.att\">{{participant.att.created | date : \'HH:mm:ss\'}}</p></div><md-button ng-if=\"participant.color\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{ participant.color }}\"><ng-md-icon icon=\"done_all\"></ng-md-icon></md-button><md-button ng-if=\"participant.att && participant.att.time\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{get_color(participant.att.isPunctual)}}\"><ng-md-icon icon=\"done\"></ng-md-icon></md-button><md-button ng-if=\"participant.att && participant.att.state_id\" aria-label=\"done\" class=\"md-fab md-raised md-mini\" style=\"color: {{getState(participant.att.state_id).color}}\"><ng-md-icon icon=\"done_all\"></ng-md-icon></md-button></md-list-item></div></div>");
$templateCache.put("app/attendance/detail/room/reports/donut/index.html","<div layout=\"column\"><div class=\"generator\"><div id=\"1\" style=\"width: 300px;\"></div><div id=\"2\" style=\"width: 300px;\"></div><div id=\"3\" style=\"width: 300px;\"></div><div id=\"4\" style=\"width: 300px;\"></div><div id=\"5\" style=\"width: 300px;\"></div><div id=\"6\" style=\"width: 300px;\"></div><div id=\"7\" style=\"width: 300px;\"></div><div id=\"8\" style=\"width: 300px;\"></div><div id=\"9\" style=\"width: 300px;\"></div><div id=\"10\" style=\"width: 300px;\"></div><div id=\"11\" style=\"width: 300px;\"></div><div id=\"12\" style=\"width: 300px;\"></div><div id=\"13\" style=\"width: 300px;\"></div><div id=\"14\" style=\"width: 300px;\"></div><div id=\"15\" style=\"width: 300px;\"></div><div id=\"16\" style=\"width: 300px;\"></div><div id=\"17\" style=\"width: 300px;\"></div><div id=\"18\" style=\"width: 300px;\"></div><div id=\"19\" style=\"width: 300px;\"></div><div id=\"20\" style=\"width: 300px;\"></div></div></div><style media=\"screen\">\r\n.generator > div {\r\n  float: left;\r\n}\r\n</style>");
$templateCache.put("app/attendance/detail/room/reports/pieful/index.html","<div layout=\"coloumn\"><div id=\"container\" style=\"width: 800px; margin: 0 auto\"></div></div>");
$templateCache.put("app/attendance/detail/settings/states/create/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Crear un nuevo estado</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"create_state(item)\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Color</label> <input required=\"\" type=\"text\" name=\"color\" ng-model=\"item.color\"><div ng-messages=\"containerForm.color.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><input type=\"color\" ng-model=\"item.color\"></div><md-input-container class=\"md-block\" flex=\"\"><label>Orden</label> <input required=\"\" type=\"text\" name=\"order\" ng-model=\"item.order\"><div ng-messages=\"containerForm.order.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content>");
$templateCache.put("app/attendance/detail/settings/states/main/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Estados</h1></md-toolbar><md-content layout-padding=\"\"></md-content>");
$templateCache.put("app/attendance/detail/settings/states/update/index.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Actualizar un estado</h1></md-toolbar><md-content layout-padding=\"\"><form name=\"containerForm\" ng-submit=\"update_state(item)\"><md-input-container class=\"md-block\" flex=\"\"><label>Nombre</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"item.name\"><div ng-messages=\"containerForm.name.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Color</label> <input required=\"\" type=\"text\" name=\"color\" ng-model=\"item.color\"><div ng-messages=\"containerForm.color.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><input type=\"color\" ng-model=\"item.color\"></div><md-input-container class=\"md-block\" flex=\"\"><label>Orden</label> <input required=\"\" type=\"text\" name=\"order\" ng-model=\"item.order\"><div ng-messages=\"containerForm.order.$error\" role=\"alert\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\">Actualizar</md-button></div></form></md-content><md-toolbar class=\"md-warn\"><h1 class=\"md-toolbar-tools\">Eliminar</h1></md-toolbar><md-content layout-padding=\"\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"remove_state(item)\">Eliminar</md-button></div></md-content>");}]);